<template>
  <section class="dp-layout architecture-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick" :default-select-root="true" ref="child"></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="architecture-workspace">
        <header class="architecture-toolbar">
          <div class="architecture-context">
            <span class="architecture-title-icon" aria-hidden="true"><i class="el-icon-office-building"></i></span>
            <div>
              <h1>教学架构管理</h1>
              <p class="architecture-subtitle">维护校区、学段、年级与班级，并管理学年升班流转</p>
              <div class="architecture-breadcrumb">
                <span>当前节点</span>
                <i class="el-icon-arrow-right"></i>
                <strong>{{ CurrentDepartment.label || '请选择组织节点' }}</strong>
                <el-tag v-if="hasCurrentDepartment" size="mini" type="info" class="architecture-type-tag">
                  {{ departmentTypeText(CurrentDepartment.DeptOrgType) }}
                </el-tag>
              </div>
            </div>
          </div>
          <div class="architecture-actions">
            <el-button v-if="isSchoolNode" type="warning" plain icon="el-icon-upload2"
              @click="openTeachingStructureImport">导入班级</el-button>
            <el-button v-if="canCreateChild" type="primary" icon="el-icon-plus" @click="submitSubForm">新增{{
              nextDepartmentTypeLabel }}</el-button>
            <el-button :disabled="!hasCurrentDepartment" icon="el-icon-edit-outline"
              @click="openEditDepartment">编辑资料</el-button>
            <el-button v-if="syncVisible" type="success" plain icon="el-icon-refresh"
              @click="handleSync">同步钉钉</el-button>
            <el-button v-if="syncVisible" icon="el-icon-s-operation" @click="openTaskCenter">钉钉同步中心</el-button>
            <el-button :disabled="!canDeleteCurrent" type="danger" plain icon="el-icon-delete" :loading="addLoading"
              @click="handleDel">删除</el-button>
          </div>
        </header>

        <nav v-if="isSchoolNode && CurrentDepartment.SchId" class="school-action-strip" aria-label="学校级管理操作">
          <div class="school-action-intro">
            <span class="school-action-label">学年流转</span>
            <span class="school-action-desc">配置规则 → 预演核对 → 执行升班；班级节点可单独结转</span>
          </div>
          <div class="school-action-group school-action-group-upgrade">
            <button type="button" class="school-action-card" @click="openUpgradeRuleDialog">
              <span class="school-action-step">1</span>
              <span>
                <strong>升班配置</strong>
                <em>入学/毕业年级与清卡退床</em>
              </span>
            </button>
            <button type="button" class="school-action-card is-primary" @click="openAnnualUpgradeDialog">
              <span class="school-action-step">2</span>
              <span>
                <strong>一键升班</strong>
                <em>预演后确认执行</em>
              </span>
            </button>
            <button type="button" class="school-action-card" @click="openUpgradeBatchDialog">
              <span class="school-action-step">3</span>
              <span>
                <strong>结转日志</strong>
                <em>查看历史批次</em>
              </span>
            </button>
          </div>
        </nav>

        <div v-if="hasCurrentDepartment && !isLeafDepartment" class="architecture-list-panel">
          <div class="architecture-section-heading">
            <div>
              <h2>直属组织</h2>
              <span class="architecture-section-count">共 {{ currentDepartmentRows.length }} 个</span>
            </div>
            <div class="architecture-section-actions">
              <span class="architecture-section-path">{{ CurrentDepartment.fullLabel || CurrentDepartment.label
              }}</span>
              <el-button v-if="isClassList" type="danger" plain size="small" icon="el-icon-delete"
                :disabled="!selectedClassRows.length" :loading="addLoading" @click="batchDeleteSelectedClasses">
                批量删除<span v-if="selectedClassRows.length">（{{ selectedClassRows.length }}）</span>
              </el-button>
              <el-button v-if="isClassList" type="primary" plain size="small" icon="el-icon-refresh"
                :disabled="!selectedClassRows.length" @click="openBatchBigTypeDialog">
                批量更换类型<span v-if="selectedClassRows.length">（{{ selectedClassRows.length }}）</span>
              </el-button>
              <el-button v-if="isClassList" type="danger" plain size="small" icon="el-icon-sort"
                :disabled="!currentSchoolSchId || !currentDepartmentRows.length" @click="openGradeTransferDialog">
                年级结转
              </el-button>
            </div>
          </div>
          <div class="tbl-scroll-host">
          <el-table
            :key="'arch-tbl-' + structurePageSize + '-' + structurePageIndex"
            ref="architectureTable"
            :data="pagedDepartmentRows"
            stripe
            class="architecture-table"
            height="100%"
            row-key="value"
            empty-text="当前节点暂无下级组织"
            @selection-change="handleClassSelectionChange"
            @row-click="handleRowClick">
            <el-table-column v-if="isClassList" type="selection" width="52" align="center"
              :reserve-selection="true"></el-table-column>
            <el-table-column type="index" label="序号" width="72" align="center"
              :index="departmentRowIndex"></el-table-column>
            <el-table-column label="ID" width="140" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.value || scope.row.Id || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" min-width="220">
              <template slot-scope="scope">
                <button type="button" class="department-name-link" @click.stop="selectDepartmentRow(scope.row)">
                  {{ scope.row.label || scope.row.Name || '-' }}
                </button>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="120" align="center">
              <template slot-scope="scope">
                <el-tag size="small" :type="departmentTypeTag(scope.row.DeptOrgType)">
                  {{ departmentTypeText(scope.row.DeptOrgType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="详情" min-width="260">
              <template slot-scope="scope">
                <span class="department-detail-text">{{ departmentDetailText(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <div class="table-op-pair">
                  <el-button type="text" class="table-op-link" @click.stop="editDepartmentRow(scope.row)">编辑</el-button>
                  <el-button type="text" class="table-op-link table-op-link--danger" @click.stop="deleteDepartmentRow(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <el-col :span="24" class="toolbar architecture-pager">
            <el-pagination
              v-if="currentDepartmentRows.length > 0"
              background
              layout="total, sizes, prev, pager, next"
              :total="currentDepartmentRows.length"
              :current-page="structurePageIndex"
              :page-size="structurePageSize"
              :page-sizes="structurePageSizes"
              @current-change="onStructurePageChange"
              @size-change="onStructurePageSizeChange">
            </el-pagination>
          </el-col>
        </div>

        <div v-else-if="hasCurrentDepartment" class="department-leaf-detail">
          <div class="class-overview">
            <div class="class-overview-head">
              <div class="class-overview-title">
                <h2>{{ CurrentDepartment.label || CurrentDepartment.Name || '班级' }}</h2>
                <span class="class-overview-id">ID {{ CurrentDepartment.value }}</span>
              </div>
              <div class="class-overview-actions">
                <el-button type="danger" plain size="small" icon="el-icon-sort"
                  :disabled="!currentSchoolSchId" @click="openClassTransferDialog">班级结转</el-button>
                <el-button size="small" icon="el-icon-edit-outline" @click="openEditDepartment">编辑资料</el-button>
              </div>
            </div>
            <div class="class-overview-meta class-overview-meta--full">
              <div class="class-meta-item">
                <span>上级组织</span>
                <strong>{{ parentDepartmentName }}</strong>
              </div>
              <div class="class-meta-item">
                <span>通讯录</span>
                <strong>{{ Number(CurrentDepartment.BigType) === 1 ? '家校通讯录' : '内部通讯录' }}</strong>
              </div>
              <div class="class-meta-item">
                <span>班级排序</span>
                <strong>{{ CurrentDepartment.ClassOrderNo || '-' }}</strong>
              </div>
              <div class="class-meta-item">
                <span>部门 ID</span>
                <strong class="class-meta-id">{{ CurrentDepartment.value }}</strong>
              </div>
            </div>
          </div>

          <section class="class-extension-section" v-loading="classExtensionLoading">
            <div class="class-extension-heading">
              <div>
                <h3>班级扩展信息</h3>
                <span v-if="classExtensions.length" class="class-extension-count">{{ classExtensions.length }}
                  条记录</span>
              </div>
              <el-button v-if="!classExtensionLoading" type="primary" plain size="small" icon="el-icon-plus"
                @click="handleAddClassExtension">新增记录</el-button>
            </div>
            <template v-if="classExtensions.length && activeClassExtension">
              <el-tabs v-model="activeClassExtensionId" class="class-extension-tabs">
                <el-tab-pane v-for="(extension, index) in classExtensions" :key="extension.Id"
                  :name="String(extension.Id)">
                  <el-tooltip slot="label" :content="extension.Alias || `扩展信息 ${index + 1}`" placement="top"
                    :disabled="(extension.Alias || '').length <= 12">
                    <span class="class-extension-tab-label">
                      {{ classExtensionTabLabel(extension, index) }}
                      <i v-if="extension.IsDefault" class="el-icon-star-on class-extension-default-icon"></i>
                    </span>
                  </el-tooltip>
                </el-tab-pane>
              </el-tabs>

              <div class="class-extension-record">
                <div class="class-extension-record-head">
                  <div class="class-extension-record-title">
                    <strong>{{ activeClassExtension.Alias || '未设置别名' }}</strong>
                    <el-tag v-if="activeClassExtension.IsDefault" size="mini" type="success">默认</el-tag>
                    <el-tag size="mini" type="info">
                      {{ activeClassExtension.ShowAlias ? '展示别名' : '不展示别名' }}
                    </el-tag>
                  </div>
                  <div class="class-extension-record-actions">
                    <el-button type="primary" plain size="small" icon="el-icon-edit"
                      @click="handleEditClassExtension(activeClassExtension)">编辑记录</el-button>
                    <el-button type="danger" plain size="small" icon="el-icon-delete"
                      :loading="deletingClassExtensionId === activeClassExtension.Id"
                      @click="deleteCurrentClassExtension(activeClassExtension)">删除记录</el-button>
                  </div>
                </div>

                <div class="class-extension-content">
                  <section class="extension-field extension-field-wide">
                    <span>班名解释</span>
                    <p>{{ activeClassExtension.ClassNameDesc || '-' }}</p>
                  </section>
                  <section class="extension-field">
                    <span>班训</span>
                    <p>{{ activeClassExtension.ClassMotto || '-' }}</p>
                  </section>
                  <section class="extension-field">
                    <span>班主任寄语</span>
                    <p>{{ activeClassExtension.HeadTeacherMessage || '-' }}</p>
                  </section>
                  <section class="extension-field extension-field-wide">
                    <span>发展目标</span>
                    <p>{{ activeClassExtension.DevelopmentGoal || '-' }}</p>
                  </section>
                  <section class="extension-media">
                    <div class="extension-media-item">
                      <span>班级 Logo</span>
                      <oss-media-thumbs v-if="activeClassExtension.ClassLogo" :media="activeClassExtension.ClassLogo"
                        :max="1" thumb-width="68px" thumb-height="68px">
                      </oss-media-thumbs>
                      <div v-else class="extension-media-empty"><i class="el-icon-picture-outline"></i></div>
                    </div>
                    <div class="extension-media-item">
                      <span>班主任照片</span>
                      <oss-media-thumbs v-if="activeClassExtension.Logo" :media="activeClassExtension.Logo" :max="1"
                        thumb-width="68px" thumb-height="68px">
                      </oss-media-thumbs>
                      <div v-else class="extension-media-empty"><i class="el-icon-user"></i></div>
                    </div>
                  </section>
                </div>
              </div>
            </template>
            <el-empty v-else-if="!classExtensionLoading" description="暂无班级扩展信息"></el-empty>
          </section>
        </div>

        <div v-else-if="workspaceBootstrapping" class="architecture-workspace-loading" v-loading="true">
          <div class="architecture-workspace-loading__placeholder"></div>
        </div>

        <div v-else class="architecture-home">
          <div class="architecture-home__hero">
            <div class="architecture-home__badge"><i class="el-icon-s-grid"></i></div>
            <h2>从左侧选择组织节点开始</h2>
            <p>先选学校，再逐级进入校区 / 学段 / 年级 / 班级。学校节点可配置升班规则并执行年度升班。</p>
          </div>
          <div class="architecture-home__grid">
            <div class="architecture-home__card">
              <i class="el-icon-share"></i>
              <strong>组织树浏览</strong>
              <span>左侧树快速定位部门，右侧查看直属下级与详情</span>
            </div>
            <div class="architecture-home__card">
              <i class="el-icon-edit-outline"></i>
              <strong>资料维护</strong>
              <span>新增下级、编辑名称类型、调整年级班级排序</span>
            </div>
            <div class="architecture-home__card">
              <i class="el-icon-sort"></i>
              <strong>学年升班</strong>
              <span>配置入学毕业年级，预演核对后一键结转</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <el-dialog :title="departmentEditorTitle" :visible.sync="departmentEditorVisible" width="620px"
      custom-class="department-editor-dialog" :close-on-click-modal="false" @closed="handleDepartmentEditorClosed">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="部门名称" prop="Name">
          <el-input v-model="ruleForm.Name" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="Pid">
          <el-input v-if="departmentEditorMode === 'add'" :value="CurrentDepartment.label" disabled></el-input>
          <el-cascader v-else style="width: 100%" v-model="ruleForm.PidPath"
            :options="filteredDepartmentCascaderOptions" :props="cascaderProps" clearable placeholder="请选择上级部门"
            @change="onCascaderChange"></el-cascader>
        </el-form-item>
        <el-form-item label="部门类型" prop="DeptOrgType">
          <el-select v-model="ruleForm.DeptOrgType" style="width: 100%"
            :disabled="departmentEditorMode === 'edit' && editingDepartmentType === 'school'" placeholder="请选择部门类型">
            <el-option v-for="opt in departmentEditorTypeOptions" :key="opt.value" :label="opt.label"
              :value="opt.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.DeptOrgType === 'class'" label="通讯录类型" prop="BigType">
          <el-radio-group v-model="ruleForm.BigType">
            <el-radio :label="0">内部通讯录</el-radio>
            <el-radio :label="1">家校通讯录</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="ruleForm.DeptOrgType === 'period'" label="学段排序" prop="OrderSort">
          <el-input v-model.number="ruleForm.OrderSort" maxlength="6" placeholder="如小学 1、初中 2、高中 3"></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.DeptOrgType === 'grade'" label="年级排序" prop="GradeOrderNo">
          <el-input v-model.trim="ruleForm.GradeOrderNo" maxlength="6" placeholder="请输入年级顺序，如 1"></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.DeptOrgType === 'class'" label="班级排序" prop="ClassOrderNo">
          <el-input v-model.trim="ruleForm.ClassOrderNo" maxlength="6" placeholder="请输入班级顺序，如 1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="departmentEditorVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="submitForm">
          {{ departmentEditorMode === 'add' ? '确认新增' : '保存修改' }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量更换通讯录类型" :visible.sync="batchBigTypeVisible" width="520px" custom-class="batch-big-type-dialog"
      :close-on-click-modal="false">
      <el-form label-width="110px">
        <el-form-item label="已选班级">
          <strong>{{ selectedClassRows.length }} 个</strong>
        </el-form-item>
        <el-form-item label="目标类型">
          <el-radio-group v-model="batchBigType">
            <el-radio :label="0">内部通讯录</el-radio>
            <el-radio :label="1">家校通讯录</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchBigTypeVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchBigTypeSaving" @click="applyBatchBigType">批量应用</el-button>
      </div>
    </el-dialog>

    <!-- 钉钉部门导入与后台同步任务。dingTreeKey 重建树避免勾选残留。最后更新：2026-10-29 -->
    <el-dialog title="同步钉钉数据" :visible.sync="syncDingVisible" width="680px"
      custom-class="teaching-sync-dialog" :close-on-click-modal="false" destroy-on-close>
      <div class="teaching-sync-panel">
      <div class="teaching-sync-tabs">
        <button type="button" :class="{ 'is-active': syncMode === 'department' }"
          @click="changeSyncMode('department')">
          <i class="el-icon-office-building"></i>
          <span><strong>导入钉钉组织</strong><small>勾选分支后提交同步中心任务</small></span>
        </button>
        <button type="button" :class="{ 'is-active': syncMode === 'task' }"
          @click="changeSyncMode('task')">
          <i class="el-icon-refresh"></i>
          <span><strong>后台同步任务</strong><small>更新学生和教师数据</small></span>
        </button>
      </div>

      <div v-show="syncMode === 'department'" class="teaching-sync-tab-pane">
        <div class="teaching-sync-target">
          <span><i class="el-icon-location-outline"></i> 挂载到本地</span>
          <strong>{{ (CurrentDepartment && (CurrentDepartment.label || CurrentDepartment.Name)) || '当前学校' }}</strong>
          <el-tag size="mini" type="primary" effect="plain">家校通讯录</el-tag>
        </div>

        <section class="teaching-sync-tree">
          <header>
            <div>
              <strong>选择钉钉子部门</strong>
              <span>可勾选一个或多个分支</span>
              <span v-if="dingTreeCacheHint" class="ding-tree-cache-hint">{{ dingTreeCacheHint }}</span>
            </div>
            <div class="ding-tree-header-actions">
              <el-tooltip content="跳过缓存，从钉钉重新拉取最新组织" placement="top">
                <el-button type="text" icon="el-icon-refresh" :disabled="dingTreeLoading" :loading="dingTreeLoading"
                  @click="fetchDingTree(true)">刷新组织</el-button>
              </el-tooltip>
            </div>
          </header>
          <div class="teaching-sync-tree__body" v-loading="dingTreeLoading"
            element-loading-text="正在拉取钉钉家校组织，请稍候...">
            <el-tree :key="'ding-tree-' + dingTreeKey" :data="dingTreeData"
              :props="{ label: 'DeptName', children: 'Children' }" node-key="DeptId"
              ref="dingTree" show-checkbox check-on-click-node :expand-on-click-node="false"
              class="custom-ding-tree">
            </el-tree>
            <div v-if="!dingTreeLoading && !dingTreeData.length" class="teaching-sync-tree__empty">
              <i class="el-icon-receiving"></i>
              <span>暂无可选的钉钉部门</span>
            </div>
          </div>
        </section>

        <div class="teaching-sync-notice">
          <i class="el-icon-info"></i>
          <p>所选分支及其上级结构将一并同步到当前本地部门，任务会进入钉钉同步中心。若同一钉钉企业已拆成多所本地学校，每个钉钉校区只能归属一所学校；已被其他学校占用的分支会明确提示。</p>
        </div>
      </div>

      <div v-show="syncMode === 'task'" class="teaching-sync-tab-pane">
        <div class="teaching-sync-target teaching-sync-resource-bar">
          <span><i class="el-icon-s-operation"></i> 选择同步内容</span>
          <el-radio-group v-model="syncResourceType" class="teaching-sync-options teaching-sync-options--inline">
            <el-radio-button label="Student"><i class="el-icon-user"></i>学生</el-radio-button>
            <el-radio-button label="Teacher"><i class="el-icon-s-custom"></i>教师</el-radio-button>
          </el-radio-group>
        </div>

        <section class="teaching-sync-scope-tree">
          <header>
            <div>
              <strong>选择同步范围</strong>
              <span>勾选本地家校节点；学生仅同步班级，教师按班级同步任教关系</span>
            </div>
          </header>
          <div class="teaching-sync-scope-tree__body">
            <el-tree
              v-if="syncScopeTreeNodes.length"
              ref="syncScopeTree"
              :key="'sync-scope-' + syncScopeTreeKey"
              :data="syncScopeTreeNodes"
              :props="{ label: 'label', children: 'children' }"
              node-key="value"
              show-checkbox
              check-on-click-node
              :expand-on-click-node="false"
              :default-expanded-keys="syncScopeTreeExpandedKeys"
              class="custom-ding-tree"
            />
            <div v-else class="teaching-sync-tree__empty">
              <i class="el-icon-receiving"></i>
              <span>暂无可选的家校组织节点</span>
            </div>
          </div>
        </section>

        <div class="teaching-sync-notice">
          <i class="el-icon-info"></i>
          <div class="teaching-sync-notice__body">
            <p>组织请到「导入钉钉组织」勾选分支；此处仅同步家校人员（学生与任教教师）</p>
            <p v-if="syncResourceType === 'Teacher'" class="teaching-sync-notice__sub">
              建议先到「内部通讯录」同步教师，以补全行政部门归属。若先同步任教，系统会自动创建教师主档，教师管理可能暂显示「未同步内部部门」，后续补同步即可。同步任教时会按任教班级自动补全「关联校区」（只增不删，已有手工关联保留）。
            </p>
          </div>
        </div>
      </div>
      </div>

      <div slot="footer" class="teaching-sync-footer">
        <span class="teaching-sync-footer__hint">
          <i class="el-icon-info"></i>
          提交后可在钉钉同步中心查看进度
        </span>
        <div class="teaching-sync-footer__actions">
          <el-button type="text" icon="el-icon-s-operation"
            @click="openTaskCenterFromSync">打开同步中心</el-button>
          <el-button @click="syncDingVisible = false">取消</el-button>
          <el-button v-if="syncMode === 'department'" type="primary" icon="el-icon-upload2"
            @click="confirmSyncDing" :loading="dingSyncing"
            :disabled="dingTreeLoading">提交导入任务</el-button>
          <el-button v-else type="primary" icon="el-icon-upload2" @click="submitTeachingSyncTask"
            :loading="dingSyncing">提交任务</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="`${upgradeRuleConfig.SchoolName || '学校'}升班规则`" :visible.sync="upgradeRuleVisible" width="980px"
      custom-class="upgrade-rule-dialog dept-pro-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="upgrade-rule-body">
        <p class="upgrade-inline-tip">
          <i class="el-icon-info"></i>
          入学=年级序号最小，毕业=序号最大；各学段单独配置。班级名需含年级简称（如「三年级(1)班」）。
        </p>

        <section class="upgrade-panel-card">
          <header class="upgrade-panel-card__head">
            <div>
              <h3>升班范围</h3>
              <span>按学段设定入学与毕业年级</span>
            </div>
          </header>
          <div v-loading="upgradeRuleLoading" class="upgrade-rule-cards">
            <div v-if="!(upgradeRuleConfig.Rules || []).length" class="upgrade-empty-hint">
              暂无可配置的升班范围，请先完善校区 / 学段 / 年级结构。
            </div>
            <article v-for="row in upgradeRuleConfig.Rules" :key="row.ScopeDepartmentId || row.PeriodDepartmentId"
              class="upgrade-rule-card" :class="{ 'is-disabled': !row.Enabled }">
              <div class="upgrade-rule-card__top">
                <div class="upgrade-rule-card__title">
                  <strong>{{ row.ScopeName || row.PeriodName || '-' }}</strong>
                  <el-tag size="mini" type="info" effect="plain">{{ row.CampusName || '—' }} · {{ upgradeScopeTypeText(row.ScopeType) }}</el-tag>
                </div>
                <div class="upgrade-rule-card__switch">
                  <el-switch v-model="row.Enabled" @change="onUpgradeRuleEnabledChange(row)"></el-switch>
                  <el-tag size="mini" :type="upgradeRuleStatusType(row)" class="upgrade-status-tag"
                    :title="row.ConfigMessage || upgradeStatusText(row.ConfigStatus)">
                    {{ row.ConfigMessage || upgradeStatusText(row.ConfigStatus) }}
                  </el-tag>
                </div>
              </div>
              <p class="upgrade-rule-card__path" :title="formatGradeSequence(row)">{{ formatGradeSequence(row) }}</p>
              <div class="upgrade-path-editors">
                <div class="upgrade-path-field" :class="{ 'is-invalid': !!row.InvalidEntryGradeDepartmentId }">
                  <label>入学年级</label>
                  <el-select v-model="row.EntryGradeDepartmentId" :disabled="!row.Enabled" size="small"
                    placeholder="入学" clearable @change="clearInvalidUpgradeGrade(row, 'entry')">
                    <el-option v-for="grade in row.Grades" :key="'e-' + grade.DepartmentId" :label="grade.Name"
                      :value="grade.DepartmentId"></el-option>
                  </el-select>
                  <p v-if="row.InvalidEntryGradeDepartmentId" class="upgrade-path-field__error">
                    原配置已失效（{{ row.InvalidEntryGradeDepartmentId }}）
                  </p>
                </div>
                <i class="el-icon-right upgrade-path-arrow"></i>
                <div class="upgrade-path-field" :class="{ 'is-invalid': !!row.InvalidGraduateGradeDepartmentId }">
                  <label>毕业年级</label>
                  <el-select v-model="row.GraduateGradeDepartmentId" :disabled="!row.Enabled" size="small"
                    placeholder="毕业" clearable @change="clearInvalidUpgradeGrade(row, 'graduate')">
                    <el-option v-for="grade in row.Grades" :key="'g-' + grade.DepartmentId" :label="grade.Name"
                      :value="grade.DepartmentId"></el-option>
                  </el-select>
                  <p v-if="row.InvalidGraduateGradeDepartmentId" class="upgrade-path-field__error">
                    原配置已失效（{{ row.InvalidGraduateGradeDepartmentId }}）
                  </p>
                </div>
              </div>
            </article>
          </div>
        </section>

        <section class="upgrade-panel-card" v-loading="unbindOptionsLoading">
          <header class="upgrade-panel-card__head">
            <div>
              <h3>清卡 / 退床</h3>
              <span>学校级开关，办理异动时是否处理活卡与床位</span>
            </div>
          </header>
          <div class="unbind-scene-grid">
            <div class="unbind-scene-card">
              <strong>毕业</strong>
              <label><el-checkbox v-model="unbindOptions.GraduateUnbindCard"></el-checkbox> 清卡</label>
              <label><el-checkbox v-model="unbindOptions.GraduateReleaseBed"></el-checkbox> 退床</label>
            </div>
            <div class="unbind-scene-card">
              <strong>转学 / 退学</strong>
              <label><el-checkbox v-model="unbindOptions.TransferLeaveUnbindCard"></el-checkbox> 清卡</label>
              <label><el-checkbox v-model="unbindOptions.TransferLeaveReleaseBed"></el-checkbox> 退床</label>
            </div>
            <div class="unbind-scene-card">
              <strong>休学</strong>
              <label><el-checkbox v-model="unbindOptions.SuspendUnbindCard"></el-checkbox> 清卡</label>
              <label><el-checkbox v-model="unbindOptions.SuspendReleaseBed"></el-checkbox> 退床</label>
            </div>
          </div>
        </section>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upgradeRuleVisible = false">取消</el-button>
        <el-button type="primary" icon="el-icon-check" :loading="upgradeRuleSaving"
          :disabled="upgradeRuleLoading || !upgradeRuleConfig.Rules.length" @click="saveUpgradeRules">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="`${annualSchoolName || '学校'}年度升班预演`" :visible.sync="annualUpgradeVisible" width="1110px"
      custom-class="annual-upgrade-dialog dept-pro-dialog" :close-on-click-modal="false"
      :close-on-press-escape="!annualExecuting">
      <div v-loading="annualPreviewLoading" class="annual-preview-body">
        <div class="upgrade-ops-tip">
          <div class="upgrade-ops-tip__title">
            <i class="el-icon-warning"></i>
            <strong>班级结转操作提示</strong>
          </div>
          <p>将对启用规则范围内的班级执行结转升级或毕业归档：毕业班归档删除、学生进入毕业档案；普通班名称按年级递进。请核对下方汇总与明细后再确认。小升初/初升高请到毕业档案做「升学导入」。</p>
        </div>
        <template v-if="annualPreview">
          <!-- 顶部汇总：保持不变 -->
          <div class="annual-metric-groups">
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">影响</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item">
                  <span>影响班级</span><strong>{{ annualPreview.AffectedClassCount }}</strong>
                </div>
                <div class="annual-summary-item">
                  <span>在读学生</span><strong>{{ annualPreview.AffectedStudentCount }}</strong>
                </div>
              </div>
            </div>
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">毕业</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item is-warning">
                  <span>毕业班级</span><strong>{{ annualPreview.GraduatedClassCount }}</strong>
                </div>
                <div class="annual-summary-item is-warning">
                  <span>毕业学生</span><strong>{{ annualPreview.GraduatedStudentCount }}</strong>
                </div>
              </div>
            </div>
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">解绑</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item">
                  <span>解绑卡片</span><strong>{{ annualPreview.CardCount }}</strong>
                </div>
                <div class="annual-summary-item">
                  <span>释放床位</span><strong>{{ annualPreview.DormBedCount }}</strong>
                </div>
              </div>
            </div>
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">余额</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item" :class="{ 'is-warning': annualPreview.BalanceStudentCount > 0 }">
                  <span>有余额学生</span><strong>{{ annualPreview.BalanceStudentCount || 0 }}</strong>
                </div>
                <div class="annual-summary-item" :class="{ 'is-warning': annualPreview.BalanceStudentCount > 0 }">
                  <span>余额合计</span><strong>{{ formatMoney(annualPreview.BalanceTotal) }}</strong>
                </div>
              </div>
            </div>
          </div>

          <div v-if="(annualPreview.Errors || []).length || (annualPreview.Warnings || []).length"
            class="upgrade-msg-list">
            <div v-for="(error, index) in annualPreview.Errors" :key="`annual-error-${index}`" class="upgrade-msg is-error">
              <i class="el-icon-error"></i><span>{{ error }}</span>
            </div>
            <div v-for="(warning, index) in annualPreview.Warnings" :key="`annual-warning-${index}`"
              class="upgrade-msg is-warning">
              <i class="el-icon-warning"></i><span>{{ warning }}</span>
            </div>
          </div>
          <el-button v-if="annualPreview.BalanceStudentCount > 0" type="text" icon="el-icon-wallet"
            class="balance-student-link" @click="openBalanceStudentDialog(annualPreview)">
            查看有余额学生名单（{{ annualPreview.BalanceStudentCount }} 人）
          </el-button>

          <!-- 两个明细分 Tab -->
          <el-tabs v-model="annualPreviewTab" class="upgrade-detail-tabs">
            <el-tab-pane name="summary">
              <span slot="label">拟升级结转班级明细（{{ (annualPreview.Classes || []).length }}）</span>
              <el-table :data="annualPreview.Classes || []" border stripe max-height="360"
                empty-text="没有可升班的班级，请先启用升班规则" class="annual-preview-table annual-preview-table--summary">
                <el-table-column label="原班级名称" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.SourceClassName }}</template>
                </el-table-column>
                <el-table-column label="是否毕业班" width="120" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="isGraduateAction(scope.row.ActionType) ? 'danger' : 'info'">
                      {{ isGraduateAction(scope.row.ActionType) ? '毕业班级' : '普通班级' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="升级/结转后预期结果" min-width="220">
                  <template slot-scope="scope">
                    <span v-if="isGraduateAction(scope.row.ActionType)" class="class-transfer-result is-archive">
                      归档删除（学生毕业注销）
                    </span>
                    <span v-else class="class-transfer-result is-upgrade">
                      ↑ 升级为 {{ scope.row.TargetClassName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="学生" width="80" align="center">
                  <template slot-scope="scope">
                    <button
                      v-if="(scope.row.ActiveStudentCount || 0) > 0"
                      type="button"
                      class="preview-student-link"
                      @click="openPreviewStudentDialog(scope.row)">
                      {{ scope.row.ActiveStudentCount }}
                    </button>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane name="detail">
              <span slot="label">结转明细</span>
              <p class="upgrade-detail-tabs__hint">校区、升班范围与卡片/床位影响</p>
              <el-table :data="annualPreview.Classes || []" border stripe max-height="330"
                empty-text="暂无明细" class="annual-preview-table">
                <el-table-column prop="CampusName" label="校区" width="110" align="center"
                  show-overflow-tooltip></el-table-column>
                <el-table-column label="升班范围" width="110" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.ScopeName || scope.row.PeriodName }}
                  </template>
                </el-table-column>
                <el-table-column label="处理方式" width="120" align="center">
                  <template slot-scope="scope">
                    <el-tag size="small" class="annual-action-tag"
                      :type="isGraduateAction(scope.row.ActionType) ? 'warning' : 'success'">
                      {{ annualActionText(scope.row.ActionType) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="原班 → 目标" min-width="220">
                  <template slot-scope="scope">
                    <div class="annual-transfer-path">
                      <div>
                        <strong>{{ scope.row.SourceClassName }}</strong>
                        <em>{{ scope.row.SourceGradeName }}</em>
                      </div>
                      <i class="el-icon-right"></i>
                      <div v-if="isGraduateAction(scope.row.ActionType)">
                        <strong class="is-archive">归档删除</strong>
                        <em>学生毕业注销</em>
                      </div>
                      <div v-else>
                        <strong>{{ scope.row.TargetClassName }}</strong>
                        <em>{{ scope.row.TargetGradeName }}</em>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="学生" width="80" align="center">
                  <template slot-scope="scope">
                    <button
                      v-if="(scope.row.ActiveStudentCount || 0) > 0"
                      type="button"
                      class="preview-student-link"
                      @click="openPreviewStudentDialog(scope.row)">
                      {{ scope.row.ActiveStudentCount }}
                    </button>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CardCount" label="卡片" width="72" align="center"></el-table-column>
                <el-table-column prop="DormBedCount" label="床位" width="72" align="center"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button :disabled="annualExecuting" @click="annualUpgradeVisible = false">我再想想</el-button>
        <el-button type="danger" icon="el-icon-check" :loading="annualExecuting"
          :disabled="!annualPreview || !annualPreview.CanExecute || annualPreviewLoading"
          @click="confirmAnnualUpgrade">确认执行结转</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="`${outboxSchoolName || '学校'}升班结转日志`" :visible.sync="upgradeBatchVisible" width="980px"
      custom-class="upgrade-outbox-dialog dept-pro-dialog" :close-on-click-modal="false">
      <div class="upgrade-outbox-toolbar">
        <el-radio-group v-model="upgradeBatchOpFilter" size="small" @change="onUpgradeBatchFilterChange">
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="1">全校升班</el-radio-button>
          <el-radio-button :label="2">单班结转</el-radio-button>
          <el-radio-button :label="5">年级结转</el-radio-button>
        </el-radio-group>
        <el-button size="small" icon="el-icon-refresh" :loading="upgradeBatchLoading"
          @click="loadUpgradeBatchPage">刷新</el-button>
      </div>
      <el-table :data="upgradeBatchItems" v-loading="upgradeBatchLoading" border stripe height="420"
        empty-text="暂无升班结转日志。执行一键升班或班级结转后将在此显示。" class="upgrade-outbox-table">
        <el-table-column label="批次号" width="148" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="batch-id">{{ scope.row.Id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="upgradeBatchTypeTag(scope.row)" effect="plain">
              {{ upgradeBatchTypeLabel(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="学年 / 时间" min-width="220">
          <template slot-scope="scope">
            <div class="batch-cell-main">{{ formatBatchYear(scope.row) }}</div>
            <div class="batch-cell-sub">{{ formatBatchTime(scope.row, null, scope.row.CreateTime) }}</div>
            <div v-if="batchReasonExtra(scope.row)" class="batch-cell-sub" :title="scope.row.Reason">
              {{ batchReasonExtra(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="88" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="isBatchSucceeded(scope.row) ? 'success' : 'info'">
              {{ isBatchSucceeded(scope.row) ? '已成功' : '执行中' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="影响" width="150">
          <template slot-scope="scope">
            <div class="batch-impact">
              <div class="batch-impact__line">
                班级 {{ scope.row.AffectedClassCount || 0 }}
                <i>·</i>
                学生 {{ scope.row.AffectedStudentCount || 0 }}
              </div>
              <div class="batch-impact__line batch-impact__line--sub">
                毕业 {{ scope.row.GraduatedStudentCount || 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button type="text" class="table-op-link" @click="showBatchDetail(scope.row)">明细</el-button>
              <el-button type="text" class="table-op-link table-op-link--danger" :loading="deletingBatchId === scope.row.Id"
                @click="deleteUpgradeBatch(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="upgrade-outbox-pagination">
        <el-pagination background layout="total, sizes, prev, pager, next"
          :total="upgradeBatchTotal" :current-page="upgradeBatchPageIndex" :page-size="upgradeBatchPageSize"
          :page-sizes="[10, 20, 50, 100]" @current-change="handleBatchPageChange" @size-change="handleBatchSizeChange">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upgradeBatchVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="`班级结转预测与结果预览 - ${classTransferClassName || '班级'}`"
      :visible.sync="classTransferVisible" width="820px" custom-class="class-transfer-dialog dept-pro-dialog"
      :close-on-click-modal="false" :close-on-press-escape="!classTransferExecuting">
      <div v-loading="classTransferLoading" class="class-transfer-body">
        <div class="upgrade-ops-tip">
          <div class="upgrade-ops-tip__title">
            <i class="el-icon-warning"></i>
            <strong>班级结转操作提示</strong>
          </div>
          <p>将对当前班级执行结转升级或毕业归档。毕业班归档删除、学生进入毕业档案；普通班名称按年级规则递进（如高一→高二），年级与兄弟班不变。单班结转不占用全校同学年升班锁。</p>
        </div>
        <template v-if="classTransferPreview">
          <div v-if="(classTransferPreview.Errors || []).length || (classTransferPreview.Warnings || []).length"
            class="upgrade-msg-list">
            <div v-for="(error, index) in classTransferPreview.Errors" :key="`ct-error-${index}`" class="upgrade-msg is-error">
              <i class="el-icon-error"></i><span>{{ error }}</span>
            </div>
            <div v-for="(warning, index) in classTransferPreview.Warnings" :key="`ct-warning-${index}`"
              class="upgrade-msg is-warning">
              <i class="el-icon-warning"></i><span>{{ warning }}</span>
            </div>
          </div>
          <el-button v-if="classTransferPreview.BalanceStudentCount > 0" type="text" icon="el-icon-wallet"
            class="balance-student-link" @click="openBalanceStudentDialog(classTransferPreview)">
            查看有余额学生名单（{{ classTransferPreview.BalanceStudentCount }} 人）
          </el-button>

          <!-- 两个明细分 Tab -->
          <el-tabs v-model="classTransferTab" class="upgrade-detail-tabs">
            <el-tab-pane name="summary">
              <span slot="label">拟升级结转班级明细（{{ (classTransferPreview.Classes || []).length }}）</span>
              <el-table :data="classTransferPreview.Classes || []" border stripe empty-text="无可结转班级">
                <el-table-column label="原班级名称" min-width="140">
                  <template slot-scope="scope">{{ scope.row.SourceClassName }}</template>
                </el-table-column>
                <el-table-column label="是否毕业班" width="120" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="isGraduateAction(scope.row.ActionType) ? 'danger' : 'info'">
                      {{ isGraduateAction(scope.row.ActionType) ? '毕业班级' : '普通班级' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="升级/结转后预期结果" min-width="200">
                  <template slot-scope="scope">
                    <span v-if="isGraduateAction(scope.row.ActionType)" class="class-transfer-result is-archive">
                      归档删除（学生毕业注销）
                    </span>
                    <span v-else class="class-transfer-result is-upgrade">
                      ↑ 升级为 {{ scope.row.TargetClassName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="学生" width="80" align="center">
                  <template slot-scope="scope">
                    <button
                      v-if="(scope.row.ActiveStudentCount || 0) > 0"
                      type="button"
                      class="preview-student-link"
                      @click="openPreviewStudentDialog(scope.row)">
                      {{ scope.row.ActiveStudentCount }}
                    </button>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane name="detail">
              <span slot="label">结转明细</span>
              <p class="upgrade-detail-tabs__hint">年级路径与解绑影响</p>
              <el-table :data="classTransferPreview.Classes || []" border stripe empty-text="暂无明细">
                <el-table-column label="原年级 / 班级" min-width="150">
                  <template slot-scope="scope">
                    <div class="annual-transfer-path">
                      <div>
                        <strong>{{ scope.row.SourceClassName }}</strong>
                        <em>{{ scope.row.SourceGradeName }}</em>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="目标年级 / 班级" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="isGraduateAction(scope.row.ActionType)" class="annual-transfer-path">
                      <div>
                        <strong class="is-archive">归档删除</strong>
                        <em>学生毕业注销</em>
                      </div>
                    </div>
                    <div v-else class="annual-transfer-path">
                      <div>
                        <strong>{{ scope.row.TargetClassName }}</strong>
                        <em>{{ scope.row.TargetGradeName }}</em>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="升班范围" min-width="110" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.ScopeName || scope.row.PeriodName || '—' }}</template>
                </el-table-column>
                <el-table-column label="学生" width="80" align="center">
                  <template slot-scope="scope">
                    <button
                      v-if="(scope.row.ActiveStudentCount || 0) > 0"
                      type="button"
                      class="preview-student-link"
                      @click="openPreviewStudentDialog(scope.row)">
                      {{ scope.row.ActiveStudentCount }}
                    </button>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CardCount" label="卡片" width="72" align="center"></el-table-column>
                <el-table-column prop="DormBedCount" label="床位" width="72" align="center"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="classTransferExecuting" @click="classTransferVisible = false">我再想想</el-button>
        <el-button type="danger" icon="el-icon-check" :loading="classTransferExecuting"
          :disabled="!classTransferPreview || !classTransferPreview.CanExecute || classTransferLoading"
          @click="confirmClassTransfer">确认执行结转</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="`年级结转预测与结果预览 - ${gradeTransferGradeName || '年级'}`"
      :visible.sync="gradeTransferVisible" width="900px" custom-class="grade-transfer-dialog dept-pro-dialog"
      :close-on-click-modal="false" :close-on-press-escape="!gradeTransferExecuting">
      <div v-loading="gradeTransferLoading" class="annual-preview-body grade-transfer-body">
        <div class="upgrade-ops-tip">
          <div class="upgrade-ops-tip__title">
            <i class="el-icon-warning"></i>
            <strong>年级结转操作提示</strong>
          </div>
          <p>将对当前年级下全部 {{ (gradeTransferPreview && gradeTransferPreview.Classes || []).length || currentDepartmentRows.length }} 个班级执行结转升级或毕业归档。普通年级只改班名、年级节点不变；毕业年级全班归档并删除年级节点。年级结转不占用全校同学年升班锁。</p>
        </div>
        <template v-if="gradeTransferPreview">
          <div class="annual-metric-groups">
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">影响</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item">
                  <span>影响班级</span><strong>{{ gradeTransferPreview.AffectedClassCount }}</strong>
                </div>
                <div class="annual-summary-item">
                  <span>在读学生</span><strong>{{ gradeTransferPreview.AffectedStudentCount }}</strong>
                </div>
              </div>
            </div>
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">毕业</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item is-warning">
                  <span>毕业班级</span><strong>{{ gradeTransferPreview.GraduatedClassCount }}</strong>
                </div>
                <div class="annual-summary-item is-warning">
                  <span>毕业学生</span><strong>{{ gradeTransferPreview.GraduatedStudentCount }}</strong>
                </div>
              </div>
            </div>
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">解绑</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item">
                  <span>解绑卡片</span><strong>{{ gradeTransferPreview.CardCount }}</strong>
                </div>
                <div class="annual-summary-item">
                  <span>释放床位</span><strong>{{ gradeTransferPreview.DormBedCount }}</strong>
                </div>
              </div>
            </div>
            <div class="annual-metric-group">
              <span class="annual-metric-group__label">余额</span>
              <div class="annual-summary-grid annual-summary-grid--compact">
                <div class="annual-summary-item" :class="{ 'is-warning': gradeTransferPreview.BalanceStudentCount > 0 }">
                  <span>有余额学生</span><strong>{{ gradeTransferPreview.BalanceStudentCount || 0 }}</strong>
                </div>
                <div class="annual-summary-item" :class="{ 'is-warning': gradeTransferPreview.BalanceStudentCount > 0 }">
                  <span>余额合计</span><strong>{{ formatMoney(gradeTransferPreview.BalanceTotal) }}</strong>
                </div>
              </div>
            </div>
          </div>

          <div v-if="(gradeTransferPreview.Errors || []).length || (gradeTransferPreview.Warnings || []).length"
            class="upgrade-msg-list">
            <div v-for="(error, index) in gradeTransferPreview.Errors" :key="`gt-error-${index}`" class="upgrade-msg is-error">
              <i class="el-icon-error"></i><span>{{ error }}</span>
            </div>
            <div v-for="(warning, index) in gradeTransferPreview.Warnings" :key="`gt-warning-${index}`"
              class="upgrade-msg is-warning">
              <i class="el-icon-warning"></i><span>{{ warning }}</span>
            </div>
          </div>
          <el-button v-if="gradeTransferPreview.BalanceStudentCount > 0" type="text" icon="el-icon-wallet"
            class="balance-student-link" @click="openBalanceStudentDialog(gradeTransferPreview)">
            查看有余额学生名单（{{ gradeTransferPreview.BalanceStudentCount }} 人）
          </el-button>

          <el-tabs v-model="gradeTransferTab" class="upgrade-detail-tabs">
            <el-tab-pane name="summary">
              <span slot="label">拟升级结转班级明细（{{ (gradeTransferPreview.Classes || []).length }}）</span>
              <el-table :data="gradeTransferPreview.Classes || []" border stripe max-height="360" empty-text="无可结转班级">
                <el-table-column label="原班级名称" min-width="140">
                  <template slot-scope="scope">{{ scope.row.SourceClassName }}</template>
                </el-table-column>
                <el-table-column label="是否毕业班" width="120" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="isGraduateAction(scope.row.ActionType) ? 'danger' : 'info'">
                      {{ isGraduateAction(scope.row.ActionType) ? '毕业班级' : '普通班级' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="升级/结转后预期结果" min-width="200">
                  <template slot-scope="scope">
                    <span v-if="isGraduateAction(scope.row.ActionType)" class="class-transfer-result is-archive">
                      归档删除（学生毕业注销）
                    </span>
                    <span v-else class="class-transfer-result is-upgrade">
                      ↑ 升级为 {{ scope.row.TargetClassName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="学生" width="80" align="center">
                  <template slot-scope="scope">
                    <button
                      v-if="(scope.row.ActiveStudentCount || 0) > 0"
                      type="button"
                      class="preview-student-link"
                      @click="openPreviewStudentDialog(scope.row)">
                      {{ scope.row.ActiveStudentCount }}
                    </button>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane name="detail">
              <span slot="label">结转明细</span>
              <p class="upgrade-detail-tabs__hint">年级路径与解绑影响</p>
              <el-table :data="gradeTransferPreview.Classes || []" border stripe max-height="360" empty-text="暂无明细">
                <el-table-column label="原年级 / 班级" min-width="150">
                  <template slot-scope="scope">
                    <div class="annual-transfer-path">
                      <div>
                        <strong>{{ scope.row.SourceClassName }}</strong>
                        <em>{{ scope.row.SourceGradeName }}</em>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="目标年级 / 班级" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="isGraduateAction(scope.row.ActionType)" class="annual-transfer-path">
                      <div>
                        <strong class="is-archive">归档删除</strong>
                        <em>学生毕业注销</em>
                      </div>
                    </div>
                    <div v-else class="annual-transfer-path">
                      <div>
                        <strong>{{ scope.row.TargetClassName }}</strong>
                        <em>{{ scope.row.TargetGradeName }}</em>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="升班范围" min-width="110" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.ScopeName || scope.row.PeriodName || '—' }}</template>
                </el-table-column>
                <el-table-column label="学生" width="80" align="center">
                  <template slot-scope="scope">
                    <button
                      v-if="(scope.row.ActiveStudentCount || 0) > 0"
                      type="button"
                      class="preview-student-link"
                      @click="openPreviewStudentDialog(scope.row)">
                      {{ scope.row.ActiveStudentCount }}
                    </button>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CardCount" label="卡片" width="72" align="center"></el-table-column>
                <el-table-column prop="DormBedCount" label="床位" width="72" align="center"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="gradeTransferExecuting" @click="gradeTransferVisible = false">我再想想</el-button>
        <el-button type="danger" icon="el-icon-check" :loading="gradeTransferExecuting"
          :disabled="!gradeTransferPreview || !gradeTransferPreview.CanExecute || gradeTransferLoading"
          @click="confirmGradeTransfer">确认执行结转</el-button>
      </div>
    </el-dialog>

    <!-- 升班明细 Dialog -->
    <el-dialog title="升班结转明细" :visible.sync="batchDetailVisible" width="860px" append-to-body
      custom-class="upgrade-batch-detail-dialog dept-pro-dialog" :close-on-click-modal="false">
      <div class="upgrade-batch-detail-toolbar">
        <el-input v-model="batchDetailKeyword" size="small" clearable prefix-icon="el-icon-search"
          placeholder="搜索原班级 / 目标班级" class="upgrade-batch-detail-search"></el-input>
      </div>
      <el-table :data="filteredBatchDetailItems" v-loading="batchDetailLoading" border stripe height="360"
        :empty-text="batchDetailKeyword ? '没有匹配的明细' : '暂无明细数据'" class="upgrade-batch-detail-table">
        <el-table-column prop="SourceDepartmentName" label="原班级/年级" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="处理方式" width="130" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.ActionType === 2 ? 'warning' : 'success'">
              {{ scope.row.ActionType === 2 ? '毕业归档' : '升至下一年级' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="TargetDepartmentName" label="目标班级/年级" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="StudentCount" label="影响人数" width="100" align="right"></el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" :disabled="!(scope.row.StudentCount > 0)"
              @click="showBatchStudentDialog(scope.row)">学生</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="batchStudentDialogTitle" :visible.sync="batchStudentVisible" width="720px" append-to-body
      custom-class="upgrade-batch-student-dialog dept-pro-dialog" :close-on-click-modal="false">
      <div class="upgrade-batch-student-toolbar">
        <el-input v-model="batchStudentKeyword" size="small" clearable prefix-icon="el-icon-search"
          placeholder="搜索姓名 / 卡号 / 学生ID / 去向" class="upgrade-batch-student-search"
          @input="onBatchStudentKeywordInput" @clear="onBatchStudentKeywordInput"></el-input>
      </div>
      <el-table :data="batchStudentItems" v-loading="batchStudentLoading" border stripe height="360"
        :empty-text="batchStudentKeyword ? '没有匹配的学生' : '暂无学生快照（历史批次可能未记录）'"
        class="upgrade-batch-student-table">
        <el-table-column prop="StuName" label="姓名" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="CardNumber" label="卡号" min-width="120">
          <template slot-scope="scope">{{ scope.row.CardNumber || '—' }}</template>
        </el-table-column>
        <el-table-column prop="StudentId" label="学生ID" min-width="140"></el-table-column>
        <el-table-column label="去向" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.TargetDepartmentName || '—' }}</template>
        </el-table-column>
      </el-table>
      <div class="batch-student-pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page.sync="batchStudentPageIndex"
          :page-size="batchStudentPageSize" :total="batchStudentTotal" @current-change="loadBatchStudents">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchStudentVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="previewStudentDialogTitle" :visible.sync="previewStudentVisible" width="720px" append-to-body
      custom-class="upgrade-preview-student-dialog" :close-on-click-modal="false">
      <p class="upgrade-detail-tabs__hint" v-if="previewStudentTargetText">预计去向：{{ previewStudentTargetText }}</p>
      <el-table :data="pagedPreviewStudents" border stripe max-height="420" empty-text="该班暂无在读学生">
        <el-table-column type="index" label="#" width="50" align="center"
          :index="previewStudentIndex"></el-table-column>
        <el-table-column prop="StuName" label="姓名" min-width="100"></el-table-column>
        <el-table-column label="卡号" min-width="120">
          <template slot-scope="scope">{{ scope.row.CardNumber || '—' }}</template>
        </el-table-column>
        <el-table-column prop="StudentId" label="学生ID" min-width="140"></el-table-column>
        <el-table-column label="床位" width="72" align="center">
          <template slot-scope="scope">{{ scope.row.HasBed ? '有' : '—' }}</template>
        </el-table-column>
        <el-table-column label="余额" width="96" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.Balance > 0" class="preview-student-balance">{{ formatMoney(scope.row.Balance) }}</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="batch-student-pagination">
        <el-pagination background layout="total, prev, pager, next"
          :current-page.sync="previewStudentPageIndex" :page-size="previewStudentPageSize"
          :total="previewStudentItems.length">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewStudentVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="balanceStudentConfirmMode ? '毕业学生仍有余额' : '毕业学生余额名单'"
      :visible.sync="balanceStudentVisible" width="760px" top="8vh" append-to-body
      custom-class="upgrade-preview-student-dialog balance-student-dialog" :close-on-click-modal="false"
      @closed="onBalanceStudentDialogClosed">
      <el-alert :type="balanceStudentConfirmMode ? 'warning' : 'info'" :closable="false" show-icon
        class="balance-student-alert">
        <template slot="title">
          本次毕业归档的学生中有 <b>{{ balanceStudentItems.length }}</b> 人账户仍有余额，合计
          <b class="preview-student-balance">{{ formatMoney(balanceStudentTotal) }} 元</b>
        </template>
        归档后学生不在在读名单，后台无法再直接退费，建议先在消费管理中退费后再结转。
      </el-alert>
      <div class="balance-student-toolbar">
        <el-input v-model="balanceStudentKeyword" size="small" clearable prefix-icon="el-icon-search"
          placeholder="搜索姓名 / 班级 / 卡号 / 学生ID" class="balance-student-search"
          @input="balanceStudentPageIndex = 1"></el-input>
        <span class="balance-student-summary" v-if="balanceStudentKeyword">
          筛选出 {{ filteredBalanceStudents.length }} 人，合计 {{ formatMoney(filteredBalanceStudentTotal) }} 元
        </span>
      </div>
      <el-table :data="pagedBalanceStudents" border stripe :max-height="balanceStudentTableMaxHeight"
        :empty-text="balanceStudentKeyword ? '没有匹配的学生' : '暂无有余额学生'">
        <el-table-column type="index" label="#" width="56" align="center"
          :index="balanceStudentIndex"></el-table-column>
        <el-table-column prop="StuName" label="姓名" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="班级" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.ClassName || '—' }}</template>
        </el-table-column>
        <el-table-column label="卡号" min-width="120">
          <template slot-scope="scope">{{ scope.row.CardNumber || '—' }}</template>
        </el-table-column>
        <el-table-column prop="StudentId" label="学生ID" min-width="140"></el-table-column>
        <el-table-column label="余额（元）" width="110" align="right">
          <template slot-scope="scope">
            <span class="preview-student-balance">{{ formatMoney(scope.row.Balance) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="batch-student-pagination">
        <el-pagination background layout="total, sizes, prev, pager, next"
          :current-page.sync="balanceStudentPageIndex" :page-size.sync="balanceStudentPageSize"
          :page-sizes="[10, 20, 50, 100]" :total="filteredBalanceStudents.length">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <template v-if="balanceStudentConfirmMode">
          <el-button @click="balanceStudentVisible = false">返回先去退费</el-button>
          <el-button type="primary" @click="confirmBalanceStudentDialog">已知晓，余额另行处理并继续</el-button>
        </template>
        <el-button v-else @click="balanceStudentVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 班级扩展信息编辑 Dialog -->
    <el-dialog :title="classExtensionEditorMode === 'add' ? '新增班级扩展信息' : '编辑班级扩展信息'"
      :visible.sync="classExtensionEditorVisible" width="760px"
      custom-class="class-extension-editor-dialog" :close-on-click-modal="false"
      @closed="handleClassExtensionEditorClosed">
      <el-form :model="classExtensionForm" :rules="classExtensionFormRules" ref="classExtensionForm"
        label-width="96px" class="class-extension-editor-form" size="small">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="别名" prop="Alias">
              <el-input v-model="classExtensionForm.Alias" maxlength="50" placeholder="请输入别名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="显示别名" prop="ShowAlias">
              <el-switch v-model="classExtensionForm.ShowAlias"></el-switch>
              <span class="form-item-hint-inline">开启后展示为「原名（别名）」</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="班名解释" prop="ClassNameDesc">
              <el-input v-model="classExtensionForm.ClassNameDesc" maxlength="500" placeholder="请输入班名解释"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="班训" prop="ClassMotto">
              <el-input v-model="classExtensionForm.ClassMotto" maxlength="200" placeholder="请输入班训"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="班主任寄语" prop="HeadTeacherMessage">
              <el-input type="textarea" :rows="4" v-model="classExtensionForm.HeadTeacherMessage" maxlength="1000"
                placeholder="请输入班主任寄语" resize="vertical"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="发展目标" prop="DevelopmentGoal">
              <el-input type="textarea" :rows="4" v-model="classExtensionForm.DevelopmentGoal" maxlength="1000"
                placeholder="请输入班级发展目标" resize="vertical"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12">
            <el-form-item label="Logo">
              <el-upload class="avatar-uploader class-extension-uploader" action="#" :auto-upload="false"
                :show-file-list="false" :on-change="handleClassExtensionClassLogoChange">
                <img v-if="deferredImageDisplay('classLogo', logoImageUrl)"
                  v-oss-src="deferredImageDisplay('classLogo', logoImageUrl)" class="avatar" />
                <i v-if="!deferredImageDisplay('classLogo', logoImageUrl)"
                  class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="班主任照片">
              <el-upload class="avatar-uploader class-extension-uploader" action="#" :auto-upload="false"
                :show-file-list="false" :on-change="handleClassExtensionHeadPicChange">
                <img v-if="deferredImageDisplay('headPic', imageUrl)"
                  v-oss-src="deferredImageDisplay('headPic', imageUrl)" class="avatar" />
                <i v-if="!deferredImageDisplay('headPic', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="是否默认" prop="IsDefault" class="class-extension-default-item">
          <el-switch v-model="classExtensionForm.IsDefault"></el-switch>
          <span class="form-item-hint-inline">同一班级仅一条默认；开启后自动取消本班其它默认项</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classExtensionEditorVisible = false">取消</el-button>
        <el-button type="primary" :loading="classExtensionSaving" @click="submitClassExtensionForm">
          提交
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="teachingImportVisible" width="860px" custom-class="teaching-import-dialog"
      :close-on-click-modal="false" :show-close="true" append-to-body
      @closed="() => resetTeachingImport(false)">
      <div slot="title" class="ti-dialog-title">
        <span class="ti-dialog-title__icon"><i class="el-icon-folder-opened"></i></span>
        <div>
          <strong>批量导入班级与教学架构</strong>
          <p>下载模板填写后上传，系统自动创建校区 → 学段 → 年级 → 班级</p>
        </div>
      </div>

      <div class="ti-body">
        <div class="ti-steps">
          <div class="ti-step">
            <span class="ti-step__no">1</span>
            <div>
              <strong>下载模板</strong>
              <em>按列填写，带 * 必填</em>
            </div>
          </div>
          <i class="el-icon-arrow-right ti-step__arrow"></i>
          <div class="ti-step">
            <span class="ti-step__no">2</span>
            <div>
              <strong>上传 Excel</strong>
              <em>支持 .xlsx / .xls</em>
            </div>
          </div>
          <i class="el-icon-arrow-right ti-step__arrow"></i>
          <div class="ti-step">
            <span class="ti-step__no">3</span>
            <div>
              <strong>核对导入</strong>
              <em>预览后再确认写入</em>
            </div>
          </div>
        </div>

        <button type="button" class="ti-template-card" :disabled="teachingImportTemplateLoading"
          @click="downloadTeachingImportTemplate">
          <span class="ti-template-card__icon"><i class="el-icon-document"></i></span>
          <span class="ti-template-card__meta">
            <strong>班级教学架构批量导入模板.xlsx</strong>
            <em>校区可空→本部校区；年级建议含届别，如「一年级2026级」</em>
          </span>
          <span class="ti-template-card__action">
            <i class="el-icon-loading" v-if="teachingImportTemplateLoading"></i>
            <template v-else>
              <i class="el-icon-download"></i>
              下载模板
            </template>
          </span>
        </button>

        <el-upload :key="'ti-upload-' + teachingImportUploadKey" ref="teachingImportUpload"
          class="ti-upload" drag action="#" :auto-upload="false" :limit="1" :show-file-list="false"
          accept=".xlsx,.xls" :on-change="onTeachingImportFileChange" :on-remove="onTeachingImportFileRemove"
          :on-exceed="onTeachingImportExceed">
          <div v-if="teachingImportFileRaw" class="ti-upload__file">
            <i class="el-icon-success ti-upload__ok"></i>
            <div>
              <strong>{{ teachingImportFileRaw.name }}</strong>
              <em>已选择，点击「解析并预览」进入核对</em>
            </div>
          </div>
          <div v-else class="ti-upload__empty">
            <i class="el-icon-upload2"></i>
            <strong>点击选择或拖拽 Excel 到此处</strong>
            <em>仅支持标准 .xlsx / .xls 文件</em>
          </div>
        </el-upload>
      </div>

      <div slot="footer" class="ti-footer">
        <el-button @click="teachingImportVisible = false">关闭</el-button>
        <el-button type="primary" icon="el-icon-view" :loading="teachingImportParsing"
          :disabled="!teachingImportFileRaw" @click="parseTeachingImportFile">
          解析并预览
        </el-button>
      </div>
    </el-dialog>

    <!-- 班级导入核对 -->
    <el-dialog :visible.sync="teachingImportPreviewVisible" width="60%" custom-class="teaching-import-dialog"
      :close-on-click-modal="false" append-to-body
      :before-close="handleTeachingImportPreviewBeforeClose">
      <div slot="title" class="ti-dialog-title">
        <span class="ti-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
        <div>
          <strong>班级导入核对</strong>
          <p>共 {{ teachingImportOutputs.length }} 条，确认无误后写入系统；同名层级将自动更新</p>
        </div>
      </div>
      <el-table :data="teachingImportOutputs" class="ti-preview-table" border stripe
        style="width: 100%" :max-height="teachingImportResult ? 240 : 420">
        <el-table-column prop="CampusName" label="校区名称" min-width="110" show-overflow-tooltip />
        <el-table-column prop="PeriodName" label="学段" width="90" show-overflow-tooltip />
        <el-table-column prop="GradeName" label="年级名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="GradeOrderNo" label="年级序号" width="90" align="center" />
        <el-table-column prop="ClassName" label="班级名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="ClassOrderNo" label="班级序号" width="90" align="center" />
        <el-table-column prop="ClassCode" label="班级编号" width="100" show-overflow-tooltip />
        <el-table-column prop="ClassAlias" label="班级别名" min-width="110" show-overflow-tooltip />
        <el-table-column fixed="right" label="操作" align="center" width="90">
          <template slot-scope="scope">
            <el-button type="text" class="ti-row-del" @click="removeTeachingImportRow(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="teachingImportResult" class="ti-result" style="margin-top: 14px;">
        <div class="ti-result__summary" :class="teachingImportHasErrors ? 'is-warn' : 'is-ok'">
          <i :class="teachingImportHasErrors ? 'el-icon-warning-outline' : 'el-icon-circle-check'"></i>
          <span>{{ teachingImportResultMsg }}</span>
        </div>
        <el-tabs v-model="teachingImportResultTab" class="ti-result__tabs">
          <el-tab-pane :label="`异常明细 ${teachingImportErrors.length}`" name="errors">
            <el-table :data="teachingImportErrors" size="small" :max-height="420" border stripe
              empty-text="无异常数据" class="ti-result__table">
              <el-table-column prop="RowNumber" label="行号" width="72" align="center" />
              <el-table-column prop="Message" label="错误说明" min-width="280" />
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="`成功明细 ${teachingImportSuccesses.length}`" name="success">
            <el-table :data="teachingImportSuccesses" size="small" :max-height="420" border stripe
              empty-text="暂无成功明细" class="ti-result__table">
              <el-table-column prop="RowNumber" label="行号" width="64" align="center" />
              <el-table-column prop="CampusName" label="校区" min-width="100" show-overflow-tooltip />
              <el-table-column prop="PeriodName" label="学段" width="80" show-overflow-tooltip />
              <el-table-column prop="GradeName" label="年级" min-width="110" show-overflow-tooltip />
              <el-table-column prop="ClassName" label="班级" min-width="110" show-overflow-tooltip />
              <el-table-column prop="ClassCode" label="编号" width="88" show-overflow-tooltip />
              <el-table-column prop="ActionStatus" label="状态" width="80" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="scope.row.ActionStatus === '新增' ? 'success' : 'warning'" effect="plain">
                    {{ scope.row.ActionStatus }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div slot="footer" class="ti-footer">
        <el-button @click="backToTeachingImportSelect">返回上一步</el-button>
        <el-button type="primary" icon="el-icon-upload2" :loading="teachingImporting"
          :disabled="!teachingImportOutputs.length" @click="submitTeachingImport">
          确认导入
        </el-button>
      </div>
    </el-dialog>

    <ding-talk-sync-task-center-dialog
      :visible.sync="taskCenterVisible"
      :school-department-id="currentSchoolDepartmentId"
      :school-name="currentSchoolName"
      :big-type="1"
    />
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  addDepartment,
  editDepartment,
  removeDepartment,
  getDingDingDepartmentTree,
  syncSelectedDingDingDepartment,
  submitDingTalkSyncTask,
  getTeachingDepartmentTree,
  downloadTeachingStructureImportTemplate,
  importTeachingStructure,
  downloadBlobExcel
} from '../../api/modules/department';
import { getDeptCascaderProps, prepareDeptCascaderTree, resolveActiveSchoolId, normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps';
import { getClassExtensionInfoListPage, deleteClassExtensionInfo, addClassExtensionInfo, editClassExtensionInfo } from '../../api/modules/misc';
import {
  getStudentUpgradeRules,
  saveStudentUpgradeRules,
  batchUpdateClassBigType,
  previewAnnualUpgrade,
  executeAnnualUpgrade,
  previewClassTransfer,
  executeClassTransfer,
  previewGradeTransfer,
  executeGradeTransfer,
  getStudentUpgradeBatchPage,
  getStudentUpgradeBatchDetails,
  getStudentUpgradeBatchStudentDetails,
  deleteStudentUpgradeBatch
} from '../../api/modules/studentUpgrade';
import {
  getEnrollmentUnbindOptions,
  saveEnrollmentUnbindOptions
} from '../../api/modules/studentEnrollment';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import DingTalkSyncTaskCenterDialog from '../../components/DingTalkSyncTaskCenterDialog'
import { buildSyncScopeConfirmMessage } from '../../utils/dingTalkSyncScope'
import { read, utils, write } from 'xlsx';

export default {
  components: { Toolbar, DepartmentPane, DingTalkSyncTaskCenterDialog },
  data() {
    return {
      filters: {
        name: "",
      },
      editVisible: false,
      addVisible: false,
      addLoading: false,
      addSubVisible: false,
      savaVisible: false,
      addSubDivVisible: false,
      departmentEditorVisible: false,
      departmentEditorMode: 'edit',
      structurePageIndex: 1,
      structurePageSize: 10,
      structurePageSizes: [10, 20, 50, 100, 200],
      classExtensionLoading: false,
      classExtensionRequestDepartmentId: '',
      classExtensions: [],
      activeClassExtensionId: '',
      deletingClassExtensionId: '',
      classExtensionEditorVisible: false,
      classExtensionEditorMode: 'add',
      classExtensionSaving: false,
      imageUrl: '',
      logoImageUrl: '',
      classExtensionForm: {
        Id: 0,
        ClassNameDesc: '',
        ClassMotto: '',
        HeadTeacherMessage: '',
        IsDefault: false,
        DevelopmentGoal: '',
        DepartmentId: 0,
        Alias: '',
        ShowAlias: false,
        Logo: '',
        ClassLogo: ''
      },
      classExtensionFormRules: {
        Alias: [
          { required: true, message: '请输入别名', trigger: 'blur' }
        ]
      },
      syncVisible: false,
      syncDingVisible: false,
      taskCenterVisible: false,
      syncMode: 'department',
      syncDingType: 1,
      dingTreeLoading: false,
      dingTreeData: [],
      /** 每次打开/刷新钉钉树递增，强制重建避免勾选残留。最后更新：2026-10-29 */
      dingTreeKey: 0,
      dingTreeFromCache: false,
      dingTreeCachedAt: '',
      dingTreeExpiresAt: '',
      syncResourceType: 'Student',
      syncScopeTreeKey: 0,
      syncScopeTreeNodes: [],
      syncScopeTreeExpandedKeys: [],
      currentSchoolDepartmentId: 0,
      currentSchoolSchType: '',
      currentSchoolName: '',
      dingSyncing: false,
      upgradeRuleVisible: false,
      upgradeRuleLoading: false,
      upgradeRuleSaving: false,
      unbindOptionsLoading: false,
      unbindOptions: {
        GraduateUnbindCard: true,
        GraduateReleaseBed: true,
        TransferLeaveUnbindCard: true,
        TransferLeaveReleaseBed: true,
        SuspendUnbindCard: false,
        SuspendReleaseBed: false
      },
      batchBigTypeVisible: false,
      batchBigType: 1,
      batchBigTypeSaving: false,
      selectedClassRows: [],
      annualUpgradeVisible: false,
      annualPreviewLoading: false,
      annualExecuting: false,
      annualAcademicYear: new Date().getMonth() >= 7 ? new Date().getFullYear() : new Date().getFullYear() - 1,
      annualSchoolName: '',
      annualPreview: null,
      annualPreviewTab: 'summary',
      annualRequestId: '',
      classTransferVisible: false,
      classTransferLoading: false,
      classTransferExecuting: false,
      classTransferPreview: null,
      classTransferTab: 'summary',
      classTransferRequestId: '',
      classTransferClassName: '',
      classTransferClassId: 0,
      gradeTransferVisible: false,
      gradeTransferLoading: false,
      gradeTransferExecuting: false,
      gradeTransferPreview: null,
      gradeTransferTab: 'summary',
      gradeTransferRequestId: '',
      gradeTransferGradeName: '',
      gradeTransferGradeId: 0,
      upgradeBatchVisible: false,
      upgradeBatchLoading: false,
      upgradeBatchOpFilter: 0,
      outboxSchoolName: '',
      upgradeBatchItems: [],
      upgradeBatchPageIndex: 1,
      upgradeBatchPageSize: 10,
      upgradeBatchTotal: 0,
      batchDetailVisible: false,
      batchDetailLoading: false,
      batchDetailItems: [],
      batchDetailBatchId: 0,
      batchDetailKeyword: '',
      batchStudentVisible: false,
      batchStudentLoading: false,
      batchStudentItems: [],
      batchStudentPageIndex: 1,
      batchStudentPageSize: 10,
      batchStudentTotal: 0,
      batchStudentSourceDeptId: 0,
      batchStudentSourceName: '',
      batchStudentKeyword: '',
      batchStudentSearchTimer: null,
      previewStudentVisible: false,
      previewStudentClassName: '',
      previewStudentTargetText: '',
      previewStudentItems: [],
      previewStudentPageIndex: 1,
      previewStudentPageSize: 10,
      balanceStudentVisible: false,
      balanceStudentItems: [],
      balanceStudentTotal: 0,
      balanceStudentKeyword: '',
      balanceStudentPageIndex: 1,
      balanceStudentPageSize: 10,
      balanceStudentConfirmMode: false,
      balanceStudentTableMaxHeight: 420,
      balanceStudentResolver: null,
      deletingBatchId: 0,
      teachingImportVisible: false,
      teachingImportPreviewVisible: false,
      teachingImportKeepFileOnClose: false,
      teachingImportFileList: [],
      teachingImportFileRaw: null,
      teachingImportUploadKey: 0,
      teachingImportOutputs: [],
      teachingImportParsing: false,
      teachingImporting: false,
      teachingImportTemplateLoading: false,
      teachingImportResult: null,
      teachingImportResultMsg: '',
      teachingImportResultTab: 'success',
      teachingImportErrors: [],
      teachingImportSuccesses: [],
      upgradeRuleConfig: {
        SchId: '',
        SchoolName: '',
        Rules: []
      },
      ruleForm: {
        Id: 0,
        OrderSort: 0,
        GradeOrderNo: '',
        ClassOrderNo: '',
        Pid: 0,
        PidPath: [],
        PidArr: [],
        CreateBy: "",
        Name: "",
        CodeRelationship: "",
        Leader: "",
        Enabled: true,
        Status: true,
        DeptOrgType: "",
        BigType: 1, // 0: 内部通讯录, 1: 家校通讯录（钉钉学校用，默认家校）
      },
      rules: {
        Name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        GradeOrderNo: [
          { required: true, message: '请输入年级排序', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '年级排序请输入正整数', trigger: 'blur' }
        ],
        ClassOrderNo: [
          { required: true, message: '请输入班级排序', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '班级排序请输入正整数', trigger: 'blur' }
        ],
        OrderSort: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '' || Number(value) === 0) {
                callback();
                return;
              }
              if (/^[1-9]\d*$/.test(String(value))) {
                callback();
                return;
              }
              callback(new Error('学段排序请输入正整数'));
            },
            trigger: 'blur'
          }
        ]
      },
      departmentEditorSource: null,
      CurrentDepartment: {},
      /** 等待左侧树默认选中，避免右侧先闪空态。最后更新：2026-08-30 */
      workspaceBootstrapping: true,
      resolvedSchoolSchId: '',
      departmentOptions: [],
      departmentTree: null,
      departmentTreeOptions: [],
      parentLabel: '',
      valueToPath: {},
      lastCodeRelationshipArr: null,
      cascaderProps: getDeptCascaderProps({ emitPath: true, checkStrictly: true })
    };
  },
  created() {
    this.loadDepartmentOptions();
  },
  watch: {
    '$store.state.activeSchoolId'(newSchoolId, oldSchoolId) {
      if (String(newSchoolId || '') !== String(oldSchoolId || '')) {
        this.workspaceBootstrapping = true
        this.CurrentDepartment = {}
        this.loadDepartmentOptions();
      }
    }
  },
  methods: {

    // 加载部门树并扁平化为下拉选项
    loadDepartmentOptions() {
      const activeSchoolId = resolveActiveSchoolId(this);
      let para = {
        pid: 0,
        type: 0,
        bigType: 1,
        scopeDepartmentId: activeSchoolId || 0
      };
      return getTeachingDepartmentTree(para).then((res) => {
        if (res && res.data && res.data.response) {
          const tree = res.data.response;
          this.departmentTree = tree;
          // ensure tree is in array form for cascader options
          this.departmentTreeOptions = tree ? [tree] : [];
          const list = [];
          this.valueToPath = {};
          const walk = (node, path) => {
            if (!node) return;
            const curPath = path ? path.concat([node.value]) : [node.value];
            // store flat option
            list.push({ value: node.value, label: node.label, CodeRelationship: node.CodeRelationship, Pid: node.Pid, DeptOrgType: node.DeptOrgType });
            // store path mapping
            this.valueToPath[String(node.value)] = curPath;
            if (node.children && node.children.length) {
              node.children.forEach((c) => walk(c, curPath));
            }
          };
          walk(tree, []);
          this.departmentOptions = list;
          // 如果之前已从 CodeRelationship 保存过原始 id 数组，尝试解析并回填 cascader path
          if (this.lastCodeRelationshipArr && this.lastCodeRelationshipArr.length) {
            const resolved = this.resolvePathFromCodeRelationship(this.lastCodeRelationshipArr);
            if (resolved && resolved.length) {
              this.ruleForm.PidPath = resolved;
              this.ruleForm.Pid = resolved[resolved.length - 1];
            }
            // 清理缓存，避免重复处理
            this.lastCodeRelationshipArr = null;
          }
        }
        return res;
      });
    },

    /**
     * 升班等变更组织后，重新请求左侧树与右侧列表数据，并尽量保持当前选中节点。
     * 创建于 2026-08-07
     */
    reloadDepartmentTreeAfterUpgrade() {
      const keepKey = this.CurrentDepartment && this.CurrentDepartment.value
        ? this.CurrentDepartment.value
        : null;
      if (this.$refs.child && typeof this.$refs.child.refreshMethod === 'function') {
        this.$refs.child.refreshMethod(keepKey);
      }
      return this.loadDepartmentOptions().then(() => {
        if (!keepKey || !this.departmentTree) return;
        const findNode = (node) => {
          if (!node) return null;
          if (String(node.value) === String(keepKey)) return node;
          const children = node.children || [];
          for (let i = 0; i < children.length; i += 1) {
            const found = findNode(children[i]);
            if (found) return found;
          }
          return null;
        };
        const fresh = findNode(this.departmentTree);
        if (fresh) this.CurrentDepartment = fresh;
      });
    },

    openTeachingStructureImport() {
      if (!this.isSchoolNode || !this.CurrentDepartment || !this.CurrentDepartment.value) {
        this.$message.warning('请先选择学校节点');
        return;
      }
      this.resetTeachingImport(true);
      this.teachingImportPreviewVisible = false;
      this.teachingImportVisible = true;
    },

    // fullReset=true 时同时清空核对数据；选择弹窗 @closed 仅重置上传态
    // 跳转预览时 keep 文件，便于「返回上一步」
    resetTeachingImport(fullReset) {
      if (!fullReset && this.teachingImportKeepFileOnClose) {
        this.teachingImportKeepFileOnClose = false;
        return;
      }
      this.teachingImportFileList = [];
      this.teachingImportFileRaw = null;
      this.teachingImportParsing = false;
      // 重建 upload，避免 limit=1 关闭后再次选择无响应
      this.teachingImportUploadKey += 1;
      if (!fullReset) return;
      this.teachingImportOutputs = [];
      this.teachingImporting = false;
      this.teachingImportResult = null;
      this.teachingImportResultMsg = '';
      this.teachingImportResultTab = 'success';
      this.teachingImportErrors = [];
      this.teachingImportSuccesses = [];
    },

    // 核对页返回选择页，保留已选文件
    backToTeachingImportSelect() {
      this.teachingImportPreviewVisible = false;
      this.teachingImportResult = null;
      this.teachingImportErrors = [];
      this.teachingImportSuccesses = [];
      this.teachingImportVisible = true;
    },

    handleTeachingImportPreviewBeforeClose(done) {
      this.backToTeachingImportSelect();
      done();
    },

    onTeachingImportFileChange(file, fileList) {
      this.teachingImportFileList = fileList.slice(-1);
      this.teachingImportFileRaw = file && file.raw ? file.raw : null;
      this.teachingImportResult = null;
      this.teachingImportErrors = [];
      this.teachingImportSuccesses = [];
    },

    onTeachingImportFileRemove() {
      this.teachingImportFileList = [];
      this.teachingImportFileRaw = null;
    },

    // 已选满 1 个文件时再次选择：用新文件替换
    onTeachingImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.teachingImportUploadKey += 1;
      this.$nextTick(() => {
        this.teachingImportFileRaw = nextFile;
        this.teachingImportFileList = [];
        this.teachingImportResult = null;
        this.teachingImportErrors = [];
        this.teachingImportSuccesses = [];
      });
    },

    downloadTeachingImportTemplate() {
      this.teachingImportTemplateLoading = true;
      downloadTeachingStructureImportTemplate()
        .then((res) => downloadBlobExcel(res, '班级架构导入模板'))
        .catch(() => {
          this.$message.error('下载模板失败');
        })
        .finally(() => {
          this.teachingImportTemplateLoading = false;
        });
    },

    // 解析 Excel 并进入核对预览。最后更新：2026-08-07
    parseTeachingImportFile() {
      if (!this.teachingImportFileRaw) {
        this.$message.warning('请先选择 Excel 文件');
        return;
      }
      const file = this.teachingImportFileRaw;
      if (!/\.(xls|xlsx)$/.test((file.name || '').toLowerCase())) {
        this.$message.error('上传格式不正确，请上传 xls 或 xlsx');
        return;
      }
      this.teachingImportParsing = true;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const workbook = read(ev.target.result, { type: 'binary' });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const aoa = utils.sheet_to_json(sheet, { header: 1, defval: '', raw: false });
          const headerIdx = aoa.findIndex((row) => {
            const c0 = String(row[0] || '');
            const c1 = String(row[1] || '');
            return c0.includes('校区') && c1.includes('学段');
          });
          if (headerIdx < 0) {
            this.teachingImportParsing = false;
            this.$message.error('未识别到表头，请使用标准导入模板');
            return;
          }
          const rows = [];
          for (let i = headerIdx + 1; i < aoa.length; i++) {
            const row = aoa[i] || [];
            const campusName = String(row[0] || '').trim();
            const periodName = String(row[1] || '').trim();
            const gradeName = String(row[2] || '').trim();
            const gradeOrderNo = String(row[3] || '').trim();
            const className = String(row[4] || '').trim();
            const classOrderNo = String(row[5] || '').trim();
            const classCode = String(row[6] || '').trim();
            const classAlias = String(row[7] || '').trim();
            if (!campusName && !periodName && !gradeName && !className && !classCode) continue;
            rows.push({
              CampusName: campusName || '本部校区',
              PeriodName: periodName,
              GradeName: gradeName,
              GradeOrderNo: gradeOrderNo,
              ClassName: className,
              ClassOrderNo: classOrderNo,
              ClassCode: classCode,
              ClassAlias: classAlias
            });
          }
          this.teachingImportParsing = false;
          if (!rows.length) {
            this.$message.warning('没有可预览的数据行');
            return;
          }
          this.teachingImportOutputs = rows;
          this.teachingImportResult = null;
          this.teachingImportErrors = [];
          this.teachingImportSuccesses = [];
          this.teachingImportKeepFileOnClose = true;
          this.teachingImportVisible = false;
          this.teachingImportPreviewVisible = true;
        } catch (e) {
          this.teachingImportParsing = false;
          this.$message.error('文件读取失败');
        }
      };
      fileReader.onerror = () => {
        this.teachingImportParsing = false;
        this.$message.error('文件读取失败');
      };
      fileReader.readAsBinaryString(file);
    },

    removeTeachingImportRow(scope) {
      if (!scope || scope.$index == null) return;
      this.teachingImportOutputs.splice(scope.$index, 1);
    },

    // 按核对后的行重建 Excel 再提交导入
    buildTeachingImportFileFromOutputs() {
      const headers = ['校区名称', '学段*', '年级名称*', '年级序号*', '班级名称*', '班级序号*', '班级编号*', '班级别名'];
      const aoa = [headers].concat(this.teachingImportOutputs.map((row) => ([
        row.CampusName || '',
        row.PeriodName || '',
        row.GradeName || '',
        row.GradeOrderNo || '',
        row.ClassName || '',
        row.ClassOrderNo || '',
        row.ClassCode || '',
        row.ClassAlias || ''
      ])));
      const sheet = utils.aoa_to_sheet(aoa);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, '班级架构导入');
      const buffer = write(book, { bookType: 'xlsx', type: 'array' });
      return new File([buffer], '班级教学架构导入核对.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
    },

    submitTeachingImport() {
      if (!this.teachingImportOutputs.length) {
        this.$message.warning('没有可导入的数据');
        return;
      }
      const schoolId = this.CurrentDepartment && this.CurrentDepartment.value;
      if (!schoolId) {
        this.$message.warning('请先选择学校节点');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.buildTeachingImportFileFromOutputs());
      this.teachingImporting = true;
      this.teachingImportResult = null;
      this.teachingImportErrors = [];
      this.teachingImportSuccesses = [];
      importTeachingStructure(formData, schoolId).then((res) => {
        this.teachingImporting = false;
        const body = res && res.data ? res.data : {};
        const result = body.response || {};
        this.teachingImportResult = result;
        this.teachingImportResultMsg = body.msg || (body.success ? '导入完成' : '导入失败');
        const errors = result.Errors || result.errors || [];
        this.teachingImportErrors = errors.map((item) => ({
          RowNumber: item.RowNumber != null ? item.RowNumber : item.rowNumber,
          Message: item.Message || item.message || ''
        }));
        const successes = result.SuccessDetails || result.successDetails || [];
        this.teachingImportSuccesses = successes.map((item) => ({
          RowNumber: item.RowNumber != null ? item.RowNumber : item.rowNumber,
          CampusName: item.CampusName || item.campusName || '',
          PeriodName: item.PeriodName || item.periodName || '',
          GradeName: item.GradeName || item.gradeName || '',
          ClassName: item.ClassName || item.className || '',
          ClassCode: item.ClassCode || item.classCode || '',
          ActionStatus: item.ActionStatus || item.actionStatus || ''
        }));
        this.teachingImportResultTab = this.teachingImportErrors.length && !this.teachingImportSuccesses.length
          ? 'errors'
          : 'success';
        if (body.success) {
          this.$message.success(this.teachingImportResultMsg);
          this.reloadDepartmentTreeAfterUpgrade();
        } else {
          this.$message.error(this.teachingImportResultMsg);
        }
      }).catch(() => {
        this.teachingImporting = false;
        this.$message.error('导入失败');
      });
    },

    // 将 CodeRelationship 字符串数组解析为与 options 中 value 类型一致的 value 数组
    resolvePathFromCodeRelationship(arr) {
      if (!Array.isArray(arr) || !arr.length) return [];
      const resolved = [];
      arr.forEach(idStr => {
        const found = (this.departmentOptions || []).find(o => String(o.value) === String(idStr));
        if (found) resolved.push(found.value);
        else {
          // 如果没找到，尝试把字符串转成数字再匹配
          const num = Number(idStr);
          const foundNum = (this.departmentOptions || []).find(o => o.value === num);
          if (foundNum) resolved.push(foundNum.value);
          else resolved.push(idStr);
        }
      });
      return resolved;
    },

    onParentTreeNodeClick(node) {
      if (!node) return;
      this.ruleForm.PidPath = this.valueToPath[String(node.value)] || [node.value];
      this.ruleForm.Pid = node.value;
      this.parentLabel = node.label;
      // 关闭弹出层 if exists
      if (this.$refs.parentTreePopover && this.$refs.parentTreePopover.doClose) this.$refs.parentTreePopover.doClose();
    },

    onCascaderChange(value) {
      if (Array.isArray(value) && value.length) {
        this.ruleForm.Pid = value[value.length - 1];
      } else {
        this.ruleForm.Pid = 0;
      }
    },


    submitSubForm() {
      if (!this.canCreateChild) return;
      const parent = this.CurrentDepartment;
      const parentType = String(parent.DeptOrgType || '').toLowerCase();
      const typeMap = {
        school: 'campus',
        affiliateschool: 'period',
        campus: 'period',
        period: 'grade',
        grade: 'class'
      };
      this.departmentEditorMode = 'add';
      this.departmentEditorSource = null;
      this.ruleForm.Id = 0;
      this.ruleForm.Name = '';
      this.ruleForm.OrderSort = 0;
      this.ruleForm.GradeOrderNo = '';
      this.ruleForm.ClassOrderNo = '';
      this.ruleForm.Pid = parent.value || 0;
      this.ruleForm.PidPath = this.valueToPath[String(parent.value)] || [parent.value];
      this.ruleForm.DeptOrgType = typeMap[parentType] || '';
      this.ruleForm.BigType = 1;
      this.departmentEditorVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },

    applyDepartmentToRuleForm(data) {
      if (!data) return;
      this.ruleForm.DeptOrgType = String(data.DeptOrgType || '').toLowerCase();
      this.ruleForm.Name = data.label || data.Name || '';
      this.ruleForm.OrderSort = Number(data.OrderSort || 0);
      this.ruleForm.GradeOrderNo = data.GradeOrderNo === null || data.GradeOrderNo === undefined
        ? ''
        : String(data.GradeOrderNo);
      this.ruleForm.ClassOrderNo = data.ClassOrderNo === null || data.ClassOrderNo === undefined
        ? ''
        : String(data.ClassOrderNo);
      this.ruleForm.Id = data.value || data.Id || 0;
      this.ruleForm.Pid = data.Pid || data.parentId || 0;

      const codeRel = data.CodeRelationship || data.CodeRelationshipString || data.CodeRelationshipText;
      if (codeRel && typeof codeRel === 'string') {
        const arr = codeRel.split(',').filter(value => value !== '');
        if (arr.length) {
          const ownId = String(this.ruleForm.Id || arr[arr.length - 1]);
          const parentPath = String(arr[arr.length - 1]) === ownId ? arr.slice(0, -1) : arr;
          this.lastCodeRelationshipArr = parentPath.slice();
          const resolved = this.resolvePathFromCodeRelationship(parentPath);
          this.ruleForm.PidPath = resolved;
          this.ruleForm.Pid = resolved && resolved.length ? resolved[resolved.length - 1] : 0;
        } else {
          this.ruleForm.PidPath = [];
          this.ruleForm.Pid = 0;
        }
      } else {
        this.lastCodeRelationshipArr = null;
        const pid = this.ruleForm.Pid;
        this.ruleForm.PidPath = pid
          ? (this.valueToPath[String(pid)] || [pid])
          : [];
      }
      this.ruleForm.ThirdPartySchoolId = data.ThirdPartySchoolId || data.ThirdPartId || '';
      this.ruleForm.BigType = data.BigType === undefined || data.BigType === null ? 1 : data.BigType;
    },

    treeNodeClick(data, node, component) {
      this.workspaceBootstrapping = false;
      this.CurrentDepartment = data || {};
      this.resolvedSchoolSchId = this.resolveSchIdFromTreeNode(node, data);
      let schoolNode = node;
      this.currentSchoolDepartmentId = '';
      this.currentSchoolSchType = '';
      this.currentSchoolName = '';
      // 默认选中时可能只有 data、无完整 el-tree parent 链，先认当前节点本身
      const selfType = String((data && (data.DeptOrgType || data.deptOrgType)) || '').toLowerCase();
      if (selfType === 'school' || selfType === 'affiliateschool') {
        this.currentSchoolDepartmentId = normalizeDeptId(data.value);
        this.currentSchoolSchType = data.SchType || data.schType || '';
        this.currentSchoolName = data.label || data.Name || this.$store.state.activeSchoolName || '';
      }
      while (!this.currentSchoolDepartmentId && schoolNode) {
        const schoolData = schoolNode.data || {};
        const orgType = String(schoolData.DeptOrgType || schoolData.deptOrgType || '').toLowerCase();
        if (orgType === 'school' || orgType === 'affiliateschool') {
          this.currentSchoolDepartmentId = normalizeDeptId(schoolData.value);
          this.currentSchoolSchType = schoolData.SchType || schoolData.schType || '';
          this.currentSchoolName = schoolData.label || schoolData.Name || this.$store.state.activeSchoolName || '';
          break;
        }
        schoolNode = schoolNode.parent;
      }
      this.clearClassSelection();
      this.structurePageIndex = 1;
      this.addSubDivVisible = false;
      if (String(data && data.DeptOrgType || '').toLowerCase() === 'class') {
        this.loadClassExtensions(data.value);
      } else {
        this.classExtensionRequestDepartmentId = '';
        this.classExtensionLoading = false;
        this.classExtensions = [];
        this.activeClassExtensionId = '';
      }

      // root selection
      if (!data || data.value === '') {
        this.editVisible = false;
        this.addVisible = false;
        this.addSubVisible = false;
        this.savaVisible = false;
        this.syncVisible = false;
        this.ruleForm.Name = '';
        this.ruleForm.OrderSort = 0;
        this.ruleForm.GradeOrderNo = '';
        this.ruleForm.ClassOrderNo = '';
        this.ruleForm.Id = 0;
        this.ruleForm.DeptOrgType = '';
        return;
      }

      // For any non-root node allow editing; disallow creating child if parent is class
      this.editVisible = true;
      this.addSubVisible = (data.DeptOrgType || '') !== 'class';
      this.addVisible = false;
      this.savaVisible = true;

      // 仅钉钉学校显示同步入口。最后更新：2026-08-30
      this.syncVisible = this.currentSchoolDepartmentId > 0
        && String(this.currentSchoolSchType || '').toLowerCase() === 'dingding';

      this.applyDepartmentToRuleForm(data);
    },

    openEditDepartment() {
      if (!this.hasCurrentDepartment) return;
      this.departmentEditorSource = this.CurrentDepartment;
      this.applyDepartmentToRuleForm(this.CurrentDepartment);
      this.departmentEditorMode = 'edit';
      this.departmentEditorVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },

    handleDepartmentEditorClosed() {
      this.departmentEditorSource = null;
    },

    selectDepartmentRow(row, column) {
      if (!row) return;
      if (column && column.type === 'selection') return;
      const tree = this.$refs.child && this.$refs.child.$refs
        ? this.$refs.child.$refs.menuTree
        : null;
      if (tree && tree.setCurrentKey) tree.setCurrentKey(row.value);
      this.treeNodeClick(row, tree && tree.getNode ? tree.getNode(row.value) : null, null);
    },

    handleRowClick(row, column) {
      if (column && column.type === 'selection') return;
      if (this.isClassList) {
        this.$refs.architectureTable.toggleRowSelection(row);
      }
    },

    editDepartmentRow(row) {
      if (!row) return;
      this.departmentEditorSource = row;
      this.applyDepartmentToRuleForm(row);
      this.departmentEditorMode = 'edit';
      this.departmentEditorVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },

    departmentRowIndex(index) {
      return (this.structurePageIndex - 1) * this.structurePageSize + index + 1;
    },

    /** 直属组织翻页 */
    onStructurePageChange(page) {
      this.structurePageIndex = Number(page) || 1;
    },

    /** 直属组织切换每页条数（须写回 data，表格才按新条数切片）。最后更新：2026-09-05 */
    onStructurePageSizeChange(size) {
      const next = Number(size) || 10;
      this.structurePageSize = next;
      this.structurePageIndex = 1;
    },

    handleClassSelectionChange(rows) {
      this.selectedClassRows = (rows || []).filter(row =>
        String(row && row.DeptOrgType || '').toLowerCase() === 'class');
    },

    clearClassSelection() {
      this.selectedClassRows = [];
      this.$nextTick(() => {
        const table = this.$refs.architectureTable;
        if (table && table.clearSelection) table.clearSelection();
      });
    },

    departmentTypeText(type) {
      const texts = {
        school: '学校', affiliateschool: '附属学校', campus: '校区',
        period: '学段', grade: '年级', class: '班级'
      };
      return texts[String(type || '').toLowerCase()] || '部门';
    },

    departmentTypeTag(type) {
      const tags = {
        school: 'primary', affiliateschool: 'primary', campus: 'success',
        period: 'warning', grade: 'danger', class: 'info'
      };
      return tags[String(type || '').toLowerCase()] || 'info';
    },

    departmentDetailText(row) {
      const type = String(row && row.DeptOrgType || '').toLowerCase();
      if (type === 'class') {
        const addressBook = Number(row.BigType) === 1 ? '家校通讯录' : '内部通讯录';
        return `班级排序：${row.ClassOrderNo || '-'} · ${addressBook}`;
      }
      if (type === 'grade') return `年级排序：${row.GradeOrderNo || '-'}`;
      if (type === 'period') return `学段排序：${row.OrderSort || '-'}`;
      return row.Description || row.Remark || '-';
    },

    departmentBusinessOrder(row) {
      const type = String(row && row.DeptOrgType || '').toLowerCase();
      if (type === 'period') {
        const n = Number(row.OrderSort);
        if (Number.isFinite(n) && n > 0) return n;
        const name = String(row.label || row.Name || '');
        if (name.includes('幼儿') || name.includes('学前') || name.includes('托育')) return 10;
        if (name.includes('小学')) return 20;
        if (name.includes('初中')) return 30;
        if (name.includes('高中')) return 40;
        if (name.includes('教职工') || name.includes('职工')) return 90;
        return 80;
      }
      const value = type === 'grade'
        ? row.GradeOrderNo
        : (type === 'class' ? row.ClassOrderNo : row.OrderSort);
      if (value === null || value === undefined || value === '') return Number.MAX_SAFE_INTEGER;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER;
    },

    classExtensionTabLabel(extension, index) {
      const label = String(extension && extension.Alias || `扩展信息 ${index + 1}`);
      return label.length > 12 ? `${label.slice(0, 12)}...` : label;
    },

    loadClassExtensions(departmentId) {
      const requestDepartmentId = String(departmentId || '');
      if (!requestDepartmentId) return;
      this.classExtensionRequestDepartmentId = requestDepartmentId;
      this.classExtensionLoading = true;
      this.classExtensions = [];
      this.activeClassExtensionId = '';
      getClassExtensionInfoListPage({
        page: 1,
        intPageSize: 100,
        departmentId: requestDepartmentId
      }).then(async res => {
        if (this.classExtensionRequestDepartmentId !== requestDepartmentId) return;
        const page = res && res.data ? res.data.response || {} : {};
        const rows = (page.data || page.Data || [])
          .filter(item => String(item.DepartmentId) === requestDepartmentId)
          .sort((left, right) => {
            if (!!left.IsDefault !== !!right.IsDefault) return left.IsDefault ? -1 : 1;
            return Number(left.Id || 0) - Number(right.Id || 0);
          });
        await this.prefetchListOssMedia(rows, ['ClassLogo', 'Logo']);
        if (this.classExtensionRequestDepartmentId !== requestDepartmentId) return;
        this.classExtensions = rows;
        this.activeClassExtensionId = rows.length ? String(rows[0].Id) : '';
      }).catch(() => {
        if (this.classExtensionRequestDepartmentId === requestDepartmentId) {
          this.classExtensions = [];
          this.activeClassExtensionId = '';
          this.$message({ message: '获取班级扩展信息失败', type: 'error' });
        }
      }).finally(() => {
        if (this.classExtensionRequestDepartmentId === requestDepartmentId) {
          this.classExtensionLoading = false;
        }
      });
    },

    deleteCurrentClassExtension(extension) {
      if (!extension || !extension.Id) return;
      const recordName = extension.Alias || `扩展信息 ${extension.Id}`;
      this.$confirm(`确认删除“${recordName}”吗？`, '删除班级扩展信息', {
        type: 'warning'
      }).then(() => {
        this.deletingClassExtensionId = extension.Id;
        return deleteClassExtensionInfo({ ids: String(extension.Id) });
      }).then(res => {
        if (!res) return;
        this.deletingClassExtensionId = '';
        if (res.data && res.data.success) {
          this.$message({ message: res.data.msg || '删除成功', type: 'success' });
          this.loadClassExtensions(this.CurrentDepartment.value);
          return;
        }
        this.$message({ message: res.data ? res.data.msg : '删除失败', type: 'error' });
      }).catch(() => {
        this.deletingClassExtensionId = '';
      });
    },

    handleAddClassExtension() {
      this.classExtensionEditorMode = 'add';
      this.classExtensionForm = {
        ClassNameDesc: '',
        ClassMotto: '',
        HeadTeacherMessage: '',
        IsDefault: false,
        DevelopmentGoal: '',
        DepartmentId: this.CurrentDepartment.value,
        Alias: "",
        ShowAlias: false,
        Logo: "",
        ClassLogo: ""
      };
      this.imageUrl = '';
      this.logoImageUrl = '';
      this.deferredImageRevoke('headPic');
      this.deferredImageRevoke('classLogo');
      this.classExtensionEditorVisible = true;
      this.$nextTick(() => {
        if (this.$refs.classExtensionForm) this.$refs.classExtensionForm.clearValidate();
      });
    },

    handleEditClassExtension(row) {
      if (!row) return;
      this.classExtensionEditorMode = 'edit';
      this.classExtensionForm = Object.assign({}, row);
      if (typeof this.classExtensionForm.ShowAlias !== 'boolean') {
        this.classExtensionForm.ShowAlias = !!this.classExtensionForm.ShowAlias;
      }
      this.imageUrl = this.classExtensionForm.Logo;
      this.logoImageUrl = this.classExtensionForm.ClassLogo;
      this.deferredImageInit('headPic', this.classExtensionForm.Logo);
      this.deferredImageInit('classLogo', this.classExtensionForm.ClassLogo);
      this.classExtensionEditorVisible = true;
      this.$nextTick(() => {
        if (this.$refs.classExtensionForm) this.$refs.classExtensionForm.clearValidate();
      });
    },

    handleClassExtensionClassLogoChange(file) {
      this.deferredImageChange('classLogo', file, { foo: 'DeptExtensionInfo', savedUrl: this.logoImageUrl });
    },

    handleClassExtensionHeadPicChange(file) {
      this.deferredImageChange('headPic', file, { foo: 'DeptExtensionInfo', savedUrl: this.imageUrl });
    },

    handleClassExtensionEditorClosed() {
      this.deferredImageRevoke('headPic');
      this.deferredImageRevoke('classLogo');
    },

    submitClassExtensionForm() {
      this.$refs.classExtensionForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(async () => {
            this.classExtensionSaving = true;
            try {
              this.classExtensionForm.Logo = await this.deferredImageEnsure('headPic', {
                endpoint: 'HeadPic',
                foo: 'DeptExtensionInfo',
                currentUrl: this.classExtensionForm.Logo
              });
              this.classExtensionForm.ClassLogo = await this.deferredImageEnsure('classLogo', {
                foo: 'DeptExtensionInfo',
                currentUrl: this.classExtensionForm.ClassLogo
              });
              let para = Object.assign({}, this.classExtensionForm);
              para.DepartmentId = Number(para.DepartmentId);

              const apiCall = this.classExtensionEditorMode === 'add'
                ? addClassExtensionInfo(para)
                : editClassExtensionInfo(para);

              const res = await apiCall;
              if (util.isEmt.format(res)) return;
              if (res.data.success) {
                this.$message({ message: res.data.msg || '保存成功', type: 'success' });
                this.classExtensionEditorVisible = false;
                this.loadClassExtensions(this.CurrentDepartment.value);
              } else {
                this.$message({ message: res.data.msg || '保存失败', type: 'error' });
              }
            } catch (e) {
              this.$message({ message: (e && e.message) || '提交失败', type: 'error' });
            } finally {
              this.classExtensionSaving = false;
            }
          });
        }
      });
    },

    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },

    //新建部门
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;

            let para = Object.assign({}, this.ruleForm);

            if (para.Id > 0) {

              const editorSource = this.departmentEditorSource || this.CurrentDepartment;
              let para = Object.assign({}, editorSource);

              para.Name = this.ruleForm.Name;
              para.Id = this.ruleForm.Id;
              para.GradeOrderNo = this.ruleForm.DeptOrgType === 'grade'
                ? String(this.ruleForm.GradeOrderNo || '')
                : editorSource.GradeOrderNo;
              para.ClassOrderNo = this.ruleForm.DeptOrgType === 'class'
                ? String(this.ruleForm.ClassOrderNo || '')
                : editorSource.ClassOrderNo;
              // 业务序号与 OrderSort 双写，供 GetClasses 等仍按 OrderSort 排序的接口使用
              if (this.ruleForm.DeptOrgType === 'grade') {
                para.OrderSort = Number(this.ruleForm.GradeOrderNo || 0);
              } else if (this.ruleForm.DeptOrgType === 'class') {
                para.OrderSort = Number(this.ruleForm.ClassOrderNo || 0);
              } else if (this.ruleForm.DeptOrgType === 'period') {
                para.OrderSort = Number(this.ruleForm.OrderSort || 0);
              }
              // 如果有选择上级部门，则更新 Pid
              if (Array.isArray(this.ruleForm.PidPath) && this.ruleForm.PidPath.length) {
                para.Pid = this.ruleForm.PidPath[this.ruleForm.PidPath.length - 1];
              } else if (this.ruleForm.Pid !== undefined && this.ruleForm.Pid !== null) {
                para.Pid = this.ruleForm.Pid;
              }

              // 重新计算 CodeRelationship：优先使用 cascader 的 PidPath（父路径），否则尝试使用父节点的 CodeRelationship
              try {
                let codeArr = [];
                if (Array.isArray(this.ruleForm.PidPath) && this.ruleForm.PidPath.length) {
                  codeArr = this.ruleForm.PidPath.map(v => String(v));
                } else if (para.Pid) {
                  const parent = (this.departmentOptions || []).find(o => String(o.value) === String(para.Pid));
                  if (parent && parent.CodeRelationship) {
                    // parent.CodeRelationship 可能是 '1,2,5,' 形式，拆分并去空
                    codeArr = (String(parent.CodeRelationship).split(',').filter(x => x !== ''));
                  } else if (parent) {
                    codeArr = [String(parent.value)];
                  }
                }
                // CodeRelationship 应该只包含到父节点（不包含自身）
                para.CodeRelationship = codeArr.length ? (codeArr.join(',') + ',') : '';
              } catch (e) {
                para.CodeRelationship = String(para.Id) + ',';
              }

              // 验证：不能将非 school 的部门改为 school；school 节点不能更改类型
              if (editorSource.DeptOrgType !== 'school' && this.ruleForm.DeptOrgType === 'school') {
                this.$message({ message: '不能将部门修改为学校类型', type: 'error' });
                this.addLoading = false;
                return;
              }
              // 确保 school 节点保持为 school
              if (editorSource.DeptOrgType === 'school') {
                para.DeptOrgType = 'school';
              } else {
                para.DeptOrgType = this.ruleForm.DeptOrgType;
              }
              // 同步 BigType（仅班级有效）
              para.BigType = this.ruleForm.BigType;

              para.ModifyTime = util.formatDate.format(
                new Date(),
                "yyyy-MM-dd hh:mm:ss"
              );

              editDepartment(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.addLoading = false;
                  this.departmentEditorVisible = false;
                  this.departmentEditorSource = null;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });

                  this.$refs.child.refreshMethod(this.CurrentDepartment.value);
                  this.loadDepartmentOptions();

                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            } else {

              if (para.DeptOrgType === 'grade') {
                para.GradeOrderNo = String(this.ruleForm.GradeOrderNo || '');
                para.OrderSort = Number(this.ruleForm.GradeOrderNo || 0);
              } else if (para.DeptOrgType === 'class') {
                para.ClassOrderNo = String(this.ruleForm.ClassOrderNo || '');
                para.OrderSort = Number(this.ruleForm.ClassOrderNo || 0);
              } else if (para.DeptOrgType === 'period') {
                para.OrderSort = Number(this.ruleForm.OrderSort || 0);
              }

              para.SchId = this.CurrentDepartment.SchId;
              const relationship = String(this.CurrentDepartment.CodeRelationship || '');
              const arr = relationship.split(',').filter(Boolean);
              if (String(arr[arr.length - 1] || '') !== String(this.CurrentDepartment.value)) {
                arr.push(this.CurrentDepartment.value);
              }
              para.PidArr = arr.slice();
              para.CodeRelationship = arr.join(',') + ',';
              para.Pid = this.CurrentDepartment.value;

              para.CreateTime = util.formatDate.format(
                new Date(),
                "yyyy-MM-dd hh:mm:ss"
              );
              para.ModifyTime = para.CreateTime;
              para.IsDeleted = false;

              var user = JSON.parse(window.localStorage.user);

              if (user && user.uID > 0) {
                para.CreateId = user.uID;
                para.CreateBy = user.uRealName;
              }
              addDepartment(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.addLoading = false;
                  this.departmentEditorVisible = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["ruleForm"].resetFields();

                  this.$refs.child.refreshMethod(this.CurrentDepartment.value);
                  this.loadDepartmentOptions();

                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    openBatchBigTypeDialog() {
      if (!this.isClassList || !this.selectedClassRows.length) {
        this.$message({ message: '请先勾选需要更换类型的班级', type: 'warning' });
        return;
      }
      if (!this.currentSchoolSchId) {
        this.$message({ message: '当前组织缺少学校标识，无法批量更换', type: 'error' });
        return;
      }
      this.batchBigType = 1;
      this.batchBigTypeVisible = true;
    },

    openUpgradeRuleDialog() {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId) {
        this.$message({ message: '当前学校缺少 SchId，无法配置升班规则', type: 'error' });
        return;
      }

      this.upgradeRuleVisible = true;
      this.upgradeRuleLoading = true;
      this.unbindOptionsLoading = true;
      this.upgradeRuleConfig = { SchId: schId, SchoolName: this.CurrentDepartment.label || '', Rules: [] };
      const schoolId = this.CurrentDepartment && this.CurrentDepartment.value;
      getEnrollmentUnbindOptions(schoolId).then((res) => {
        this.unbindOptionsLoading = false;
        if (res && res.data && res.data.success && res.data.response) {
          this.unbindOptions = Object.assign({}, this.unbindOptions, res.data.response);
        }
      }).catch(() => {
        this.unbindOptionsLoading = false;
      });
      getStudentUpgradeRules(schId).then((res) => {
        this.upgradeRuleLoading = false;
        if (res && res.data && res.data.success) {
          const config = res.data.response || {};
          config.Rules = (config.Rules || []).map(rule => this.normalizeUpgradeRuleRow(rule));
          this.upgradeRuleConfig = config;
          return;
        }
        const message = res && res.data ? res.data.msg : '获取升班配置失败';
        this.$message({ message, type: 'error' });
      }).catch(() => {
        this.upgradeRuleLoading = false;
      });
    },

    saveUpgradeRules() {
      const invalidRule = (this.upgradeRuleConfig.Rules || []).find(rule => {
        if (!rule.Enabled) return false;
        const grades = rule.Grades || [];
        return grades.length < 2
          || String(rule.EntryGradeDepartmentId || '') !== String(grades[0].DepartmentId)
          || String(rule.GraduateGradeDepartmentId || '') !== String(grades[grades.length - 1].DepartmentId);
      });
      if (invalidRule) {
        this.$message({
          message: `升班范围“${invalidRule.ScopeName || invalidRule.PeriodName}”的入学年级和毕业年级必须分别是年级顺序的第一项和最后一项`,
          type: 'warning'
        });
        return;
      }

      const params = {
        SchId: this.upgradeRuleConfig.SchId,
        Rules: this.upgradeRuleConfig.Rules.map(rule => ({
          PeriodDepartmentId: rule.PeriodDepartmentId,
          EntryGradeDepartmentId: rule.EntryGradeDepartmentId || 0,
          GraduateGradeDepartmentId: rule.GraduateGradeDepartmentId || 0,
          Enabled: !!rule.Enabled,
          RowVersion: rule.RowVersion || 0
        }))
      };
      this.upgradeRuleSaving = true;
      const schoolId = this.CurrentDepartment && this.CurrentDepartment.value;
      Promise.all([
        saveStudentUpgradeRules(params),
        saveEnrollmentUnbindOptions({ SchoolId: schoolId, Options: this.unbindOptions })
      ]).then(([res]) => {
        this.upgradeRuleSaving = false;
        if (res && res.data && res.data.success) {
          const config = res.data.response || {};
          config.Rules = (config.Rules || []).map(rule => this.normalizeUpgradeRuleRow(rule));
          this.upgradeRuleConfig = config;
          this.$message({ message: res.data.msg || '保存成功', type: 'success' });
          return;
        }
        const message = res && res.data ? res.data.msg : '保存升班配置失败';
        this.$message({ message, type: 'error' });
      }).catch(() => {
        this.upgradeRuleSaving = false;
      });
    },

    applyBatchBigType() {
      const targetName = this.batchBigType === 1 ? '家校通讯录' : '内部通讯录';
      const departmentIds = this.selectedClassRows
        .map(row => Number(row.value || row.Id))
        .filter(id => Number.isFinite(id) && id > 0);
      if (!departmentIds.length) {
        this.$message({ message: '请先勾选需要更换类型的班级', type: 'warning' });
        return;
      }
      this.$confirm(`确认将选中的 ${departmentIds.length} 个班级调整为${targetName}吗？`, '批量更换类型', {
        type: 'warning'
      }).then(() => {
        this.batchBigTypeSaving = true;
        return batchUpdateClassBigType({
          SchId: this.currentSchoolSchId,
          DepartmentIds: departmentIds,
          TargetBigType: this.batchBigType
        });
      }).then((res) => {
        this.batchBigTypeSaving = false;
        if (!res) return;
        if (res.data && res.data.success) {
          this.batchBigTypeVisible = false;
          this.$message({ message: res.data.msg || '批量调整成功', type: 'success' });
          this.clearClassSelection();
          this.$refs.child.refreshMethod(this.CurrentDepartment.value);
          this.loadDepartmentOptions();
          return;
        }
        this.$message({ message: res.data ? res.data.msg : '批量调整失败', type: 'error' });
      }).catch(() => {
        this.batchBigTypeSaving = false;
      });
    },

    openAnnualUpgradeDialog() {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId) {
        this.$message({ message: '当前学校缺少 SchId，无法执行年度升班', type: 'error' });
        return;
      }
      this.annualSchoolName = this.CurrentDepartment.label || '';
      const now = new Date();
      this.annualAcademicYear = now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
      this.annualPreview = null;
      this.annualPreviewTab = 'summary';
      this.annualRequestId = '';
      this.annualUpgradeVisible = true;
      this.loadAnnualUpgradePreview();
    },

    loadAnnualUpgradePreview() {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId || this.annualPreviewLoading) return;
      this.annualPreviewLoading = true;
      this.annualPreview = null;
      this.annualRequestId = '';
      previewAnnualUpgrade({
        SchId: schId,
        AcademicYearStart: this.annualAcademicYear
      }).then((res) => {
        this.annualPreviewLoading = false;
        if (res && res.data && res.data.success) {
          this.annualPreview = res.data.response || null;
          this.annualRequestId = this.createRequestId();
          return;
        }
        this.$message({
          message: res && res.data ? res.data.msg : '年度升班预演失败',
          type: 'error'
        });
      }).catch(() => {
        this.annualPreviewLoading = false;
      });
    },

    confirmAnnualUpgrade() {
      const preview = this.annualPreview;
      if (!preview || !preview.CanExecute || this.annualExecuting) return;
      const defaultReason = `${preview.AcademicYearName} 学年全校升班`;
      let confirmBalance = false;
      this.askBalanceArchiveConfirm(preview).then((ok) => {
        confirmBalance = ok;
        return this.$prompt(
          `将处理 ${preview.AffectedClassCount} 个班级、${preview.AffectedStudentCount} 名在读学生，其中 ${preview.GraduatedStudentCount} 名学生毕业。请输入执行原因。`,
          '确认执行年度升班',
          {
            confirmButtonText: '确认执行',
            cancelButtonText: '取消',
            inputValue: defaultReason,
            inputPlaceholder: '请输入执行原因',
            inputValidator: value => {
              const reason = String(value || '').trim();
              if (!reason) return '执行原因不能为空';
              if (reason.length > 500) return '执行原因不能超过 500 个字符';
              return true;
            },
            type: 'warning'
          }
        );
      }).then(({ value }) => {
        this.annualExecuting = true;
        return executeAnnualUpgrade({
          SchId: preview.SchId,
          AcademicYearStart: preview.AcademicYearStart,
          PreviewToken: preview.PreviewToken,
          SnapshotHash: preview.SnapshotHash,
          RequestId: this.annualRequestId,
          Reason: String(value || '').trim(),
          ConfirmBalanceArchive: confirmBalance
        });
      }).then((res) => {
        if (!res) return;
        this.annualExecuting = false;
        if (res.data && res.data.success) {
          const result = res.data.response || {};
          this.$message({
            message: `${res.data.msg || '年度升班执行成功'}，批次号：${result.BatchId || '-'}`,
            type: 'success',
            duration: 5000
          });
          this.annualUpgradeVisible = false;
          this.annualPreview = null;
          this.reloadDepartmentTreeAfterUpgrade();
          return;
        }
        this.$message({ message: res.data ? res.data.msg : '年度升班执行失败', type: 'error' });
      }).catch(() => {
        this.annualExecuting = false;
      });
    },

    createRequestId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
        const random = Math.floor(Math.random() * 16);
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
      });
    },

    annualActionText(actionType) {
      return this.isGraduateAction(actionType) ? '毕业归档并删除' : '年级原地升级';
    },

    isGraduateAction(actionType) {
      return actionType === 2 || actionType === 'GraduateArchive';
    },

    openUpgradeBatchDialog() {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId) {
        this.$message({ message: '当前学校缺少 SchId，无法查看结转日志', type: 'error' });
        return;
      }
      this.outboxSchoolName = this.CurrentDepartment.label || '';
      this.upgradeBatchPageIndex = 1;
      this.upgradeBatchOpFilter = 0;
      this.upgradeBatchItems = [];
      this.upgradeBatchVisible = true;
      this.loadUpgradeBatchPage();
    },

    onUpgradeBatchFilterChange() {
      this.upgradeBatchPageIndex = 1;
      this.loadUpgradeBatchPage();
    },

    loadUpgradeBatchPage() {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId || this.upgradeBatchLoading) return;
      this.upgradeBatchLoading = true;
      const params = {
        SchId: schId,
        PageIndex: this.upgradeBatchPageIndex,
        PageSize: this.upgradeBatchPageSize
      };
      if (this.upgradeBatchOpFilter === 1 || this.upgradeBatchOpFilter === 2 || this.upgradeBatchOpFilter === 5) {
        params.OperationType = this.upgradeBatchOpFilter;
      }
      getStudentUpgradeBatchPage(params).then((res) => {
        this.upgradeBatchLoading = false;
        if (res && res.data && res.data.success) {
          const page = res.data.response || {};
          this.upgradeBatchItems = page.data || [];
          this.upgradeBatchTotal = page.dataCount || 0;
          return;
        }
        this.$message({ message: res && res.data ? res.data.msg : '获取结转日志失败', type: 'error' });
      }).catch(() => {
        this.upgradeBatchLoading = false;
      });
    },

    isClassTransferBatch(row) {
      const op = row && row.OperationType;
      return op === 2 || op === '2' || op === 'ClassGraduation';
    },

    upgradeBatchTypeLabel(row) {
      const op = Number(row && row.OperationType);
      if (op === 2) return '单班结转';
      if (op === 5) return '年级结转';
      if (op === 1) return '全校升班';
      return '其它';
    },

    upgradeBatchTypeTag(row) {
      const op = Number(row && row.OperationType);
      if (op === 2) return 'warning';
      if (op === 5) return 'danger';
      return '';
    },

    openGradeTransferDialog() {
      const schId = this.currentSchoolSchId;
      const gradeId = this.CurrentDepartment && Number(this.CurrentDepartment.value);
      if (!schId) {
        this.$message({ message: '无法识别学校 SchId，请从学校节点进入后选择年级', type: 'error' });
        return;
      }
      if (!gradeId) {
        this.$message({ message: '当前年级无效', type: 'error' });
        return;
      }
      if (!this.currentDepartmentRows.length) {
        this.$message({ message: '该年级下没有可结转的班级', type: 'warning' });
        return;
      }
      this.gradeTransferGradeId = gradeId;
      this.gradeTransferGradeName = this.CurrentDepartment.label || this.CurrentDepartment.Name || '';
      this.gradeTransferPreview = null;
      this.gradeTransferTab = 'summary';
      this.gradeTransferRequestId = '';
      const now = new Date();
      this.annualAcademicYear = now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
      this.gradeTransferVisible = true;
      this.loadGradeTransferPreview();
    },

    loadGradeTransferPreview() {
      const schId = this.currentSchoolSchId;
      if (!schId || !this.gradeTransferGradeId || this.gradeTransferLoading) return;
      this.gradeTransferLoading = true;
      this.gradeTransferPreview = null;
      this.gradeTransferRequestId = '';
      previewGradeTransfer({
        SchId: schId,
        GradeDepartmentId: this.gradeTransferGradeId,
        AcademicYearStart: this.annualAcademicYear
      }).then((res) => {
        this.gradeTransferLoading = false;
        if (res && res.data && res.data.success) {
          this.gradeTransferPreview = res.data.response || null;
          this.gradeTransferRequestId = this.createRequestId();
          return;
        }
        this.$message({
          message: res && res.data ? res.data.msg : '年级结转预演失败',
          type: 'error'
        });
      }).catch(() => {
        this.gradeTransferLoading = false;
      });
    },

    confirmGradeTransfer() {
      const preview = this.gradeTransferPreview;
      if (!preview || !preview.CanExecute || this.gradeTransferExecuting) return;
      const isGraduate = (preview.GraduatedClassCount || 0) > 0;
      const classCount = preview.AffectedClassCount || 0;
      const defaultReason = isGraduate
        ? `${preview.AcademicYearName} 学年年级毕业结转 - ${this.gradeTransferGradeName}`
        : `${preview.AcademicYearName} 学年年级升班 - ${this.gradeTransferGradeName}`;
      let confirmBalance = false;
      this.askBalanceArchiveConfirm(preview).then((ok) => {
        confirmBalance = ok;
        return this.$prompt(
          isGraduate
            ? `将归档年级「${this.gradeTransferGradeName}」下 ${classCount} 个班级，${preview.GraduatedStudentCount || 0} 名学生进入毕业档案。请输入执行原因。`
            : `将把年级「${this.gradeTransferGradeName}」下 ${classCount} 个班级按规则升班改名。请输入执行原因。`,
          '确认执行年级结转',
          {
            confirmButtonText: '确认执行',
            cancelButtonText: '取消',
            inputValue: defaultReason,
            inputPlaceholder: '请输入执行原因',
            inputValidator: value => {
              const reason = String(value || '').trim();
              if (!reason) return '执行原因不能为空';
              if (reason.length > 500) return '执行原因不能超过 500 个字符';
              return true;
            },
            type: 'warning'
          }
        );
      }).then(({ value }) => {
        this.gradeTransferExecuting = true;
        return executeGradeTransfer({
          SchId: preview.SchId,
          GradeDepartmentId: this.gradeTransferGradeId,
          AcademicYearStart: preview.AcademicYearStart,
          PreviewToken: preview.PreviewToken,
          SnapshotHash: preview.SnapshotHash,
          RequestId: this.gradeTransferRequestId,
          Reason: String(value || '').trim(),
          ConfirmBalanceArchive: confirmBalance
        });
      }).then((res) => {
        if (!res) return;
        this.gradeTransferExecuting = false;
        if (res.data && res.data.success) {
          const result = res.data.response || {};
          this.$message({
            message: `${res.data.msg || '年级结转执行成功'}，批次号：${result.BatchId || '-'}`,
            type: 'success',
            duration: 5000
          });
          this.gradeTransferVisible = false;
          this.gradeTransferPreview = null;
          this.reloadDepartmentTreeAfterUpgrade();
          return;
        }
        this.$message({ message: res.data ? res.data.msg : '年级结转执行失败', type: 'error' });
      }).catch(() => {
        this.gradeTransferExecuting = false;
      });
    },

    /**
     * 从树节点向上解析学校 SchId（班级等子节点本身常无 SchId）。
     */
    resolveSchIdFromTreeNode(node, data) {
      let schId = (data && data.SchId) || '';
      let tempNode = node;
      let guard = 0;
      while (tempNode && guard++ < 64) {
        if (tempNode.data && tempNode.data.SchId) {
          schId = tempNode.data.SchId;
          if (String(tempNode.data.DeptOrgType || '').toLowerCase() === 'school') break;
        }
        tempNode = tempNode.parent;
      }
      if (schId) return schId;
      // 无树节点时在部门树中按 Pid 回溯学校
      const byId = {};
      const collect = (list) => {
        (list || []).forEach((item) => {
          if (!item) return;
          byId[item.value] = item;
          if (item.children && item.children.length) collect(item.children);
        });
      };
      collect(this.departmentTreeOptions || []);
      if (this.departmentTree) byId[this.departmentTree.value] = this.departmentTree;
      let current = data && data.value != null ? (byId[data.value] || data) : data;
      guard = 0;
      while (current && guard++ < 64) {
        if (current.SchId) return current.SchId;
        const pid = current.Pid;
        if (!pid || !byId[pid]) break;
        current = byId[pid];
      }
      return (this.departmentTree && this.departmentTree.SchId) || '';
    },

    openClassTransferDialog() {
      const schId = this.currentSchoolSchId;
      const classId = this.CurrentDepartment && Number(this.CurrentDepartment.value);
      if (!schId) {
        this.$message({ message: '无法识别学校 SchId，请从学校节点进入后选择班级', type: 'error' });
        return;
      }
      if (!classId) {
        this.$message({ message: '当前班级无效', type: 'error' });
        return;
      }
      this.classTransferClassId = classId;
      this.classTransferClassName = this.CurrentDepartment.label || this.CurrentDepartment.Name || '';
      this.classTransferPreview = null;
      this.classTransferTab = 'summary';
      this.classTransferRequestId = '';
      const now = new Date();
      this.annualAcademicYear = now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
      this.classTransferVisible = true;
      this.loadClassTransferPreview();
    },

    loadClassTransferPreview() {
      const schId = this.currentSchoolSchId;
      if (!schId || !this.classTransferClassId || this.classTransferLoading) return;
      this.classTransferLoading = true;
      this.classTransferPreview = null;
      this.classTransferRequestId = '';
      previewClassTransfer({
        SchId: schId,
        ClassDepartmentId: this.classTransferClassId,
        AcademicYearStart: this.annualAcademicYear
      }).then((res) => {
        this.classTransferLoading = false;
        if (res && res.data && res.data.success) {
          this.classTransferPreview = res.data.response || null;
          this.classTransferRequestId = this.createRequestId();
          return;
        }
        this.$message({
          message: res && res.data ? res.data.msg : '班级结转预演失败',
          type: 'error'
        });
      }).catch(() => {
        this.classTransferLoading = false;
      });
    },

    confirmClassTransfer() {
      const preview = this.classTransferPreview;
      if (!preview || !preview.CanExecute || this.classTransferExecuting) return;
      const classRow = (preview.Classes && preview.Classes[0]) || {};
      const isGraduate = this.isGraduateAction(classRow.ActionType);
      const defaultReason = isGraduate
        ? `${preview.AcademicYearName} 学年单班毕业结转 - ${this.classTransferClassName}`
        : `${preview.AcademicYearName} 学年单班升班 - ${this.classTransferClassName}`;
      let confirmBalance = false;
      this.askBalanceArchiveConfirm(preview).then((ok) => {
        confirmBalance = ok;
        return this.$prompt(
          isGraduate
            ? `将归档班级「${this.classTransferClassName}」，${preview.GraduatedStudentCount || 0} 名学生进入毕业档案。请输入执行原因。`
            : `将把「${this.classTransferClassName}」升级为「${classRow.TargetClassName || ''}」。请输入执行原因。`,
          '确认执行班级结转',
          {
            confirmButtonText: '确认执行',
            cancelButtonText: '取消',
            inputValue: defaultReason,
            inputPlaceholder: '请输入执行原因',
            inputValidator: value => {
              const reason = String(value || '').trim();
              if (!reason) return '执行原因不能为空';
              if (reason.length > 500) return '执行原因不能超过 500 个字符';
              return true;
            },
            type: 'warning'
          }
        );
      }).then(({ value }) => {
        this.classTransferExecuting = true;
        return executeClassTransfer({
          SchId: preview.SchId,
          ClassDepartmentId: this.classTransferClassId,
          AcademicYearStart: preview.AcademicYearStart,
          PreviewToken: preview.PreviewToken,
          SnapshotHash: preview.SnapshotHash,
          RequestId: this.classTransferRequestId,
          Reason: String(value || '').trim(),
          ConfirmBalanceArchive: confirmBalance
        });
      }).then((res) => {
        if (!res) return;
        this.classTransferExecuting = false;
        if (res.data && res.data.success) {
          const result = res.data.response || {};
          this.$message({
            message: `${res.data.msg || '班级结转执行成功'}，批次号：${result.BatchId || '-'}`,
            type: 'success',
            duration: 5000
          });
          this.classTransferVisible = false;
          this.classTransferPreview = null;
          this.reloadDepartmentTreeAfterUpgrade();
          return;
        }
        this.$message({ message: res.data ? res.data.msg : '班级结转执行失败', type: 'error' });
      }).catch(() => {
        this.classTransferExecuting = false;
      });
    },

    handleBatchPageChange(page) {
      this.upgradeBatchPageIndex = page;
      this.loadUpgradeBatchPage();
    },

    handleBatchSizeChange(size) {
      this.upgradeBatchPageSize = size;
      this.upgradeBatchPageIndex = 1;
      this.loadUpgradeBatchPage();
    },

    formatBatchTime(row, column, cellValue) {
      if (!cellValue) return '-';
      const date = new Date(cellValue);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },

    formatBatchYear(row) {
      if (!row || row.AcademicYearStart == null || row.AcademicYearStart === '') return '-';
      return `${row.AcademicYearStart}-${Number(row.AcademicYearStart) + 1} 学年`;
    },

    isBatchSucceeded(row) {
      const status = row && row.BatchStatus;
      return status === 'Succeeded' || status === 2 || status === '2';
    },

    // 默认原因与学年重复时不展示，仅保留自定义说明
    batchReasonExtra(row) {
      const reason = row && row.Reason ? String(row.Reason).trim() : '';
      if (!reason) return '';
      const yearText = this.formatBatchYear(row);
      const defaults = [
        `${yearText}全校升班`,
        `${yearText} 全校升班`,
        yearText
      ];
      if (defaults.some(item => reason === item || reason.replace(/\s/g, '') === String(item).replace(/\s/g, ''))) {
        return '';
      }
      return reason;
    },

    showBatchDetail(row) {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId) return;
      this.batchDetailItems = [];
      this.batchDetailKeyword = '';
      this.batchDetailBatchId = row.Id;
      this.batchDetailVisible = true;
      this.batchDetailLoading = true;
      getStudentUpgradeBatchDetails(row.Id, schId).then((res) => {
        this.batchDetailLoading = false;
        if (res && res.data && res.data.success) {
          this.batchDetailItems = res.data.response || [];
          return;
        }
        this.$message({ message: res && res.data ? res.data.msg : '获取结转明细失败', type: 'error' });
      }).catch(() => {
        this.batchDetailLoading = false;
      });
    },

    showBatchStudentDialog(row) {
      if (!row || !(row.StudentCount > 0)) return;
      this.batchStudentSourceDeptId = row.SourceDepartmentId;
      this.batchStudentSourceName = row.SourceDepartmentName || '班级';
      this.batchStudentPageIndex = 1;
      this.batchStudentKeyword = '';
      this.batchStudentItems = [];
      this.batchStudentTotal = 0;
      this.batchStudentVisible = true;
      this.loadBatchStudents(1);
    },

    /**
     * 学生快照搜索防抖后重新拉第一页。最后更新：2026-10-22
     */
    onBatchStudentKeywordInput() {
      if (this.batchStudentSearchTimer) {
        clearTimeout(this.batchStudentSearchTimer);
      }
      this.batchStudentSearchTimer = setTimeout(() => {
        this.batchStudentPageIndex = 1;
        this.loadBatchStudents(1);
      }, 300);
    },

    loadBatchStudents(page) {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId || !this.batchDetailBatchId || !this.batchStudentSourceDeptId) return;
      const pageIndex = page || this.batchStudentPageIndex || 1;
      this.batchStudentPageIndex = pageIndex;
      this.batchStudentLoading = true;
      const params = {
        SchId: schId,
        BatchId: this.batchDetailBatchId,
        SourceDepartmentId: this.batchStudentSourceDeptId,
        PageIndex: pageIndex,
        PageSize: this.batchStudentPageSize
      };
      const keyword = String(this.batchStudentKeyword || '').trim();
      if (keyword) params.Keyword = keyword;
      getStudentUpgradeBatchStudentDetails(params).then((res) => {
        this.batchStudentLoading = false;
        if (!(res && res.data && res.data.success)) {
          this.$message.error((res && res.data && res.data.msg) || '获取学生快照失败');
          return;
        }
        const pageData = res.data.response || {};
        this.batchStudentItems = pageData.data || pageData.Data || [];
        this.batchStudentTotal = pageData.dataCount != null ? pageData.dataCount : (pageData.DataCount || 0);
      }).catch(() => {
        this.batchStudentLoading = false;
      });
    },

    /**
     * 预演明细中点击学生人数，展示该班在读学生名单。
     */
    openPreviewStudentDialog(row) {
      if (!row || !(row.ActiveStudentCount > 0)) return;
      const students = Array.isArray(row.Students) ? row.Students : [];
      this.previewStudentClassName = row.SourceClassName || '班级';
      this.previewStudentTargetText = this.isGraduateAction(row.ActionType)
        ? '毕业档案（归档删除）'
        : (row.TargetClassName || '下一年级目标班');
      this.previewStudentItems = students.slice();
      this.previewStudentPageIndex = 1;
      this.previewStudentVisible = true;
      if (!students.length && row.ActiveStudentCount > 0) {
        this.$message.warning('预演未返回学生名单，请重新预演后再试');
      }
    },

    previewStudentIndex(index) {
      return (this.previewStudentPageIndex - 1) * this.previewStudentPageSize + index + 1;
    },

    /**
     * 打开预演中账户仍有余额的毕业学生完整名单。创建于 2026-10-10
     */
    openBalanceStudentDialog(preview, confirmMode = false) {
      this.balanceStudentItems = ((preview && preview.BalanceStudents) || []).slice();
      this.balanceStudentTotal = (preview && preview.BalanceTotal) || 0;
      this.balanceStudentKeyword = '';
      this.balanceStudentPageIndex = 1;
      this.balanceStudentConfirmMode = confirmMode;
      // 弹窗内除表格外（标题、提示、搜索、分页、按钮）约占 330px，表格最高 420、最低 200
      this.balanceStudentTableMaxHeight = Math.max(200, Math.min(420, window.innerHeight * 0.84 - 330));
      this.balanceStudentVisible = true;
    },

    balanceStudentIndex(index) {
      return (this.balanceStudentPageIndex - 1) * this.balanceStudentPageSize + index + 1;
    },

    /** 余额确认弹窗点击「继续」。创建于 2026-10-10 */
    confirmBalanceStudentDialog() {
      const resolver = this.balanceStudentResolver;
      this.balanceStudentResolver = null;
      this.balanceStudentVisible = false;
      if (resolver) resolver.resolve(true);
    },

    /** 余额弹窗关闭：确认模式下未点「继续」即视为取消。创建于 2026-10-10 */
    onBalanceStudentDialogClosed() {
      const resolver = this.balanceStudentResolver;
      this.balanceStudentResolver = null;
      this.balanceStudentConfirmMode = false;
      if (resolver) resolver.reject('cancel');
    },

    /**
     * 金额格式化（保留两位小数）。创建于 2026-10-10
     */
    formatMoney(value) {
      const num = Number(value || 0);
      return Number.isFinite(num) ? num.toFixed(2) : '0.00';
    },

    /**
     * 结转执行前：毕业学生仍有余额时弹出表格名单（可搜索、分页），用户确认后才允许归档。
     * 无余额 resolve(false)；确认 resolve(true)；取消 reject('cancel')。最后修改：2026-10-10
     */
    askBalanceArchiveConfirm(preview) {
      const count = (preview && preview.BalanceStudentCount) || 0;
      if (!count) return Promise.resolve(false);
      return new Promise((resolve, reject) => {
        this.balanceStudentResolver = { resolve, reject };
        this.openBalanceStudentDialog(preview, true);
      });
    },

    // 删除结转批次：全校批次可解除同学年锁定；单班批次仅删日志。均不回滚业务数据。
    deleteUpgradeBatch(row) {
      const schId = this.CurrentDepartment && this.CurrentDepartment.SchId;
      if (!schId || !row || !row.Id) return;
      const yearText = row.AcademicYearStart
        ? `${row.AcademicYearStart}-${row.AcademicYearStart + 1} 学年`
        : '该批次';
      const unlockHint = this.isClassTransferBatch(row)
        ? '不会回滚已改名的班级、已归档学生；单班结转本就不占用全校同学年锁。'
        : '不会回滚已改名的班级、已归档学生；删除后可再次执行同学年全校升班。';
      this.$confirm(
        `确认删除${yearText}结转记录（批次 ${row.Id}）？${unlockHint}`,
        '删除结转批次',
        { type: 'warning', confirmButtonText: '确认删除', cancelButtonText: '取消' }
      ).then(() => {
        this.deletingBatchId = row.Id;
        return deleteStudentUpgradeBatch({ SchId: schId, BatchId: row.Id });
      }).then((res) => {
        this.deletingBatchId = 0;
        if (!res) return;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '已删除，可再次操作升班');
          this.loadUpgradeBatchPage();
          return;
        }
        this.$message.error((res.data && res.data.msg) || '删除失败');
      }).catch(() => {
        this.deletingBatchId = 0;
      });
    },

    upgradeStatusType(status) {
      const types = { saved: 'success', changed: 'warning', invalid: 'danger', unconfigured: 'info' };
      return types[status] || 'info';
    },

    // 已停用用灰色，避免误用红色强调
    upgradeRuleStatusType(row) {
      if (!row) return 'info';
      if (!row.Enabled && (row.ConfigStatus === 'saved' || row.ConfigMessage === '已停用')) {
        return 'info';
      }
      return this.upgradeStatusType(row.ConfigStatus);
    },

    formatGradeSequence(row) {
      const grades = (row && row.Grades) || [];
      if (!grades.length) return '暂无年级';
      return grades.map(item => item.Name).join(' → ');
    },

    /**
     * 规范化升班规则行：年级 ID 统一为字符串；不在当前 Grades 中则留空，并保留原 ID 供红色提示。
     */
    normalizeUpgradeRuleRow(rule) {
      const source = rule || {};
      const grades = (source.Grades || []).map(grade => Object.assign({}, grade, {
        DepartmentId: grade.DepartmentId == null || grade.DepartmentId === ''
          ? grade.DepartmentId
          : String(grade.DepartmentId)
      }));
      const gradeIdSet = new Set(grades.map(grade => String(grade.DepartmentId)));
      const resolveGradeId = (raw) => {
        if (raw == null || raw === '' || raw === 0 || raw === '0') {
          return { value: null, invalidId: null };
        }
        const id = String(raw);
        return gradeIdSet.has(id)
          ? { value: id, invalidId: null }
          : { value: null, invalidId: id };
      };
      const entry = resolveGradeId(source.EntryGradeDepartmentId);
      const graduate = resolveGradeId(source.GraduateGradeDepartmentId);
      return Object.assign({}, source, {
        Grades: grades,
        EntryGradeDepartmentId: entry.value,
        GraduateGradeDepartmentId: graduate.value,
        InvalidEntryGradeDepartmentId: entry.invalidId,
        InvalidGraduateGradeDepartmentId: graduate.invalidId
      });
    },

    // 重新选择后清除对应失效提示
    clearInvalidUpgradeGrade(row, kind) {
      if (!row) return;
      if (kind === 'entry') row.InvalidEntryGradeDepartmentId = null;
      if (kind === 'graduate') row.InvalidGraduateGradeDepartmentId = null;
    },

    // 启用时自动对齐入学/毕业为顺序首尾，减少配反
    onUpgradeRuleEnabledChange(row) {
      if (!row || !row.Enabled) return;
      const grades = row.Grades || [];
      if (grades.length < 1) return;
      row.EntryGradeDepartmentId = grades[0].DepartmentId;
      row.GraduateGradeDepartmentId = grades[grades.length - 1].DepartmentId;
      row.InvalidEntryGradeDepartmentId = null;
      row.InvalidGraduateGradeDepartmentId = null;
    },

    upgradeStatusText(status) {
      const texts = { saved: '已保存', changed: '结构已变化', invalid: '配置无效', unconfigured: '未配置' };
      return texts[status] || '未配置';
    },

    upgradeScopeTypeText(type) {
      const texts = { school: '学校', campus: '校区', period: '学段' };
      return texts[String(type || '').toLowerCase()] || '范围';
    },

    //删除：优先删表格勾选的下级；否则删当前节点
    handleDel() {
      if (this.selectedClassRows && this.selectedClassRows.length) {
        this.deleteDepartmentRows(this.selectedClassRows.slice());
        return;
      }

      const row = this.CurrentDepartment;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });
        return;
      }

      const childCount = (this.currentDepartmentRows || []).length;
      if (childCount > 0) {
        this.$message({
          message: `当前选中的是「${row.label || '该节点'}」，其下还有 ${childCount} 个下级。请勾选要删除的班级后点删除，或进入班级后再删。`,
          type: "warning",
          duration: 5000
        });
        return;
      }

      this.deleteDepartmentRows([row]);
    },

    // 表格行删除
    deleteDepartmentRow(row) {
      if (!row) return;
      this.deleteDepartmentRows([row]);
    },

    // 批量删除勾选的班级
    batchDeleteSelectedClasses() {
      if (!this.selectedClassRows || !this.selectedClassRows.length) {
        this.$message.warning('请先勾选要删除的班级');
        return;
      }
      this.deleteDepartmentRows(this.selectedClassRows.slice(), { isClassBatch: true });
    },

    deleteDepartmentRows(rows, options = {}) {
      const targets = (rows || []).filter(row => row && (row.value || row.Id));
      if (!targets.length) {
        this.$message({ message: "请选择要删除的组织", type: "error" });
        return;
      }

      const names = targets.map(row => row.label || row.Name || row.value).join('、');
      const isClassBatch = !!options.isClassBatch || (
        targets.length > 1 && targets.every(row => String(row.DeptOrgType || '').toLowerCase() === 'class')
      );
      let tip;
      if (targets.length === 1) {
        tip = `确认删除「${names}」吗？`;
      } else if (isClassBatch) {
        tip = `确认批量删除已选的 ${targets.length} 个班级吗？\n${names}`;
      } else {
        tip = `确认删除已选的 ${targets.length} 个组织（${names}）吗？`;
      }

      this.$confirm(tip, "提示", {
        type: "warning",
        customClass: isClassBatch ? 'dept-batch-delete-confirm' : ''
      })
        .then(async () => {
          this.addLoading = true;
          let successCount = 0;
          let failCount = 0;
          let lastError = '';
          for (let i = 0; i < targets.length; i += 1) {
            const target = targets[i];
            const id = target.value || target.Id;
            try {
              const res = await removeDepartment({ id });
              if (util.isEmt.format(res)) {
                failCount += 1;
                continue;
              }
              if (res.data && res.data.success) {
                successCount += 1;
              } else {
                failCount += 1;
                lastError = (res.data && res.data.msg) || '删除失败';
              }
            } catch (e) {
              failCount += 1;
              lastError = '删除失败';
            }
          }
          this.addLoading = false;
          if (successCount > 0) {
            this.$message({
              message: targets.length === 1
                ? "删除成功"
                : (failCount > 0
                  ? `成功删除 ${successCount} 个，失败 ${failCount} 个`
                  : `成功删除 ${successCount} 个班级`),
              type: failCount > 0 ? "warning" : "success",
            });
            this.clearClassSelection();
            this.$refs.child && this.$refs.child.refreshMethod();
            this.loadDepartmentOptions();
          }
          if (lastError && successCount === 0) {
            this.$message({
              message: lastError,
              type: "error",
            });
          } else if (lastError && failCount > 0) {
            this.$message({
              message: `部分失败：${lastError}`,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },

    // 打开固定家校通讯录同步任务窗口。最后更新：2026-10-29
    handleSync() {
      let row = this.CurrentDepartment;
      if (!row) {
        this.$message({ message: "请选择要同步到的本地部门位置！", type: "error" });
        return;
      }
      this.syncDingVisible = true;
      this.syncMode = 'department';
      this.syncResourceType = 'Student';
      this.dingTreeData = [];
      this.dingTreeKey += 1;
      this.dingTreeFromCache = false;
      this.dingTreeCachedAt = '';
      this.dingTreeExpiresAt = '';
      this.syncScopeTreeNodes = [];
      this.syncScopeTreeExpandedKeys = [];
      this.syncScopeTreeKey += 1;
      this.$nextTick(() => this.fetchDingTree());
    },

    /** 切换组织导入或后台任务 */
    changeSyncMode(mode) {
      this.syncMode = mode;
      if (mode === 'department' && this.dingTreeData.length === 0) {
        this.$nextTick(() => this.fetchDingTree());
      }
      if (mode === 'task') {
        if (!this.syncScopeTreeNodes.length) {
          this.refreshSyncScopeTree();
        }
        this.$nextTick(() => this.initSyncScopeTreeSelection());
      }
    },
    /** 刷新同步范围树数据。最后更新：2026-08-30 */
    refreshSyncScopeTree() {
      this.syncScopeTreeNodes = this.resolveSyncScopeTreeNodes();
      this.syncScopeTreeExpandedKeys = this.syncScopeTreeNodes
        .map((node) => node && node.value)
        .filter((value) => value != null && value !== '')
        .map((value) => String(value));
    },
    /** 浅克隆组织树供弹窗内 el-tree 使用，避免污染左侧树。最后更新：2026-08-30 */
    cloneSyncScopeNode(node) {
      if (!node || typeof node !== 'object' || Array.isArray(node)) return node;
      return Object.assign({}, node, {
        children: (node.children || []).map((child) => this.cloneSyncScopeNode(child)),
      });
    },
    /** 从左侧组织树解析当前学校同步范围。最后更新：2026-08-30 */
    findSyncScopeSchoolNode(root) {
      const activeSchoolId = normalizeDeptId(this.currentSchoolDepartmentId)
        || resolveActiveSchoolId(this);
      const walk = (node) => {
        if (!node) return null;
        if (Array.isArray(node)) {
          for (let index = 0; index < node.length; index += 1) {
            const found = walk(node[index]);
            if (found) return found;
          }
          return null;
        }
        const orgType = String(node.DeptOrgType || node.deptOrgType || '').toLowerCase();
        const val = normalizeDeptId(node.value);
        if ((orgType === 'school' || orgType === 'affiliateschool')
          && (!activeSchoolId || deptIdsEqual(val, activeSchoolId))) {
          return node;
        }
        const children = node.children || [];
        for (let index = 0; index < children.length; index += 1) {
          const found = walk(children[index]);
          if (found) return found;
        }
        return null;
      };
      return walk(root);
    },
    /** 解析人员同步可选组织树节点。最后更新：2026-08-30 */
    resolveSyncScopeTreeNodes() {
      const pane = this.$refs.child;
      const menuNodes = pane && Array.isArray(pane.menus)
        ? pane.menus.filter((node) => normalizeDeptId(node && node.value))
        : [];
      if (menuNodes.length) {
        return menuNodes.map((node) => this.cloneSyncScopeNode(node));
      }
      if (this.departmentTree) {
        const schoolNode = this.findSyncScopeSchoolNode(this.departmentTree);
        return schoolNode ? [this.cloneSyncScopeNode(schoolNode)] : [];
      }
      return [];
    },
    /** 初始化人员同步范围树：默认不勾选，由用户自行选择。最后更新：2026-08-30 */
    initSyncScopeTreeSelection() {
      this.$nextTick(() => {
        const tree = this.$refs.syncScopeTree;
        if (!tree) return;
        tree.setCheckedKeys([]);
      });
    },
    /** 构建人员同步任务范围参数。最后更新：2026-08-30 */
    buildTeachingSyncScopePayload() {
      const tree = this.$refs.syncScopeTree;
      if (!tree) return null;
      const checkedNodes = tree.getCheckedNodes(false, false);
      if (!checkedNodes.length) return null;
      const schoolId = normalizeDeptId(this.currentSchoolDepartmentId);
      if (checkedNodes.length === 1 && deptIdsEqual(checkedNodes[0].value, schoolId)) {
        return { scopeType: 'School', scopeDepartmentIds: [] };
      }
      const scopeDepartmentIds = checkedNodes
        .map((node) => normalizeDeptId(node.value))
        .filter((id) => !!id);
      if (!scopeDepartmentIds.length) return null;
      return { scopeType: 'Department', scopeDepartmentIds };
    },

    /** 拉取钉钉家校通讯录组织树；forceRefresh 为 true 时跳过缓存。最后更新：2026-10-29 */
    fetchDingTree(forceRefresh = false) {
      const row = this.CurrentDepartment;
      if (!row || this.dingTreeLoading) return;
      this.dingTreeLoading = true;
      if (forceRefresh) {
        this.dingTreeData = [];
        this.dingTreeKey += 1;
        this.dingTreeFromCache = false;
        this.dingTreeCachedAt = '';
        this.dingTreeExpiresAt = '';
      }
      getDingDingDepartmentTree({
        id: row.value,
        type: this.syncDingType,
        forceRefresh: !!forceRefresh,
      }).then((res) => {
        if (util.isEmt.format(res)) return;
        if (res.data.success) {
          this.applyDingTreePayload(res.data.response);
        } else {
          this.$message({ message: res.data.msg, type: "error" });
        }
      }).finally(() => {
        this.dingTreeLoading = false;
        this.$nextTick(() => this.clearDingTreeCheckedKeys());
      });
    },
    /** 清空钉钉组织树勾选，避免跨次打开残留。最后更新：2026-10-29 */
    clearDingTreeCheckedKeys() {
      const dingTree = this.$refs.dingTree;
      if (dingTree && typeof dingTree.setCheckedKeys === 'function') {
        dingTree.setCheckedKeys([]);
      }
    },
    /** 解析钉钉组织树响应（兼容新旧结构）。最后更新：2026-10-29 */
    applyDingTreePayload(payload) {
      if (!payload) {
        this.dingTreeData = [];
        return;
      }
      if (Array.isArray(payload)) {
        this.dingTreeData = payload;
        this.dingTreeFromCache = false;
        this.dingTreeCachedAt = '';
        this.dingTreeExpiresAt = '';
        return;
      }
      this.dingTreeData = payload.Tree || payload.tree || [];
      this.dingTreeFromCache = !!(payload.FromCache != null ? payload.FromCache : payload.fromCache);
      this.dingTreeCachedAt = payload.CachedAt || payload.cachedAt || '';
      this.dingTreeExpiresAt = payload.ExpiresAt || payload.expiresAt || '';
    },
    formatDingTreeCacheTime(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      const pad = (num) => String(num).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    /** 将勾选的钉钉分支导入当前本地节点。最后更新：2026-10-29 */
    confirmSyncDing() {
      if (this.dingTreeLoading) {
        this.$message({ message: "钉钉组织加载中，请稍后再提交", type: "warning" });
        return;
      }
      const dingTree = this.$refs.dingTree;
      const checkedNodes = dingTree ? dingTree.getCheckedNodes(false, true) : [];
      if (!checkedNodes || checkedNodes.length === 0) {
        this.$message({ message: "请先勾选要同步的钉钉部门", type: "warning" });
        return;
      }

      const strictCheckedNodes = dingTree.getCheckedNodes(false, false);
      const row = this.CurrentDepartment;
      const para = {
        id: row.value,
        dingDeptId: checkedNodes.map(node => node.DeptId).join(','),
        type: this.syncDingType,
        strictDingDeptId: strictCheckedNodes.map(node => node.DeptId).join(',')
      };
      this.$confirm(`确认将所选钉钉分支导入到【${row.label}】下吗？`, "确认提交", {
        type: "warning",
        confirmButtonText: "提交任务",
        cancelButtonText: "取消"
      }).then(() => {
        this.dingSyncing = true;
        return syncSelectedDingDingDepartment(para);
      }).then((res) => {
        if (!res || util.isEmt.format(res)) return;
        if (res.data.success) {
          const taskId = res.data.response;
          this.$message.success(taskId
            ? `导入任务 ${taskId} 已提交`
            : (res.data.msg || "导入任务已提交"));
          this.syncDingVisible = false;
          this.taskCenterVisible = true;
          return;
        }
        this.$message({
          message: `${res.data.msg ? res.data.msg.replace(/\n/g, '<br>') : '导入失败'}`,
          type: 'error',
          dangerouslyUseHTMLString: true
        });
      }).catch(() => {}).finally(() => {
        this.dingSyncing = false;
      });
    },

    async submitTeachingSyncTask() {
      const row = this.CurrentDepartment;
      if (!row || !this.currentSchoolDepartmentId) {
        this.$message({ message: "未识别到当前节点所属学校", type: "warning" });
        return;
      }
      if (this.syncResourceType === 'Department') {
        this.$message.warning('组织请到「导入钉钉组织」勾选分支同步');
        this.syncMode = 'department';
        this.$nextTick(() => this.fetchDingTree());
        return;
      }
      const scopePayload = this.buildTeachingSyncScopePayload();
      if (!scopePayload) {
        this.$message.warning('请先勾选同步范围');
        return;
      }
      const resourceLabel = ({ Student: '学生', Teacher: '教师' })[this.syncResourceType] || '人员';
      const checkedNodes = this.$refs.syncScopeTree
        ? this.$refs.syncScopeTree.getCheckedNodes(false, false)
        : [];
      await this.$confirm(
        buildSyncScopeConfirmMessage(scopePayload, resourceLabel, {
          resourceType: this.syncResourceType,
          checkedNodes,
          countMode: 'class',
          rootId: Number(this.currentSchoolDepartmentId) || 0,
          flatDepartments: (this.departmentOptions || []).map((item) => ({
            id: String(item.value),
            pid: String(item.Pid || ''),
            name: item.label,
            deptOrgType: item.DeptOrgType,
          })),
        }),
        '提示',
        { type: 'warning' }
      );
      this.dingSyncing = true;
      try {
        const res = await submitDingTalkSyncTask({
          SchoolDepartmentId: this.currentSchoolDepartmentId,
          ResourceType: this.syncResourceType,
          BigType: 1,
          ScopeType: scopePayload.scopeType,
          ScopeDepartmentIds: scopePayload.scopeDepartmentIds,
        });
        if (!res.data || !res.data.success) {
          this.$message.error((res.data && res.data.msg) || '同步任务提交失败');
          return;
        }
        this.syncDingVisible = false;
        const taskId = res.data.response;
        this.$message.success(`同步任务 ${taskId} 已提交`);
        this.taskCenterVisible = true;
      } finally {
        this.dingSyncing = false;
      }
    },

    /** 打开钉钉同步中心（家校任务）。最后更新：2026-08-30 */
    openTaskCenter() {
      this.taskCenterVisible = true;
    },
    openTaskCenterFromSync() {
      this.syncDingVisible = false;
      this.openTaskCenter();
    },

  },
  computed: {
    batchStudentDialogTitle() {
      const name = this.batchStudentSourceName || '班级';
      return `${name} · 学生快照`;
    },
    /** 结转明细按原/目标班级名模糊筛选。创建于 2026-10-22 */
    filteredBatchDetailItems() {
      const list = this.batchDetailItems || [];
      const keyword = String(this.batchDetailKeyword || '').trim().toLowerCase();
      if (!keyword) return list;
      return list.filter(item => [item.SourceDepartmentName, item.TargetDepartmentName]
        .some(field => field != null && String(field).toLowerCase().includes(keyword)));
    },
    previewStudentDialogTitle() {
      const name = this.previewStudentClassName || '班级';
      return `${name} · 预演学生名单`;
    },
    pagedPreviewStudents() {
      const list = this.previewStudentItems || [];
      const start = (this.previewStudentPageIndex - 1) * this.previewStudentPageSize;
      return list.slice(start, start + this.previewStudentPageSize);
    },
    /** 余额名单按姓名/班级/卡号/学生ID 模糊筛选。创建于 2026-10-10 */
    filteredBalanceStudents() {
      const list = this.balanceStudentItems || [];
      const keyword = String(this.balanceStudentKeyword || '').trim().toLowerCase();
      if (!keyword) return list;
      return list.filter(item => [item.StuName, item.ClassName, item.CardNumber, item.StudentId]
        .some(field => field != null && String(field).toLowerCase().includes(keyword)));
    },
    filteredBalanceStudentTotal() {
      return this.filteredBalanceStudents.reduce((sum, item) => sum + Number(item.Balance || 0), 0);
    },
    pagedBalanceStudents() {
      const start = (this.balanceStudentPageIndex - 1) * this.balanceStudentPageSize;
      return this.filteredBalanceStudents.slice(start, start + this.balanceStudentPageSize);
    },
    hasCurrentDepartment() {
      return !!(this.CurrentDepartment && this.CurrentDepartment.value);
    },
    /** 钉钉组织树缓存提示文案。最后更新：2026-08-30 */
    dingTreeCacheHint() {
      if (this.dingTreeLoading || !this.dingTreeData.length) return '';
      const timeText = this.formatDingTreeCacheTime(this.dingTreeCachedAt);
      const expireText = this.formatDingTreeCacheTime(this.dingTreeExpiresAt);
      const expireSuffix = expireText ? ` · 将于 ${expireText} 过期` : '';
      if (this.dingTreeFromCache && timeText) return `缓存数据 · 更新于 ${timeText}${expireSuffix}`;
      if (timeText) return `已实时拉取 · ${timeText}${expireSuffix}`;
      return expireText ? `已实时拉取${expireSuffix}` : '已实时拉取';
    },
    isLeafDepartment() {
      return String(this.CurrentDepartment && this.CurrentDepartment.DeptOrgType || '').toLowerCase() === 'class';
    },
    isClassList() {
      return String(this.CurrentDepartment && this.CurrentDepartment.DeptOrgType || '').toLowerCase() === 'grade';
    },
    currentSchoolSchId() {
      return this.resolvedSchoolSchId
        || (this.CurrentDepartment && this.CurrentDepartment.SchId)
        || (this.departmentTree && this.departmentTree.SchId)
        || '';
    },
    canCreateChild() {
      return this.hasCurrentDepartment && !this.isLeafDepartment;
    },
    canDeleteCurrent() {
      const type = String(this.CurrentDepartment && this.CurrentDepartment.DeptOrgType || '').toLowerCase();
      return this.hasCurrentDepartment && type !== 'school';
    },
    nextDepartmentTypeLabel() {
      const labels = {
        school: '校区', affiliateschool: '学段', campus: '学段', period: '年级', grade: '班级'
      };
      const type = String(this.CurrentDepartment && this.CurrentDepartment.DeptOrgType || '').toLowerCase();
      return labels[type] || '下级组织';
    },
    currentDepartmentRows() {
      if (!this.departmentTree || !this.hasCurrentDepartment) return [];
      const targetId = String(this.CurrentDepartment.value);
      const findNode = node => {
        if (!node) return null;
        if (String(node.value) === targetId) return node;
        const children = node.children || [];
        for (let index = 0; index < children.length; index += 1) {
          const found = findNode(children[index]);
          if (found) return found;
        }
        return null;
      };
      const target = findNode(this.departmentTree);
      return (target && target.children ? target.children : [])
        .slice()
        .sort((left, right) => {
          const orderDiff = this.departmentBusinessOrder(left) - this.departmentBusinessOrder(right);
          if (orderDiff !== 0) return orderDiff;
          return String(left.label || '').localeCompare(String(right.label || ''), 'zh-CN');
        });
    },
    pagedDepartmentRows() {
      const size = Number(this.structurePageSize) || 10;
      const page = Number(this.structurePageIndex) || 1;
      const list = this.currentDepartmentRows || [];
      const start = (page - 1) * size;
      return list.slice(start, start + size);
    },
    activeClassExtension() {
      return (this.classExtensions || []).find(item => String(item.Id) === String(this.activeClassExtensionId)) || null;
    },
    parentDepartmentName() {
      const pid = this.CurrentDepartment && (this.CurrentDepartment.Pid || this.CurrentDepartment.parentId);
      const parent = (this.departmentOptions || []).find(item => String(item.value) === String(pid || ''));
      return parent ? parent.label : '-';
    },
    departmentEditorTitle() {
      if (this.departmentEditorMode === 'add') {
        return `新增${this.departmentTypeText(this.ruleForm.DeptOrgType)}`;
      }
      return `编辑${this.departmentTypeText(this.ruleForm.DeptOrgType)}资料`;
    },
    editingDepartmentType() {
      const source = this.departmentEditorSource || this.CurrentDepartment || {};
      return String(source.DeptOrgType || this.ruleForm.DeptOrgType || '').toLowerCase();
    },
    departmentEditorTypeOptions() {
      return this.departmentEditorMode === 'add' ? this.childTypeOptions : this.editTypeOptions;
    },
    filteredDepartmentTree() {
      const tree = this.departmentTree;
      if (!tree) return [];
      const editorTarget = this.departmentEditorMode === 'edit'
        ? this.departmentEditorSource
        : this.CurrentDepartment;
      const editorTargetId = editorTarget && (editorTarget.value || editorTarget.Id);
      const curId = editorTargetId ? String(editorTargetId) : null;
      const filterNode = (node) => {
        if (!node) return null;
        // 排除自身
        if (curId && String(node.value) === curId) return null;
        // 数据层直接过滤掉班级类型节点
        if (node.DeptOrgType === 'class') return null;
        const children = (node.children || []).map(c => filterNode(c)).filter(Boolean);
        const copy = Object.assign({}, node);
        if (children.length) {
          copy.children = children;
        } else if (Object.prototype.hasOwnProperty.call(copy, 'children')) {
          // 空 children 会导致级联多出「暂无数据」一列
          delete copy.children;
        }
        return copy;
      };
      const root = filterNode(tree);
      return root ? [root] : [];
    },
    filteredDepartmentCascaderOptions() {
      // 上级选择：班级已过滤；清洗 disabled / 空 children，保证年级等可选。最后更新：2026-08-26
      return prepareDeptCascaderTree(this.filteredDepartmentTree, { clearAllDisabled: true });
    },
    // 过滤掉自身，允许选择子节点作为上级
    filteredDepartmentOptions() {
      if (!this.departmentOptions || !this.CurrentDepartment || !this.CurrentDepartment.value) return this.departmentOptions || [];
      const curId = String(this.CurrentDepartment.value);
      return (this.departmentOptions || []).filter(opt => {
        // 排除自身，并且排除班级类型（不可作为上级）
        if (String(opt.value) === curId) return false;
        if (opt.DeptOrgType === 'class') return false;
        return true;
      });
    },
    childTypeOptions() {
      const types = [
        { label: '学校', value: 'school' },
        { label: '校区', value: 'campus' },
        { label: '学段', value: 'period' },
        { label: '年级', value: 'grade' },
        { label: '班级', value: 'class' },
      ];
      const order = types.map(t => t.value);
      const parentType = String((this.CurrentDepartment && this.CurrentDepartment.DeptOrgType) || this.ruleForm.DeptOrgType || '').toLowerCase();
      if (parentType === 'affiliateschool') {
        return types.filter(t => ['period', 'grade', 'class'].includes(t.value));
      }
      const idx = order.indexOf(parentType);
      if (idx === -1) return types;
      return types.filter(t => order.indexOf(t.value) > idx);
    },

    // 编辑模式：如果当前节点是 school，则不可更改；否则不能改为 school
    editTypeOptions() {
      const types = [
        { label: '学校', value: 'school' },
        { label: '校区', value: 'campus' },
        { label: '学段', value: 'period' },
        { label: '年级', value: 'grade' },
        { label: '班级', value: 'class' },
      ];
      const current = this.editingDepartmentType;
      if (current === 'school') return [{ label: '学校', value: 'school' }];
      return types.filter(t => t.value !== 'school');
    },

    isSchoolNode() {
      const cur = (this.CurrentDepartment && this.CurrentDepartment.DeptOrgType) || this.ruleForm.DeptOrgType || '';
      return cur === 'school';
    },
    teachingImportHasErrors() {
      return !!(this.teachingImportErrors && this.teachingImportErrors.length);
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 树加载失败时不要一直卡在 loading
    this._bootstrapTimer = setTimeout(() => {
      if (this.workspaceBootstrapping && !this.hasCurrentDepartment) {
        this.workspaceBootstrapping = false
      }
    }, 5000)
  },
  beforeDestroy() {
    if (this._bootstrapTimer) {
      clearTimeout(this._bootstrapTimer)
      this._bootstrapTimer = null
    }
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.architecture-page {
  --dept-primary: #3b82f6;
  --dept-primary-soft: #eff6ff;
  --dept-primary-mid: #bfdbfe;
  --dept-ink: #1e293b;
  --dept-text: #0f172a;
  --dept-muted: #64748b;
  --dept-line: #e2e8f0;
  --dept-surface: #ffffff;
  --dept-warn: #d97706;
  --dept-radius: 12px;
  /* 左侧沿用全局 .dp-left，与人员页一致；仅右侧保留架构页皮肤。最后修改：2026-08-07 */
}

.architecture-page>.dp-right {
  padding: 0;
  border: 1px solid var(--dept-line);
  border-radius: var(--dept-radius);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  background: var(--dept-surface);
}

.architecture-workspace {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 0;
  background: #fff;
  /* 右侧栏变窄时按容器宽度响应，而非整页视口。创建于 2026-08-30 */
  container-type: inline-size;
  container-name: arch-workspace;
}

.architecture-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 16px;
  flex: 0 0 auto;
  flex-shrink: 0;
  padding: 12px 18px 12px;
  border-bottom: 1px solid var(--dept-line);
  background: #fff;
  overflow: visible;
}

.architecture-context {
  flex: 1 1 280px;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.architecture-title-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: var(--dept-primary);
  background: var(--dept-primary-soft);
  font-size: 18px;
  box-shadow: none;
}

.architecture-context h1 {
  margin: 0 0 4px;
  color: var(--dept-ink);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.architecture-subtitle {
  margin: 0 0 8px;
  color: var(--dept-muted);
  font-size: 12px;
  line-height: 1.5;
}

.architecture-breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
  color: var(--dept-muted);
  font-size: 12px;
}

.architecture-breadcrumb strong {
  max-width: 280px;
  overflow: hidden;
  color: var(--dept-text);
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
}

.architecture-type-tag {
  margin-left: 2px;
}

.architecture-context-id {
  padding-left: 8px;
  border-left: 1px solid #cbd5e1;
  color: #94a3b8;
  font-size: 12px;
}

.architecture-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  flex: 0 1 auto;
  align-self: flex-start;
  max-width: 100%;
  min-width: 0;
}

.architecture-actions .el-button+.el-button {
  margin-left: 0;
}

.architecture-actions /deep/ .el-button {
  float: none !important;
  margin: 0 !important;
  width: auto;
  max-width: 100%;
  min-height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  transition: color 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
}

.architecture-actions /deep/ .el-button--primary {
  background: var(--dept-primary);
  border-color: var(--dept-primary);
  box-shadow: none;
}

.architecture-actions /deep/ .el-button--primary:hover,
.architecture-actions /deep/ .el-button--primary:focus {
  background: #2563eb;
  border-color: #2563eb;
}

.school-action-strip {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  flex: 0 0 auto;
  flex-shrink: 0;
  padding: 12px 18px;
  border-bottom: 1px solid var(--dept-line);
  background: #fafbfc;
  box-sizing: border-box;
  overflow: visible;
}

.school-action-intro {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.school-action-label {
  color: var(--dept-ink);
  font-size: 13px;
  font-weight: 600;
}

.school-action-desc {
  color: var(--dept-muted);
  font-size: 12px;
}

.school-action-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.school-action-card {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--dept-line);
  border-radius: 10px;
  background: #fff;
  color: var(--dept-text);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.18s ease, background-color 0.18s ease;
}

.school-action-card i {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--dept-primary-soft);
  color: var(--dept-primary);
  font-size: 16px;
  flex: 0 0 32px;
}

.school-action-step {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--dept-primary-soft);
  color: var(--dept-primary);
  font-size: 12px;
  font-weight: 700;
  flex: 0 0 28px;
}

.school-action-card.is-primary .school-action-step {
  background: #dbeafe;
  color: #1d4ed8;
}

.school-action-card span {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.school-action-card strong {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
}

.school-action-card em {
  font-style: normal;
  font-size: 11px;
  color: var(--dept-muted);
  line-height: 1.3;
}

.school-action-card:hover {
  border-color: var(--dept-primary-mid);
  background: #f8fafc;
  box-shadow: none;
}

.school-action-card.is-primary {
  border-color: var(--dept-primary-mid);
  background: var(--dept-primary-soft);
  color: var(--dept-text);
  box-shadow: none;
}

.school-action-card.is-primary i {
  background: #dbeafe;
  color: var(--dept-primary);
}

.school-action-card.is-primary strong {
  color: #1d4ed8;
}

.school-action-card.is-primary em {
  color: var(--dept-muted);
}

.architecture-list-panel {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 14px 18px 18px;
  overflow: hidden;
}

.architecture-list-panel > .el-col.toolbar {
  float: none !important;
  clear: both !important;
  width: 100% !important;
  display: flex !important;
  justify-content: flex-end !important;
  margin-top: 12px;
  padding: 0;
  background: transparent;
}

.architecture-section-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
  flex-shrink: 0;
}

.architecture-section-heading>div {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.architecture-section-heading h2 {
  margin: 0;
  color: var(--dept-ink);
  font-size: 16px;
  font-weight: 700;
}

.architecture-section-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--dept-primary-soft);
  color: var(--dept-primary);
  font-size: 12px;
  font-weight: 600;
}

.architecture-section-actions {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.architecture-section-path {
  max-width: 100%;
  overflow: hidden;
  line-height: 22px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--dept-muted);
  font-size: 12px;
}

.architecture-table {
  width: 100%;
  border: 1px solid var(--dept-line);
  border-radius: 12px;
  overflow: hidden;
}

.architecture-table /deep/ .el-table__row {
  cursor: pointer;
}

.architecture-table /deep/ .el-table__row td {
  transition: background-color 0.2s ease;
}

.architecture-table /deep/ .el-table__row:hover>td {
  background: #f8fafc !important;
}

.architecture-table /deep/ th {
  height: 48px;
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
}

.architecture-table /deep/ td {
  height: 56px;
}

.department-name-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--dept-text);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.18s ease;
}

.department-name-link:hover {
  color: var(--dept-primary);
}

.dept-row-actions {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  vertical-align: middle;
}

.department-detail-text {
  color: var(--dept-muted);
}

.architecture-home {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 28px;
  min-height: 520px;
  padding: 48px 40px;
}

.architecture-workspace-loading {
  flex: 1;
  min-height: 360px;
  border: 1px dashed #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.architecture-workspace-loading__placeholder {
  min-height: 360px;
}

.architecture-home__hero {
  max-width: 560px;
}

.architecture-home__badge {
  width: 44px;
  height: 44px;
  margin-bottom: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: var(--dept-primary);
  background: var(--dept-primary-soft);
  font-size: 20px;
  box-shadow: none;
}

.architecture-home__hero h2 {
  margin: 0 0 10px;
  color: var(--dept-ink);
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.architecture-home__hero p {
  margin: 0;
  color: var(--dept-muted);
  font-size: 14px;
  line-height: 1.7;
}

.architecture-home__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  max-width: 920px;
}

.architecture-home__card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px 18px 20px;
  border: 1px solid var(--dept-line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.architecture-home__card:hover {
  border-color: var(--dept-primary-mid);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.architecture-home__card i {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--dept-primary-soft);
  color: var(--dept-primary);
  font-size: 16px;
}

.architecture-home__card strong {
  color: var(--dept-text);
  font-size: 14px;
  font-weight: 700;
}

.architecture-home__card span {
  color: var(--dept-muted);
  font-size: 12px;
  line-height: 1.6;
}

.department-leaf-detail {
  padding: 18px 22px 22px;
}

.class-overview {
  display: block;
  padding: 16px 18px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid var(--dept-line);
  box-shadow: none;
}

.class-overview-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.class-overview-title h2 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: var(--dept-ink);
  line-height: 1.3;
}

.class-overview-id {
  color: var(--dept-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.class-overview-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.class-overview-meta {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(96px, 1fr));
  border-left: 0;
}

.class-overview-meta--full {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
}

.class-meta-item {
  min-width: 0;
  padding: 2px 16px;
  border-right: 1px solid #e2e8f0;
}

.class-meta-item:first-child {
  padding-left: 4px;
}

.class-meta-item:last-child {
  border-right: 0;
  padding-right: 4px;
}

.class-meta-item span,
.class-meta-item strong {
  display: block;
}

.class-meta-item span {
  margin-bottom: 6px;
  color: var(--dept-muted);
  font-size: 12px;
  letter-spacing: 0.04em;
}

.class-meta-item strong {
  overflow: hidden;
  color: var(--dept-text);
  font-size: 15px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class-meta-id {
  font-family: Consolas, Monaco, monospace;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--dept-muted) !important;
}

.class-extension-section {
  min-height: 220px;
  margin-top: 20px;
  border: 1px solid var(--dept-line);
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.03);
}

.class-extension-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 0 20px;
  border-bottom: 1px solid #f1f5f9;
  background: #f8fafc;
}

.class-extension-heading>div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.class-extension-heading h3 {
  margin: 0;
  color: var(--dept-ink);
  font-size: 16px;
  font-weight: 600;
}

.class-extension-count {
  color: var(--dept-muted);
  font-size: 12px;
}

.class-extension-tabs {
  padding: 0 20px;
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
}

.class-extension-tabs /deep/ .el-tabs__header {
  margin: 0;
}

.class-extension-tabs /deep/ .el-tabs__item {
  max-width: 210px;
  height: 48px;
  padding: 0 20px;
  line-height: 48px;
  font-weight: 500;
  color: var(--dept-muted);
  transition: color 0.2s ease;
}

.class-extension-tabs /deep/ .el-tabs__item.is-active {
  color: var(--dept-primary);
}

.class-extension-tabs /deep/ .el-tabs__active-bar {
  background: var(--dept-primary);
}

.class-extension-tabs /deep/ .el-tabs__nav-wrap::after {
  display: none;
}

.class-extension-tab-label {
  display: inline-flex;
  align-items: center;
  max-width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class-extension-default-icon {
  margin-left: 4px;
  color: #10b981;
}

.class-extension-record {
  padding: 20px;
}

.class-extension-record-head {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.class-extension-record-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.class-extension-record-title strong {
  max-width: 420px;
  overflow: hidden;
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class-extension-record-actions {
  display: flex;
  gap: 8px;
}

.class-extension-content {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.extension-field,
.extension-media {
  min-height: 104px;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.extension-field:hover,
.extension-media:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.extension-field-wide {
  grid-column: 1 / -1;
  min-height: 82px;
}

.extension-field>span,
.extension-media-item>span {
  display: block;
  margin-bottom: 8px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.extension-field p {
  max-height: 78px;
  margin: 0;
  overflow: auto;
  color: #334155;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.extension-media {
  grid-column: 1 / -1;
  min-height: 114px;
  display: flex;
  align-items: flex-start;
  gap: 40px;
}

.extension-media /deep/ img {
  max-width: 100%;
}

.extension-media-item {
  min-width: 120px;
}

.extension-media-empty {
  width: 68px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px dashed #cbd5e1;
  border-radius: 8px;
  color: #94a3b8;
  background: #f8fafc;
  font-size: 22px;
  transition: border-color 0.2s ease, color 0.2s ease;
}

.extension-media-empty:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.upgrade-scope-main {
  color: #1e293b;
  font-weight: 600;
  line-height: 1.35;
}

.upgrade-scope-sub {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.35;
}

.upgrade-scope-sub i {
  margin: 0 4px;
  font-style: normal;
  color: #cbd5e1;
}

.upgrade-scope-path {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upgrade-path-editors {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.upgrade-path-editors .el-select {
  flex: 1;
  min-width: 0;
}

.upgrade-path-field {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.upgrade-path-field label {
  font-size: 12px;
  color: #64748b;
}

.upgrade-path-field.is-invalid label {
  color: #dc2626;
}

.upgrade-path-field.is-invalid >>> .el-input__inner {
  border-color: #f87171;
}

.upgrade-path-field__error {
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  color: #dc2626;
  word-break: break-all;
}

.upgrade-inline-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 14px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 12px;
  line-height: 1.55;
}

.upgrade-inline-tip i {
  margin-top: 2px;
  color: #3b82f6;
}

.upgrade-panel-card {
  margin-bottom: 14px;
  padding: 14px 16px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.upgrade-panel-card__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.upgrade-panel-card__head h3 {
  margin: 0 0 2px;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.upgrade-panel-card__head span {
  color: #64748b;
  font-size: 12px;
}

.upgrade-rule-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 48px;
}

.upgrade-rule-card {
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fafbfc;
  transition: border-color 0.18s ease, background-color 0.18s ease;
}

.upgrade-rule-card.is-disabled {
  opacity: 0.72;
}

.upgrade-rule-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.upgrade-rule-card__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.upgrade-rule-card__title strong {
  font-size: 14px;
  color: #0f172a;
}

.upgrade-rule-card__switch {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.upgrade-rule-card__path {
  margin: 8px 0 10px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upgrade-empty-hint {
  padding: 18px 12px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

.unbind-scene-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.unbind-scene-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fafbfc;
}

.unbind-scene-card strong {
  font-size: 13px;
  color: #1e293b;
}

.unbind-scene-card label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #475569;
  cursor: pointer;
}

.annual-metric-groups {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(0, 1.25fr);
  gap: 10px;
  margin-bottom: 14px;
}

.annual-metric-group {
  padding: 10px 12px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.annual-metric-group__label {
  display: inline-block;
  margin-bottom: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.annual-metric-group .annual-summary-item {
  min-width: 0;
  min-height: 64px;
  padding: 10px;
  gap: 6px;
  border-radius: 10px;
}

.annual-metric-group .annual-summary-item strong {
  font-size: 18px;
  white-space: nowrap;
}

.upgrade-ops-tip {
  margin-bottom: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px solid #fdba74;
}

.upgrade-ops-tip__title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  color: #c2410c;
}

.upgrade-ops-tip__title i {
  font-size: 16px;
}

.upgrade-ops-tip__title strong {
  font-size: 13px;
  font-weight: 700;
}

.upgrade-ops-tip p {
  margin: 0;
  color: #9a3412;
  font-size: 12px;
  line-height: 1.6;
}

.upgrade-detail-section {
  margin-top: 4px;
  margin-bottom: 14px;
}

.upgrade-detail-section__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 8px;
}

.upgrade-detail-section__head h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.upgrade-detail-section__head span {
  color: #94a3b8;
  font-size: 12px;
}

.upgrade-detail-section--extra {
  padding-top: 4px;
  border-top: 1px dashed #e2e8f0;
}

.upgrade-detail-tabs {
  margin-top: 4px;
}

.upgrade-detail-tabs /deep/ .el-tabs__header {
  margin-bottom: 10px;
}

.upgrade-detail-tabs /deep/ .el-tabs__item {
  font-weight: 600;
  color: #64748b;
}

.upgrade-detail-tabs /deep/ .el-tabs__item.is-active {
  color: #1e293b;
}

.upgrade-detail-tabs__hint {
  margin: 0 0 8px;
  color: #94a3b8;
  font-size: 12px;
}

.preview-student-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: #2563eb;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.preview-student-link:hover {
  color: #1d4ed8;
}

.preview-student-balance {
  color: #dc2626;
  font-weight: 600;
}

.balance-student-link {
  margin: 2px 0 6px;
  padding: 0;
  color: #dc2626;
}

.upgrade-msg-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}

.upgrade-msg {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
}

.upgrade-msg.is-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.upgrade-msg.is-warning {
  background: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
  border-radius: 10px;
  padding: 10px 12px;
}

.annual-transfer-path {
  display: flex;
  align-items: center;
  gap: 10px;
}

.annual-transfer-path > div {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.annual-transfer-path strong {
  color: #0f172a;
  font-size: 13px;
  line-height: 1.3;
}

.annual-transfer-path strong.is-archive {
  color: #b45309;
}

.annual-transfer-path em {
  font-style: normal;
  color: #94a3b8;
  font-size: 12px;
}

.annual-transfer-path > i {
  color: #94a3b8;
  flex: 0 0 auto;
}

.upgrade-outbox-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.class-transfer-tip {
  margin-bottom: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.class-transfer-tip strong {
  display: block;
  margin-bottom: 4px;
  color: #92400e;
  font-size: 13px;
}

.class-transfer-tip p {
  margin: 0;
  color: #a16207;
  font-size: 12px;
  line-height: 1.55;
}

.class-transfer-detail-head {
  margin-bottom: 8px;
}

.class-transfer-result.is-upgrade {
  color: #15803d;
  font-weight: 600;
}

.class-transfer-result.is-archive {
  color: #b91c1c;
  font-weight: 600;
}

.upgrade-path-arrow {
  flex: 0 0 auto;
  /* 与左侧 label(12px)+gap(4px)+小尺寸选择框中线对齐，避免右侧错误文案撑高后整体居中错位 */
  margin-top: 26px;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1;
}

.upgrade-status-tag {
  display: inline-block;
  height: auto !important;
  max-width: 100%;
  white-space: normal !important;
  line-height: 1.4 !important;
  padding: 4px 8px !important;
  text-align: left;
  word-break: break-all;
}

.annual-preview-body {
  min-height: 220px;
}

.upgrade-rule-alert {
  margin-bottom: 14px;
}

.upgrade-rule-section {
  margin-bottom: 16px;
}

.upgrade-rule-section__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 10px;
}

.upgrade-rule-section__head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.upgrade-rule-section__head span {
  color: #64748b;
  font-size: 12px;
}

.upgrade-rule-table-wrap {
  overflow: hidden;
  border-radius: 12px;
}

.annual-summary-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.annual-summary-grid.annual-summary-grid--compact {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 0;
}

.annual-summary-item {
  min-height: 78px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.annual-summary-item:hover {
  border-color: var(--dept-primary-mid);
  box-shadow: none;
}

.annual-summary-item strong {
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1;
}

.annual-summary-item.is-warning {
  background: linear-gradient(180deg, #fffbeb 0%, #fff 100%);
  border-color: #fde68a;
}

.annual-summary-item.is-warning strong {
  color: #d97706;
}

.annual-preview-alert {
  margin-bottom: 8px;
}

.unbind-config-block {
  margin-top: 4px;
  padding: 14px 16px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.unbind-config-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 12px;
}

.unbind-config-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.unbind-config-head span {
  color: #64748b;
  font-size: 12px;
}

.unbind-matrix {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.unbind-matrix th,
.unbind-matrix td {
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
  text-align: center;
  font-size: 13px;
  color: #334155;
}

.unbind-matrix th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
}

.unbind-matrix td:first-child,
.unbind-matrix th:first-child {
  text-align: left;
  width: 36%;
  color: #1e293b;
  font-weight: 500;
}

.unbind-matrix tr:last-child td {
  border-bottom: 0;
}

.annual-preview-table {
  margin-top: 14px;
}

.annual-action-tag {
  height: auto !important;
  max-width: 100%;
  padding: 4px 8px;
  line-height: 1.4 !important;
  white-space: normal;
  word-break: keep-all;
}

.annual-class-name {
  margin-top: 3px;
  color: #909399;
  font-size: 12px;
}

.annual-no-target {
  color: #909399;
  font-size: 16px;
  line-height: 1.2;
}

.upgrade-outbox-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}


@media (max-width: 1180px) {
  .class-overview-meta--full {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 12px;
  }

  .class-overview-meta--full .class-meta-item:nth-child(2n) {
    border-right: 0;
  }
}

/* 右侧内容区变窄：顶栏按钮区换行 */
@container arch-workspace (max-width: 720px) {
  .school-action-group {
    grid-template-columns: 1fr;
  }

  .architecture-actions {
    flex: 1 1 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 992px) {
  .annual-summary-grid {
    grid-template-columns: repeat(3, minmax(120px, 1fr));
  }

  .annual-metric-groups {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .unbind-scene-grid {
    grid-template-columns: 1fr;
  }

  .class-overview-head {
    flex-direction: column;
  }

  .architecture-home {
    padding: 28px 20px;
    min-height: 420px;
  }

  .architecture-home__grid {
    grid-template-columns: 1fr;
  }

  .architecture-home__hero h2 {
    font-size: 22px;
  }
}

@media (max-width: 768px) {
  /* 滚动/分栏高度由全局 admin-responsive.css 统一处理，此处只保留本页布局细节 */
  .architecture-page>.dp-right {
    width: 100%;
  }

  .architecture-toolbar {
    padding: 14px;
  }

  .architecture-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .school-action-strip,
  .school-action-group-upgrade {
    width: 100%;
  }

  .architecture-actions /deep/ .el-button {
    min-height: 40px;
  }

  .school-action-card {
    min-height: 56px;
  }

  .school-action-strip {
    align-items: flex-start;
    padding: 10px 14px;
  }

  .architecture-list-panel,
  .department-leaf-detail {
    padding: 14px;
  }

  .architecture-section-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }

  .architecture-section-path {
    max-width: 100%;
    text-align: left;
  }

  .architecture-section-actions {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .architecture-table /deep/ .el-table__body-wrapper {
    overflow-x: auto;
  }

  .class-extension-content {
    grid-template-columns: minmax(0, 1fr);
  }

  .extension-field-wide,
  .extension-media {
    grid-column: 1;
  }

  .upgrade-outbox-toolbar {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .architecture-page>.dp-right {
    border-radius: 6px;
  }

  .architecture-context {
    min-width: 0;
  }

  .architecture-title-icon {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }

  .architecture-context h1 {
    font-size: 17px;
  }

  .architecture-breadcrumb {
    flex-wrap: wrap;
    white-space: normal;
  }

  .architecture-breadcrumb strong {
    max-width: 180px;
  }

  .architecture-actions /deep/ .el-button {
    flex: 1 1 calc(50% - 4px);
    min-width: 0;
  }

  .school-action-group {
    width: 100%;
  }

  .school-action-label {
    width: 100%;
  }

  .school-action-card {
    flex: 1 1 100%;
  }

  .class-overview {
    padding: 14px;
  }

  .class-overview-meta,
  .class-overview-meta--full {
    grid-template-columns: minmax(0, 1fr);
  }

  .class-meta-item,
  .class-meta-item:nth-child(n + 3) {
    padding: 10px 2px;
    border-right: 0;
    border-bottom: 1px solid #e1e7ef;
  }

  .class-meta-item:last-child {
    border-bottom: 0;
  }

  .class-extension-heading,
  .class-extension-tabs {
    padding-right: 12px;
    padding-left: 12px;
  }

  .class-extension-tabs /deep/ .el-tabs__item {
    max-width: 164px;
    padding: 0 12px;
  }

  .class-extension-tab-label {
    max-width: 136px;
  }

  .class-extension-record {
    padding: 0 12px 12px;
  }

  .class-extension-record-head {
    align-items: flex-start;
  }

  .class-extension-record-title,
  .class-extension-record-title strong {
    max-width: 100%;
  }

  .extension-media {
    flex-wrap: wrap;
    gap: 18px;
  }

  .annual-summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .school-action-card {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {

  .architecture-actions /deep/ .el-button,
  .architecture-table /deep/ .el-table__row td,
  .class-extension-tabs /deep/ .el-tabs__item,
  .school-action-card,
  .architecture-home__card,
  .annual-summary-item {
    transition: none;
  }

  .school-action-card:hover,
  .architecture-home__card:hover {
    transform: none;
  }
}
</style>

<style>
/* 毕业余额名单/确认弹窗（append-to-body）。最后修改：2026-10-10 */
.balance-student-dialog {
  max-width: 94vw;
}

.balance-student-dialog .balance-student-alert {
  margin-bottom: 12px;
}

.balance-student-dialog .balance-student-alert .preview-student-balance {
  color: #dc2626;
}

.balance-student-dialog .balance-student-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.balance-student-dialog .balance-student-search {
  width: 280px;
}

.balance-student-dialog .balance-student-summary {
  color: #64748b;
  font-size: 12px;
}

/* 教学架构顶栏按钮：禁止 float/外边距错位。最后修改：2026-08-30 */
.architecture-page .architecture-actions .el-button {
  float: none !important;
  margin: 0 !important;
}

/* 教学架构导入弹窗（append-to-body，需非 scoped）。最后更新：2026-08-07 */
.teaching-import-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.teaching-import-dialog .el-dialog__header {
  padding: 20px 24px 12px;
  border-bottom: 1px solid #eef2f7;
}

.teaching-import-dialog .el-dialog__body {
  padding: 16px 24px 8px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.teaching-import-dialog .el-dialog__footer {
  padding: 12px 24px 20px;
  border-top: 1px solid #eef2f7;
}

.ti-dialog-title {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-right: 28px;
}

.ti-dialog-title__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eff6ff;
  color: #3b82f6;
  font-size: 20px;
  flex-shrink: 0;
}

.ti-dialog-title strong {
  display: block;
  font-size: 17px;
  font-weight: 650;
  color: #0f172a;
  line-height: 1.3;
}

.ti-dialog-title p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.45;
}

.ti-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ti-steps {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  border: 1px solid #e2e8f0;
}

.ti-step {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.ti-step__no {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #3b82f6;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ti-step strong {
  display: block;
  font-size: 13px;
  color: #0f172a;
  font-weight: 600;
}

.ti-step em {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
  font-style: normal;
}

.ti-step__arrow {
  color: #cbd5e1;
  font-size: 14px;
}

.ti-template-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  background: #eff6ff;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.ti-template-card:hover:not(:disabled) {
  border-color: #3b82f6;
  background: #dbeafe;
}

.ti-template-card:disabled {
  opacity: 0.7;
  cursor: wait;
}

.ti-template-card__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fff;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  border: 1px solid #bfdbfe;
}

.ti-template-card__meta {
  flex: 1;
  min-width: 0;
}

.ti-template-card__meta strong {
  display: block;
  font-size: 13px;
  color: #1e3a8a;
  font-weight: 600;
}

.ti-template-card__meta em {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
  font-style: normal;
}

.ti-template-card__action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #3b82f6;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.ti-upload {
  width: 100%;
}

.ti-upload .el-upload {
  width: 100%;
}

.ti-upload .el-upload-dragger {
  width: 100%;
  height: auto;
  min-height: 128px;
  padding: 22px 16px;
  border-radius: 14px;
  border: 1.5px dashed #93c5fd;
  background: linear-gradient(180deg, #f8fbff 0%, #fff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.ti-upload .el-upload-dragger:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

.ti-upload__empty,
.ti-upload__file {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #334155;
}

.ti-upload__empty i {
  font-size: 32px;
  color: #3b82f6;
  margin-bottom: 2px;
}

.ti-upload__empty strong,
.ti-upload__file strong {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.ti-upload__empty em,
.ti-upload__file em {
  font-size: 12px;
  color: #64748b;
  font-style: normal;
}

.ti-upload__file {
  flex-direction: row;
  gap: 12px;
  text-align: left;
}

.ti-upload__ok {
  font-size: 28px;
  color: #16a34a;
}

.ti-result {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.ti-result__summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 600;
}

.ti-result__summary.is-ok {
  background: #f0fdf4;
  color: #166534;
  border-bottom: 1px solid #bbf7d0;
}

.ti-result__summary.is-warn {
  background: #fffbeb;
  color: #92400e;
  border-bottom: 1px solid #fde68a;
}

.ti-result__tabs {
  padding: 8px 12px 12px;
}

.ti-result__tabs .el-tabs__header {
  margin-bottom: 10px;
}

.ti-result__tabs .el-tabs__item {
  height: 34px;
  line-height: 34px;
  font-size: 13px;
}

.ti-result__table th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 600;
}

.ti-preview-table th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 600;
}

.ti-row-del {
  color: #ef4444 !important;
}

.ti-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.ti-footer .el-button--primary {
  background: #3b82f6;
  border-color: #3b82f6;
  min-width: 120px;
}

.ti-footer .el-button--primary:hover,
.ti-footer .el-button--primary:focus {
  background: #2563eb;
  border-color: #2563eb;
}

.ti-footer .el-button--primary.is-disabled,
.ti-footer .el-button--primary.is-disabled:hover {
  background: #93c5fd;
  border-color: #93c5fd;
  color: #fff;
}

@media (max-width: 768px) {
  .ti-steps {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .ti-step__arrow {
    display: none;
  }

  .ti-template-card {
    flex-wrap: wrap;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ti-template-card,
  .ti-upload .el-upload-dragger {
    transition: none;
  }
}

/* 钉钉同步弹窗美化样式 */
.ding-sync-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.ding-sync-dialog .el-dialog__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  padding: 20px;
}

.ding-sync-dialog .el-dialog__header .el-dialog__title {
  font-weight: 600;
  color: #303133;
}

.ding-sync-dialog .el-dialog__body {
  padding: 20px 25px;
}

.ding-sync-dialog .ding-sync-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background: #f8f9fb;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.ding-sync-dialog .ding-sync-header .ding-sync-label {
  margin-right: 15px;
  font-weight: 500;
  color: #606266;
}

.ding-sync-dialog .ding-sync-header .ding-sync-label i {
  margin-right: 4px;
  color: var(--btn-primary, #2563eb);
}

.ding-sync-dialog .ding-tree-container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  min-height: 250px;
  max-height: 450px;
  overflow-y: auto;
  padding: 10px 0;
}

/* 自定义树节点样式 */
.ding-sync-dialog .ding-tree-container .custom-ding-tree .el-tree-node__content {
  height: 32px;
}

.ding-sync-dialog .ding-tree-container .custom-ding-tree .el-tree-node__content:hover {
  background-color: #f0f7ff;
}

.ding-sync-dialog .ding-tree-container .custom-ding-tree .el-tree-node:focus>.el-tree-node__content {
  background-color: #e6f1fc;
}

.ding-sync-dialog .ding-sync-tips {
  margin-top: 15px;
  padding: 10px 15px;
  background-color: #eef5fe;
  border-left: 4px solid var(--btn-primary, #2563eb);
  color: #606266;
  font-size: 13px;
  border-radius: 0 4px 4px 0;
  line-height: 1.5;
}

.ding-sync-dialog .ding-sync-tips i {
  color: var(--btn-primary, #2563eb);
  margin-right: 5px;
}

.upgrade-rule-dialog {
  max-width: 1040px;
  border-radius: 14px;
  overflow: hidden;
}

.dept-pro-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #fafbfc;
}

.dept-pro-dialog .el-dialog__title {
  color: #1e293b;
  font-weight: 600;
  font-size: 16px;
}

.dept-pro-dialog .el-dialog__body {
  padding: 16px 22px 8px;
}

.dept-pro-dialog .el-dialog__footer {
  padding: 12px 22px 18px;
  border-top: 1px solid #f1f5f9;
}

.upgrade-rule-dialog .upgrade-rule-table {
  border: 1px solid #e2e8f0;
  border-right: none;
  border-bottom: none;
}

.upgrade-rule-dialog .upgrade-rule-table::before,
.upgrade-rule-dialog .upgrade-rule-table::after {
  display: none !important;
}

.upgrade-rule-dialog .upgrade-path-editors .el-select {
  width: auto;
}

.upgrade-rule-dialog .upgrade-rule-table th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 600;
}

.annual-upgrade-dialog {
  max-width: 96%;
  border-radius: 14px;
  overflow: hidden;
}

.annual-upgrade-dialog .el-dialog__body {
  padding: 16px 22px 8px;
}

.grade-transfer-dialog,
.class-transfer-dialog {
  max-width: 820px;
  border-radius: 14px;
  overflow: hidden;
}

.grade-transfer-dialog .el-dialog__body,
.class-transfer-dialog .el-dialog__body {
  padding: 16px 22px 8px;
}

/* 弹窗 append-to-body 时 scoped 样式不生效，汇总区样式需在此声明 */
.grade-transfer-dialog .annual-metric-groups,
.class-transfer-dialog .annual-metric-groups,
.annual-upgrade-dialog .annual-metric-groups {
  display: grid;
  /* 影响/毕业/解绑/余额 四组一行，余额组金额较长略宽。最后修改：2026-10-10 */
  grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(0, 1.25fr);
  gap: 10px;
  margin-bottom: 14px;
}

@media (max-width: 960px) {
  .grade-transfer-dialog .annual-metric-groups,
  .class-transfer-dialog .annual-metric-groups,
  .annual-upgrade-dialog .annual-metric-groups {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.grade-transfer-dialog .annual-metric-group,
.class-transfer-dialog .annual-metric-group,
.annual-upgrade-dialog .annual-metric-group {
  padding: 10px 12px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.grade-transfer-dialog .annual-metric-group__label,
.class-transfer-dialog .annual-metric-group__label,
.annual-upgrade-dialog .annual-metric-group__label {
  display: inline-block;
  margin-bottom: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.grade-transfer-dialog .annual-summary-grid.annual-summary-grid--compact,
.class-transfer-dialog .annual-summary-grid.annual-summary-grid--compact,
.annual-upgrade-dialog .annual-summary-grid.annual-summary-grid--compact {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 0;
}

.grade-transfer-dialog .annual-metric-group .annual-summary-item,
.class-transfer-dialog .annual-metric-group .annual-summary-item,
.annual-upgrade-dialog .annual-metric-group .annual-summary-item {
  min-width: 0;
  min-height: 64px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  color: #64748b;
  font-size: 12px;
}

.grade-transfer-dialog .annual-metric-group .annual-summary-item strong,
.class-transfer-dialog .annual-metric-group .annual-summary-item strong,
.annual-upgrade-dialog .annual-metric-group .annual-summary-item strong {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.grade-transfer-dialog .annual-metric-group .annual-summary-item.is-warning,
.class-transfer-dialog .annual-metric-group .annual-summary-item.is-warning,
.annual-upgrade-dialog .annual-metric-group .annual-summary-item.is-warning {
  background: linear-gradient(180deg, #fffbeb 0%, #fff 100%);
  border-color: #fde68a;
}

.grade-transfer-dialog .annual-metric-group .annual-summary-item.is-warning strong,
.class-transfer-dialog .annual-metric-group .annual-summary-item.is-warning strong,
.annual-upgrade-dialog .annual-metric-group .annual-summary-item.is-warning strong {
  color: #d97706;
}

.upgrade-outbox-dialog {
  max-width: 980px;
  border-radius: 14px;
  overflow: hidden;
}

.upgrade-outbox-dialog .el-dialog__body {
  padding: 16px 22px;
}

/* 结转日志 / 明细 / 学生快照表格固定高度，避免 0/1 条时弹窗过矮。最后更新：2026-10-22 */
.upgrade-outbox-table,
.upgrade-batch-detail-table,
.upgrade-batch-student-table {
  width: 100%;
}

.upgrade-outbox-table .el-table__empty-block,
.upgrade-batch-detail-table .el-table__empty-block,
.upgrade-batch-student-table .el-table__empty-block {
  min-height: 300px;
}

.upgrade-batch-detail-toolbar,
.upgrade-batch-student-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.upgrade-batch-detail-search,
.upgrade-batch-student-search {
  width: 280px;
}

/* 结转日志分页：与主列表一致靠右，并与表格留出间距。最后更新：2026-10-01 */
.upgrade-outbox-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.upgrade-outbox-table .batch-id {
  font-variant-numeric: tabular-nums;
  color: #334155;
}

.upgrade-outbox-table .batch-cell-main {
  color: #1e293b;
  font-weight: 500;
  line-height: 1.35;
}

.upgrade-outbox-table .batch-cell-sub {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upgrade-outbox-table .batch-impact {
  color: #475569;
  font-variant-numeric: tabular-nums;
  line-height: 1.35;
}

.upgrade-outbox-table .batch-impact__line {
  white-space: nowrap;
}

.upgrade-outbox-table .batch-impact__line--sub {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
}

.upgrade-outbox-table .batch-impact i {
  margin: 0 4px;
  font-style: normal;
  color: #cbd5e1;
}

.batch-student-pagination {
  margin-top: 12px;
  text-align: right;
}

.department-editor-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.department-editor-dialog .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.department-editor-dialog .el-dialog__title {
  color: #1e293b;
  font-weight: 600;
}

.dept-batch-delete-confirm .el-message-box__message {
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 240px;
  overflow-y: auto;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader /deep/ .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 106.8px;
  display: block;
}

.form-item-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.form-item-hint-inline {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  vertical-align: middle;
}

.class-extension-editor-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.class-extension-editor-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.class-extension-editor-dialog .el-dialog__body {
  padding: 18px 20px 8px;
  max-height: min(72vh, 640px);
  overflow-y: auto;
}

.class-extension-editor-dialog .el-dialog__footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #f1f5f9;
}

.class-extension-editor-form .el-form-item {
  margin-bottom: 14px;
}

.class-extension-editor-form .class-extension-default-item {
  margin-bottom: 6px;
}

.class-extension-uploader .avatar-uploader-icon,
.class-extension-uploader .avatar {
  width: 148px;
  height: 88px;
  line-height: 88px;
}

/* 选择器需压过 dialog-theme 的 .el-dialog:not(.is-fullscreen)。最后修改：2026-09-14 */
.el-dialog.teaching-sync-dialog {
  display: flex;
  flex-direction: column;
  width: 680px !important;
  max-width: calc(100vw - 32px);
  height: min(760px, calc(100vh - 48px));
  height: min(760px, calc(100dvh - 48px));
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  margin-top: calc((100vh - min(760px, calc(100vh - 48px))) / 2) !important;
  margin-top: calc((100dvh - min(760px, calc(100dvh - 48px))) / 2) !important;
  margin-bottom: 0 !important;
  border-radius: 14px;
  overflow: hidden;
}

.el-dialog.teaching-sync-dialog .el-dialog__header {
  flex-shrink: 0;
  padding: 18px 22px 15px;
  border-bottom: 1px solid #e8edf3;
  background: #fbfcfe;
}

.el-dialog.teaching-sync-dialog .el-dialog__title {
  color: #172033;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: .01em;
}

.el-dialog.teaching-sync-dialog .el-dialog__headerbtn {
  top: 20px;
  right: 22px;
}

.el-dialog.teaching-sync-dialog .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  padding: 16px 22px 10px;
  overflow: hidden;
}

.el-dialog.teaching-sync-dialog .el-dialog__footer {
  flex-shrink: 0;
  padding: 14px 22px 18px;
  border-top: 1px solid #eef2f6;
  background: #fbfcfe;
}

.teaching-sync-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.teaching-sync-tab-pane {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.teaching-sync-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.teaching-sync-tabs button {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 11px 13px;
  border: 1px solid #dfe5ec;
  border-radius: 9px;
  color: #64748b;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: border-color .2s ease, background-color .2s ease, color .2s ease;
}

.teaching-sync-tabs button:hover {
  border-color: #a9c3ef;
  color: var(--btn-primary, #2563eb);
}

.teaching-sync-tabs button.is-active {
  border-color: var(--btn-primary, #2563eb);
  color: var(--btn-primary, #2563eb);
  background: #f3f7ff;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, .05);
}

.teaching-sync-tabs button > i {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: #f1f5f9;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
}

.teaching-sync-tabs button.is-active > i {
  background: #e4edff;
}

.teaching-sync-tabs button span,
.teaching-sync-tabs button strong,
.teaching-sync-tabs button small {
  display: block;
}

.teaching-sync-tabs button span {
  min-width: 0;
}

.teaching-sync-tabs button strong {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

.teaching-sync-tabs button.is-active strong {
  color: #1d4ed8;
}

.teaching-sync-tabs button small {
  margin-top: 2px;
  overflow: hidden;
  color: #94a3b8;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teaching-sync-target {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;
  gap: 9px;
  min-height: 44px;
  height: 44px;
  margin-bottom: 12px;
  padding: 0 12px;
  border-radius: 8px;
  color: #64748b;
  background: #f8fafc;
  font-size: 12px;
}

.teaching-sync-target > span i {
  margin-right: 4px;
  color: #94a3b8;
}

.teaching-sync-target > strong {
  min-width: 0;
  overflow: hidden;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teaching-sync-target .el-tag {
  margin-left: auto;
  flex-shrink: 0;
}

.teaching-sync-resource-bar {
  flex-wrap: nowrap;
  gap: 8px 12px;
}

.teaching-sync-resource-bar > span {
  flex-shrink: 0;
  white-space: nowrap;
}

.teaching-sync-resource-bar .teaching-sync-options--inline {
  display: flex !important;
  width: auto;
  margin-left: auto;
  gap: 8px;
  flex-shrink: 0;
}

.teaching-sync-resource-bar .teaching-sync-options--inline .el-radio-button {
  flex: 0 0 auto;
  margin-left: 0 !important;
}

.teaching-sync-resource-bar .teaching-sync-options--inline .el-radio-button .el-radio-button__inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  gap: 4px;
  width: auto;
  height: 28px;
  min-height: 28px;
  padding: 0 14px;
  margin-left: 0 !important;
  border: 1px solid #dfe5ec !important;
  border-left: 1px solid #dfe5ec !important;
  border-radius: 7px !important;
  box-shadow: none !important;
  color: #64748b;
  font-size: 12px;
  line-height: 1;
  transition: color .2s ease, border-color .2s ease, background-color .2s ease;
}

.teaching-sync-resource-bar .teaching-sync-options--inline .el-radio-button:not(:first-child) .el-radio-button__inner {
  border-left: 1px solid #dfe5ec !important;
}

.teaching-sync-resource-bar .teaching-sync-options--inline .el-radio-button__inner:hover {
  border-color: #9dbcf4 !important;
  border-left-color: #9dbcf4 !important;
  color: var(--btn-primary, #2563eb);
}

.teaching-sync-resource-bar .teaching-sync-options--inline .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border: 1px solid var(--btn-primary, #2563eb) !important;
  border-left: 1px solid var(--btn-primary, #2563eb) !important;
  color: var(--btn-primary, #2563eb);
  background: #f3f7ff;
  box-shadow: none !important;
}

.teaching-sync-scope-tree {
  overflow: hidden;
  flex: 1;
  min-height: 0;
  border: 1px solid #dfe5ec;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.teaching-sync-scope-tree > header {
  padding: 10px 13px;
  border-bottom: 1px solid #edf1f5;
  background: #fbfcfe;
}

.teaching-sync-scope-tree > header strong,
.teaching-sync-scope-tree > header span {
  display: block;
}

.teaching-sync-scope-tree > header strong {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.teaching-sync-scope-tree > header span {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
}

.teaching-sync-scope-tree__body {
  flex: 1;
  min-height: 0;
  padding: 7px 5px;
  overflow-y: auto;
}

.teaching-sync-tree {
  overflow: hidden;
  flex: 1;
  min-height: 0;
  border: 1px solid #dfe5ec;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.teaching-sync-tree > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 13px;
  border-bottom: 1px solid #edf1f5;
  background: #fbfcfe;
}

.teaching-sync-tree > header strong,
.teaching-sync-tree > header span {
  display: block;
}

.teaching-sync-tree > header strong {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.teaching-sync-tree > header span {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
}

.ding-tree-cache-hint {
  display: block;
  margin-top: 4px;
  color: #64748b !important;
  font-size: 11px !important;
}

.ding-tree-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.teaching-sync-tree__body {
  position: relative;
  flex: 1;
  min-height: 0;
  padding: 7px 5px;
  overflow-y: auto;
}

.teaching-sync-tree .el-tree-node__content {
  height: 34px;
  border-radius: 6px;
}

.teaching-sync-tree .el-tree-node__content:hover {
  background: #f3f7fd;
}

.teaching-sync-tree__empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 12px;
}

.teaching-sync-tree__empty i {
  font-size: 26px;
  color: #cbd5e1;
}

.teaching-sync-notice {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  gap: 8px;
  min-height: 56px;
  margin-top: 12px;
  padding: 9px 11px;
  border-left: 3px solid #7aa7ef;
  border-radius: 0 7px 7px 0;
  color: #64748b;
  background: #f4f7fc;
  box-sizing: border-box;
}

.teaching-sync-notice > i {
  margin-top: 2px;
  color: #4f83d7;
}

.teaching-sync-notice p {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}

.teaching-sync-notice__body {
  flex: 1;
  min-width: 0;
}

.teaching-sync-notice__sub {
  margin-top: 6px !important;
  padding-top: 6px;
  border-top: 1px dashed #d7e3f4;
  color: #92600a;
}

.teaching-sync-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 15px 16px;
  border: 1px solid #dce8f8;
  border-radius: 10px;
  background: #f5f9ff;
}

.teaching-sync-hero__icon {
  display: inline-flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  color: var(--btn-primary, #2563eb);
  background: #e5efff;
  font-size: 21px;
}

.teaching-sync-hero__content {
  min-width: 0;
}

.teaching-sync-hero__eyebrow {
  display: block;
  margin-bottom: 3px;
  color: var(--btn-primary, #2563eb);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.teaching-sync-hero__content strong {
  display: block;
  color: #1e293b;
  font-size: 15px;
  font-weight: 600;
}

.teaching-sync-hero__content p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.teaching-sync-scope {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 14px 2px 18px;
  color: #64748b;
  font-size: 13px;
}

.teaching-sync-scope span i {
  margin-right: 5px;
  color: #94a3b8;
}

.teaching-sync-scope strong {
  overflow: hidden;
  color: #334155;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teaching-sync-resource__head {
  display: flex;
  flex-shrink: 0;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 10px;
}

.teaching-sync-resource__head strong,
.teaching-sync-resource__head span {
  display: block;
}

.teaching-sync-resource__head strong {
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
}

.teaching-sync-resource__head span {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 12px;
}

.teaching-sync-options {
  display: flex !important;
  width: 100%;
  gap: 8px;
}

.teaching-sync-options--people .el-radio-button {
  flex: 1 1 33.33%;
}

.teaching-sync-options .el-radio-button {
  flex: 1 1 25%;
  width: auto;
  min-width: 0;
}

.teaching-sync-options:not(.teaching-sync-options--inline) .el-radio-button__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 42px;
  padding: 0 10px;
  border: 1px solid #dfe5ec !important;
  border-radius: 8px !important;
  color: #475569;
  background: #fff;
  box-shadow: none !important;
  font-weight: 500;
  transition: border-color .2s ease, color .2s ease, background-color .2s ease;
}

.teaching-sync-options:not(.teaching-sync-options--inline) .el-radio-button__inner:hover {
  border-color: #9dbcf4 !important;
  color: var(--btn-primary, #2563eb);
}

.teaching-sync-options:not(.teaching-sync-options--inline) .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border-color: var(--btn-primary, #2563eb) !important;
  color: var(--btn-primary, #2563eb);
  background: #eff5ff;
}

.teaching-sync-options .el-radio-button__inner i {
  font-size: 16px;
}

.teaching-sync-flow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #475569;
  background: #f8fafc;
  font-size: 12px;
}

.teaching-sync-flow > span {
  padding: 3px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #fff;
  font-weight: 500;
}

.teaching-sync-flow > i {
  color: #94a3b8;
}

.teaching-sync-flow small {
  margin-left: auto;
  color: #94a3b8;
}

.teaching-sync-footer {
  display: flex;
  align-items: center;
  gap: 10px;
}

.teaching-sync-footer__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 已有 flex gap，避免与 dialog-theme 的相邻 margin 叠成双倍间距 */
.el-dialog.teaching-sync-dialog .teaching-sync-footer__actions .el-button + .el-button {
  margin-left: 0 !important;
}

.teaching-sync-footer__hint {
  margin-right: auto;
  color: #94a3b8;
  font-size: 12px;
}

.teaching-sync-footer__hint i {
  margin-right: 4px;
}

@media (max-width: 768px) {
  .el-dialog.teaching-sync-dialog {
    width: calc(100vw - 16px) !important;
    height: calc(100vh - 16px);
    height: calc(100dvh - 16px);
    max-height: none;
    margin: 8px auto !important;
    border-radius: 12px;
  }

  .el-dialog.teaching-sync-dialog .el-dialog__header {
    padding: 14px 16px 12px;
  }

  .el-dialog.teaching-sync-dialog .el-dialog__body {
    padding: 12px 14px 8px;
  }

  .el-dialog.teaching-sync-dialog .el-dialog__footer {
    padding: 10px 14px 14px;
  }

  .teaching-sync-tabs {
    margin-bottom: 12px;
  }

  .teaching-sync-tree__body,
  .teaching-sync-scope-tree__body {
    height: auto;
    flex: 1;
    min-height: 0;
  }

  .teaching-sync-notice {
    margin-top: 8px;
    padding: 8px 10px;
    font-size: 11px;
  }
}

@media (max-width: 640px) {
  .teaching-sync-tabs {
    grid-template-columns: minmax(0, 1fr);
  }

  .teaching-sync-options {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .teaching-sync-footer__hint {
    display: none;
  }

  .teaching-sync-footer__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (prefers-reduced-motion: reduce) {
  .teaching-sync-tabs button,
  .teaching-sync-options .el-radio-button__inner {
    transition: none;
  }
}
</style>
